import { IApiFileMap } from "../Components/ComponentApiTypes";

export const apiFileMap: IApiFileMap = {
    "azure-devops-ui/Components/Autocomplete/Autocomplete.Props.d.ts": [
        {
            "description": "",
            "name": "IAutocompleteProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria hint to describe the element",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional css class to be emitted to the editable input element child of the Autocomplete",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " vss-palette\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom colors to use",
                    "name": "customColors",
                    "optional": true,
                    "type": "IColor[]"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Display the color picker or the \"New Label\" row?",
                    "name": "disableColorPicker",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event to handle checking if the value is in the parent group",
                    "name": "onCheckForDuplicateInParent",
                    "optional": true,
                    "type": "(currentInput: string) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional: Text to be shown if the value is in the parent group",
                    "name": "onDuplicateInParentText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event to handle onFocus",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLInputElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event to handle changes to the input value",
                    "name": "onInputValueChange",
                    "optional": true,
                    "type": "(newValue: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event to handle keyDown events within the editable input child of the Autocomplete",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLInputElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event to handle submission of the Autocomplete",
                    "name": "onSubmit",
                    "optional": true,
                    "type": "(labelModel: ILabelModel) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional placeholder text",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Suggestion provider that the Autocomplete will use to generate suggestions",
                    "name": "suggestionProvider",
                    "optional": false,
                    "type": "(content: string) => PromiseLike<ILabelModel[]>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional observable to allow components to be notified of changes to values",
                    "name": "value",
                    "optional": true,
                    "type": "string | IReadonlyObservableValue<string>"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Autocomplete/Suggestions.Props.d.ts": [
        {
            "description": "",
            "name": "ISuggestionsProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Observable for the current selected color",
                    "name": "currentSelectedColorIndex",
                    "optional": false,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The currently selected index",
                    "name": "currentSelectedIndex",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Display the color picker or the \"New Label\" row?",
                    "name": "disableColorPicker",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Is the current search text already in the parent group?",
                    "name": "isCurrentInputAlreadyInGroup",
                    "optional": false,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Are we currently loading items?",
                    "name": "isLoading",
                    "optional": false,
                    "type": "boolean"
                },
                {
                    "defaultValue": " \"This label is already included\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional: Text to be displayed when suggestion is already in group",
                    "name": "inputAlreadyInGroupText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional handler that will be called when the component updates\r\nUsed to check for duplicates in the parent\r\nLeave undefined if you want to be able to add duplicates",
                    "name": "onCheckForExactMatch",
                    "optional": true,
                    "type": "(suggestions: ILabelModel[]) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event handler for when a color pip is clicked, enhanced with relevant data",
                    "name": "onColorPipClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, color: IColor, index: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event handler for when the New Label row is clicked; only used in colorless mode\r\nColor picker will display when New Label row is hovered by default, so this isn't necessary unless it's disabled",
                    "name": "onNewLabelClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional event handler for when a suggestion in the list is clicked",
                    "name": "onSuggestionClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, labelModel: ILabelModel) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Currently suggested Labels",
                    "name": "suggestedItems",
                    "optional": false,
                    "type": "ILabelModel[]"
                },
                {
                    "defaultValue": " []\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Color picker colors",
                    "name": "swatchPickerColors",
                    "optional": true,
                    "type": "IColor[]"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Breadcrumb/Breadcrumb.Props.d.ts": [
        {
            "description": "",
            "name": "IBreadcrumbProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label to be used for the entire breadcrumb",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name to apply to the root element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to prevent breadcrumb items from being managed by a focus group.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to prevent tab index being set to 0 for breadcrumb items.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom element to render after the breadcrumb.",
                    "name": "extraContent",
                    "optional": true,
                    "type": "JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name to apply to the extra content element",
                    "name": "extraContentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " []\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "items to display",
                    "name": "items",
                    "optional": true,
                    "type": "IBreadcrumbItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role to apply to the breadcrumb container.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IBreadcrumbItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria description for an individual breadcrumb item",
                    "name": "ariaDescription",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label to be used for an individual breadcrumb item",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Url to navigate to when this breadcrumb is clicked.",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional props for an icon to display before the text",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Arbitrary unique string associated with the breadcrumb",
                    "name": "key",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional props for the menu item generated on overflow, to override default props",
                    "name": "menuItemProps",
                    "optional": true,
                    "type": "IMenuItem"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback issued when the breadcrumb is selected.",
                    "name": "onClick",
                    "optional": true,
                    "type": "(ev?: React.MouseEvent<HTMLElement>, item?: IBreadcrumbItem) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If multiple items with the same id are contributed, the one with the highest priority will be shown.",
                    "name": "priority",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the order items should be displayed in (lowest first, undefined and 0 last).",
                    "name": "rank",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display to the user for the breadcrumb",
                    "name": "text",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to hide this item.  This should only be used with priority to hide default items.",
                    "name": "hidden",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Breakpoint/Breakpoint.Props.d.ts": [
        {
            "description": "",
            "name": "IBreakpointProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set of breakpoint sizes the caller is interested in. As the elements size either\r\nshrinks or grows beyond one of these values the onBreakpoint delegate will be\r\ncalled with the breakpoint index with the smaller but closest value to the current\r\nsize of the element.\r\n\r\nThese numbers should be sorted from smallest to largest.",
                    "name": "breakpoints",
                    "optional": false,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Delegate that is called when the breakpoint changes.",
                    "name": "onBreakpoint",
                    "optional": false,
                    "type": "(breakpointIndex: number, breakpoint: number) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Button/Button.Props.d.ts": [
        {
            "description": "",
            "name": "IButton",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets focus to the Button.",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IButtonProps",
            "properties": [
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the button is focused when mounted.",
                    "name": "autoFocus",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-checked to the button element.",
                    "name": "ariaChecked",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-controls to the button element.\r\n\r\nNOTE: Give the base Id in this case, NOT the getSafeId.",
                    "name": "ariaControls",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-describedby to the button element.\r\n\r\nNOTE: Give the base Id in this case, NOT the getSafeId.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-disabled to the button element.",
                    "name": "ariaDisabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-expanded to the button element.",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-haspopup to the button element.",
                    "name": "ariaHasPopup",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-disabled to the button element.",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-label to the button element.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-labelledby to the button element.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-posinset to the button element.",
                    "name": "ariaPosInSet",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-roledescription to the button element.",
                    "name": "ariaRoleDescription",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-pressed to the button element.",
                    "name": "ariaPressed",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-selected to the button element.",
                    "name": "ariaSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-setsize to the button element.",
                    "name": "ariaSetSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the button element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if this button should be styled with a danger color.",
                    "name": "danger",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional data attribute to add to the button element.",
                    "name": "dataIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the button cannot be interacted with.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the button's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the button's to be tabbable.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set the buttons focus zone to be different than the closest parent focus zone.",
                    "name": "focusZoneId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Href to navigate to when the button is clicked.  Pass in if this is a link button.",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Object specifying which icon to display within the button.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A unique identifier for the button",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle blur events",
                    "name": "onBlur",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle button clicks.",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle button key down.",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle mouse leave events.",
                    "name": "onMouseDown",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle mouse leave events.",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle mouse over events.",
                    "name": "onMouseOver",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle focus events",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if this button should be styled with a primary color.",
                    "name": "primary",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, relationship between current document and the linked document. Only required if href is set.",
                    "name": "rel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " button\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Extra styles that should be added to the element, this supports dynamic\r\nstyles that couldn't be defined statically in CSS.",
                    "name": "style",
                    "optional": true,
                    "type": "React.CSSProperties"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to style this as a subtle button.",
                    "name": "subtle",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the tabindex on the button element.",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional,context in which the linked resource will open.",
                    "name": "target",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " \"button\" if href is not set, otherwise undefined\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, type of button.",
                    "name": "type",
                    "optional": true,
                    "type": "\"submit\" | \"reset\" | \"button\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional text to render inside the button.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the button is hovered.\r\nFor icon only buttons, the tooltip will default to the aria-label.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Button/ExpandableButton.Props.d.ts": [
        {
            "description": "",
            "name": "IExpandableButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Element the dropdown should open relative to, if the dropdown shouldn't\r\nopen relative to the button itself.",
                    "name": "anchorElement",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Offset from the anchor element or point for the dropdown.",
                    "name": "anchorOffset",
                    "optional": true,
                    "type": "IOffset"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the anchor element the dropdown should be relative to.",
                    "name": "anchorOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "anchorPoint can be supplied if the dropdown should open at a fixed\r\npoint instead of relative to the button.",
                    "name": "anchorPoint",
                    "optional": true,
                    "type": "IPoint"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the button element",
                    "name": "buttonClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref to pass to the container element.",
                    "name": "containerRef",
                    "optional": true,
                    "type": "React.RefObject<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional Id that should be used on the dropdown to uniquely identify\r\nthis element.",
                    "name": "dropdownId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the dropdown to make relative to the button location.",
                    "name": "dropdownOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If hideDropdownIcon is supplied the button acts as a dropdown button\r\nwithout showing the dropdown arrows.",
                    "name": "hideDropdownIcon",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method used to create the callout.",
                    "name": "renderCallout",
                    "optional": false,
                    "type": "RenderCalloutFunction"
                }
            ],
            "externalTypes": [
                {
                    "name": "IExpandableSharedProps"
                },
                {
                    "name": "IButtonProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/ButtonGroup/ButtonGroup.Props.d.ts": [
        {
            "description": "",
            "name": "IButtonGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the button group.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role to apply to the div containing the group, e.g. \"menubar\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Callout/Callout.Props.d.ts": [
        {
            "description": "",
            "name": "ContentJustification",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "Start",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Center",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "End",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "",
                    "name": "Stretch",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ContentLocation",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "Start",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Center",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "End",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ContentOrientation",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "Column",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Row",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ContentSize",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "Small",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Medium",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "Large",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "",
                    "name": "Auto",
                    "type": "number"
                },
                {
                    "defaultValue": "4",
                    "description": "",
                    "name": "ExtraLarge",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ICallout",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "updateLayout can be called to force the callout to recompute its position\r\nand location if it is using a relative layout. This means that contentLocation\r\nwas not specified, and instead an element or point was used to position it.",
                    "name": "updateLayout",
                    "optional": false,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICalloutProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the callout is being positioned relative to an existing element in the DOM\r\nthe relative element should be supplied as the anchorElement.\r\n(anchorOrigin should be supplied with anchorElement)",
                    "name": "anchorElement",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "anchorOffset is used to shift the location of the callout from the defined\r\nlocation by a fixed amount. An example might be the tooltip callout defaults\r\nto an anchorOffset of { x: 8 y: 8 } from the mouse position.",
                    "name": "anchorOffset",
                    "optional": true,
                    "type": "IOffset"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When an anchorElement is supplied the anchorOrigin is used to describe the\r\nrelative location of the callout with respect to the anchorElement. A common\r\nexample here is a dropdown button aligns the callout to the bottom-right of\r\nthe button.",
                    "name": "anchorOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Instead of using an anchorElement to position the callout, if can be positioned\r\nbased on a fixed location. The anchorPoint defines the fixed position for the\r\nanchor.",
                    "name": "anchorPoint",
                    "optional": true,
                    "type": "IPoint"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which describes this one for screen reader users.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the root element to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.\r\nDefaults to this checkbox's label element.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This will dismiss the callout once it gets and then loses focus. Callouts should\r\ndismiss when they lose focus unless they are intended to be modeless UI.",
                    "name": "blurDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "calloutOrigin works in conjunction with the other position styles;\r\nanchorElement, anchorOffset, anchorOrigin, anchorPoint. After determining the\r\nlocation based on the anchor properties the position of the callout is applied.\r\n\r\nExample: Again the DropDownButton uses anchorOrigin -> Bottom, right with no offset.\r\nThis means the anchorPoint will be the bottom right of the button. The calloutOrigin\r\nis defined as top, right. This will position the top, right corner of the callout\r\non the bottom right of the button.",
                    "name": "calloutOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the callout element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the content element of the callout.",
                    "name": "contentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional ref to be passed to the top level callout element.",
                    "name": "contentRef",
                    "optional": true,
                    "type": "React.RefObject<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Justification of the callout content within the callout. This defaults to auto\r\nlayout and will take on the content size. This ONLY applies to window relative\r\nlayouts, use contentLocation to use this.",
                    "name": "contentJustification",
                    "optional": true,
                    "type": "ContentJustification"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This needs to be supplied for a window relative layout. Otherwise the anchorElement\r\nis used as the location basis.",
                    "name": "contentLocation",
                    "optional": true,
                    "type": "ContentLocation"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Orientation of the callout, is this a column or a row. This ONLY applies to window relative\r\nlayouts, use contentLocation to use this.",
                    "name": "contentOrientation",
                    "optional": true,
                    "type": "ContentOrientation"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the callout have the standard callout shadow.",
                    "name": "contentShadow",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If supplied there are a set of well-known fixed size callout's designed to keep\r\nthings like panels and other types of information using a consistent layout.\r\nThis ONLY applies to window relative layouts, use contentLocation to use this.\r\nThis should be supplied when you are following a standard UI model size.",
                    "name": "contentSize",
                    "optional": true,
                    "type": "ContentSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The callout will handle keyboard events and when the escape key is pressed the\r\ncallout will close if the the event hasnt had the defaultPrevented.",
                    "name": "escDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "fixedLayout is used to determine whether or not the callout should be moved\r\nbased on visibility. if fixedLayout is set to true the callout wont be moved.",
                    "name": "fixedLayout",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the elements in the callout\r\ncontent are rendered.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional height to use for a custom size.",
                    "name": "height",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the id supplied, this id will be added to the callout element as the DOM\r\nid attribute.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The callout element will trap mouse events and dismiss the callout when a click\r\noccurs. This will prevent the events from being handled by the underlying\r\nelements outside the callout's contents.",
                    "name": "lightDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The callout element will be given a class that is a semi-transparency that helps\r\nthe user understand the user should focus on the callout and dismiss it before\r\ninteracting with the underlying document.",
                    "name": "modal",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when an animation on the Callout element ends.\r\nUseful when the callout hide/show is animated and the caller wants to know when it completes.",
                    "name": "onAnimationEnd",
                    "optional": true,
                    "type": "(event: React.AnimationEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method that is called when the callout is dismissed.",
                    "name": "onDismiss",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the mouse enters the callout.",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the mouse leaves the callout.",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when a key is pressed down.",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The portalProps allow the caller to control how the Callout's portal are\r\nconfigured. The default will create the portal as a full screen element\r\nrooted in the body.",
                    "name": "portalProps",
                    "optional": true,
                    "type": "IPortalProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role is used to define the assistive usage of this callout. The default is\r\n\"dialog\", but can be overriden with this property.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If updateLayout is set to true, the component is re-laid out each time new props\r\nare passed in. If not the callout's layout is not updated.",
                    "name": "updateLayout",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This will dismiss the callout if viewport changes such as a scroll or a resize",
                    "name": "viewportChangeDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional width to use for a custom size.",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Card/Card.Props.d.ts": [
        {
            "description": "",
            "name": "ICardProps",
            "properties": [
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to be able to collapse the Card's contents with a button.",
                    "name": "collapsible",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to collapse the card, hiding the contents.",
                    "name": "collapsed",
                    "optional": true,
                    "type": "boolean | ObservableValue<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to forward to the content of the Card",
                    "name": "contentProps",
                    "optional": true,
                    "type": "ICardContentProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Card header can be defined with a set of breakpoints. These breakpoints will be used to control\r\nthe visibility of the Command Bar items as the space available to Card header changes.",
                    "name": "headerBreakpoints",
                    "optional": true,
                    "type": "IHeaderBreakpoint[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the card's header. If there is\r\na table after the header, then \"no-v-padding\" should be passed here\r\nin order to remove the bottom padding that the header renders by default.",
                    "name": "headerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional commands to render in the Card's header",
                    "name": "headerCommandBarItems",
                    "optional": true,
                    "type": "IObservableArray<IHeaderCommandBarItem> | IHeaderCommandBarItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to forward to the description of the Card's Header",
                    "name": "headerDescriptionProps",
                    "optional": true,
                    "type": "ICardHeaderDescriptionProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Icon props to forward to the Card's Header",
                    "name": "headerIconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the collapse button is clicked.",
                    "name": "onCollapseClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional function to render a custom header.",
                    "name": "renderHeader",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to forward to the title of the Card's Header",
                    "name": "titleProps",
                    "optional": true,
                    "type": "ICardTitleProps"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICustomCardProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ICardContentProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the card content",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates the consumer does not want any horizontal padding.",
                    "name": "contentPadding",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICardFooterProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the card footer",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICardHeaderDescriptionProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the card header's description",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional description to display for the card",
                    "name": "text",
                    "optional": true,
                    "type": "React.ReactNode"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICardTitleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional aria level to the title",
                    "name": "ariaLevel",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the title",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id to pass to the card title",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional size to render the card's title",
                    "name": "size",
                    "optional": true,
                    "type": "TitleSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional title to display for the card",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICustomCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the card container element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Checkbox/Checkbox.Props.d.ts": [
        {
            "description": "",
            "name": "ITriStateCheckboxProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which describes this one for screen reader users.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.\r\nDefaults to this checkbox's label element.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria Label for the Checkbox for screen reader users.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The checked state of the checkbox.",
                    "name": "checked",
                    "optional": false,
                    "type": "IReadonlyObservableValue<boolean | undefined> | boolean | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the checkbox element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the checkbox cannot be interacted with.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the checkbox's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to omit setting the tab index to 0.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Additional focuszoneId the checkbox should be included in.",
                    "name": "focuszoneId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An id to pass to the checkbox element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional label to render next to the checkbox.",
                    "name": "label",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An id to pass to the label element.",
                    "name": "labelId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional callback to handle checked state change events.",
                    "name": "onChange",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, checked: boolean | undefined) => void"
                },
                {
                    "defaultValue": " checkbox\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The aria role to put on the checkbox element.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the tabindex on the button element.",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the checkbox is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A triState checkbox means the checkbox can be in one of three states:\r\n1) Unchecked - checked = false\r\n2) Checked - checked = true\r\n3) Indeterminate - checked = undefined\r\n\r\nIf undefined is passed as the value a checkbox it will show in the\r\nindeterminate state, but when changed it will switch back and forth between\r\nunchecked and checked. If triState is set to true, the rotation will go\r\nthrough the states in the order above.",
                    "name": "triState",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICheckboxProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The checked state of the checkbox.",
                    "name": "checked",
                    "optional": false,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional callback to handle checked state change events.",
                    "name": "onChange",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, checked: boolean) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITriStateCheckboxProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/ClipboardButton/ClipboardButton.Props.d.ts": [
        {
            "description": "",
            "name": "IClipboardButtonProps",
            "properties": [
                {
                    "defaultValue": " \"Copy to clipboard\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label to pass to button",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS class name to add to Clipboard Button",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback provided when the button looses the focus.",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback provided after a copy is finished.",
                    "name": "onCopy",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback provided when the button gets the focus.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(e: React.FocusEvent) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function to retreive the text that will be copied to the clipboard.\r\nThis function can return either a plain text string, a new JSX.Element\r\nwith the HTML to copy, or an  HTMLexisting DOM Element.",
                    "name": "getContent",
                    "optional": false,
                    "type": "() => string | JSX.Element | HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set to true, the tooltip will be changed to \"Copied to Clipboard\" when\r\nthe button is clicked.\r\nIf a string is provided the tooltip will be changed to the string instead.",
                    "name": "showCopiedTooltip",
                    "optional": true,
                    "type": "boolean | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to style this as a subtle button.",
                    "name": "subtle",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the button is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle mouse leave events.",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Coin/Coin.Props.d.ts": [
        {
            "description": "",
            "name": "CoinSize",
            "properties": [
                {
                    "defaultValue": "16",
                    "description": "",
                    "name": "size16",
                    "type": "number"
                },
                {
                    "defaultValue": "20",
                    "description": "",
                    "name": "size20",
                    "type": "number"
                },
                {
                    "defaultValue": "24",
                    "description": "",
                    "name": "size24",
                    "type": "number"
                },
                {
                    "defaultValue": "32",
                    "description": "",
                    "name": "size32",
                    "type": "number"
                },
                {
                    "defaultValue": "40",
                    "description": "",
                    "name": "size40",
                    "type": "number"
                },
                {
                    "defaultValue": "72",
                    "description": "",
                    "name": "size72",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ICoinProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional arial-label to specify for the coin.\r\nDefaults to the displayName.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name for the Coin",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Name to display in the tooltip and use for initials for the coin",
                    "name": "displayName",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, provides additional info to display in the tooltip after the 'displayName'",
                    "name": "principalName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, if the coin is focusable.",
                    "name": "dataIsFocusable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, if the coin should be a tab stop",
                    "name": "isTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, if the coin should be rendered as an image. The coin defaults to initials if this is not set.",
                    "name": "imageUrl",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, alt text for the image if an image is provided.",
                    "name": "imgAltText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, role for the image. Use role=\"presentation\" if image is accompanied by separate text with the same information as the alt text.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, size of the coin.",
                    "name": "size",
                    "optional": true,
                    "type": "CoinSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom tooltip props to be used for the tooltip in place of simply the display name. Null indicates that no tooltip should be used.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, callback when the coin is clicked.",
                    "name": "onClick",
                    "optional": true,
                    "type": "(ev?: React.MouseEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ColorPip/ColorPip.Props.d.ts": [
        {
            "description": "",
            "name": "IColorPipProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Color to use to render\r\nOptional because you may want to override in CSS",
                    "name": "color",
                    "optional": true,
                    "type": "IColor"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, emits a \"selected\" class",
                    "name": "isSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onClick for the pip, enhanced with color data",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, color: IColor) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ColorSwatchPicker/ColorSwatchPicker.Props.d.ts": [
        {
            "description": "",
            "name": "IColorSwatchPickerProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Colors to render into the swatch picker as pips",
                    "name": "colors",
                    "optional": false,
                    "type": "IColor[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Currently selected pip",
                    "name": "selectedIndex",
                    "optional": true,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional custom class name to emit",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Enhanced onClick handler for an arbitrary pip\r\nPasses back relevant data",
                    "name": "onPipClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, color: IColor, index: number) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ConditionalChildren/ConditionalChildren.Props.d.ts": [
        {
            "description": "",
            "name": "IConditionalChildrenProps",
            "properties": [
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether to apply a not operator to the result of the renderChildren value",
                    "name": "inverse",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to show the children of this component.\r\nIf Observable, will subscribe and re-render on change notifications.",
                    "name": "renderChildren",
                    "optional": false,
                    "type": "IObservableLikeValue<boolean | undefined>"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/DetailsPanel/DetailsPanel.Props.d.ts": [
        {
            "description": "",
            "name": "IDetailsPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to emit onto the root DetailPanel element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Dialog/Dialog.Props.d.ts": [
        {
            "description": "",
            "name": "ICustomDialogProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that should be applied to the top level callout element.",
                    "name": "calloutClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that should be applied to the callout's content element.",
                    "name": "calloutContentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the root dialog element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Element selector of the first focusable element. If no selector is supplied, a hidden\r\nelement will be created and focus given to the CommandBarFlyout through this element.",
                    "name": "defaultActiveElement",
                    "optional": true,
                    "type": "string | (() => string)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria-label for the default focusable element if defaultActiveElement isn't provided.",
                    "name": "defaultFocusableElementAriaLabel",
                    "optional": true,
                    "type": "string\r\n\r\n    /**\r\n     * Method that is called when the dialog is dismissed.\r\n     */\r\n    onDismiss: () => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set, the content of the dialog will be overlaid with a transparent div with a spinner.",
                    "name": "overlay",
                    "optional": true,
                    "type": "{\r\n        spinnerLabel?: string;\r\n        spinnerAriaLabel?: string;\r\n    }"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the dialog will have a gripper in the corner that can be used to resize.",
                    "name": "resizable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The dialog will handle keyboard events and when the enter key is pressed the\r\ndialog will behave as if the primary key was pressed if the event \r\nhasnt had the defaultPrevented.",
                    "name": "enterPrimary",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Primary button props.",
                    "name": "primaryButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, while tabbing through dialog elements if ends up on input element than text \r\nwill be selected automatically. This is a default input behavior.",
                    "name": "selectInputTextOnFocus",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICalloutProps",
                    "properties": [
                        "ariaDescribedBy",
                        "ariaLabel",
                        "ariaLabelledBy",
                        "blurDismiss",
                        "contentJustification",
                        "contentLocation",
                        "contentSize",
                        "escDismiss",
                        "id",
                        "lightDismiss",
                        "modal",
                        "role"
                    ]
                }
            ]
        },
        {
            "description": "",
            "name": "IDialogProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional list of props to render as buttons in the footer.",
                    "name": "footerButtonProps",
                    "optional": true,
                    "type": "IButtonProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Properties to configure how the dialog title looks.",
                    "name": "titleProps",
                    "optional": false,
                    "type": "IPanelTitleProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Shows a close button in the top right corner of the dialog. Using a cancel button in\r\nthe footer or lightDismiss are preferred over this.",
                    "name": "showCloseButton",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICustomDialogProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Dropdown/Dropdown.Props.d.ts": [
        {
            "description": "",
            "name": "IDropdownProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to keep the callout open when an item is selected.\r\nBy default the callout will close on select unless multiselect or selectOnFocus is enabled on selection.",
                    "name": "dismissOnSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": ": true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to not do any text filtering when the user types in the filter box.  Do this if you want\r\nto control filtering through userFilteredItems.",
                    "name": "filterByText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional method to perform a custom filter of items based on filter text.\r\nIf not provided, it will filter items based on item.text.",
                    "name": "filterItem",
                    "optional": true,
                    "type": "(filterText: string, item: IListBoxItem<T>, items: IListBoxItem<T>[]) => boolean | number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The throttle wait time to use when updating the filter. The text field\r\nwill still update on every keystroke, but the updating the filter\r\nitself will be throttled by this amount. The default value is 0 ms.\r\nPassing a value of 0 here will cause this text field not to be throttled.",
                    "name": "filterThrottleWait",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is called when updates are made to the listBox items to update the unselectbale items in the selection.",
                    "name": "getUnselectableRanges",
                    "optional": true,
                    "type": "(items: IListBoxItem<T>[]) => ISelectionRange[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function which returns the callout for this dropdpown.",
                    "name": "renderCallout",
                    "optional": true,
                    "type": "(props: IDropdownCalloutProps) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function which returns the Expandable for this dropdown.",
                    "name": "renderExpandable",
                    "optional": true,
                    "type": "(props: IDropdownExpandableProps) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renderer for selected items in the expandable.  Defaults to rendering the selected item's text.",
                    "name": "renderSelectedItems",
                    "optional": true,
                    "type": "(selection: IListSelection, items: IListBoxItem<T>[]) => JSX.Element | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to display a column with checks or checkboxes for selected items.",
                    "name": "showChecksColumn",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies whether items should be sorted by startsWith matching when filtering.",
                    "name": "startsWithSort",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Supply for a custom width for the callout.  By default, the callout's width will be the same as the\r\nexpandable.  To change the expandable width, set a className.",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide a minimum width for the callout",
                    "name": "minCalloutWidth",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListBoxSharedProps<T>"
                },
                {
                    "name": "IDropdownCalloutProps<T>",
                    "properties": [
                        "actions",
                        "calloutContentClassName",
                        "filteredNoResultsText",
                        "filterPlaceholderText",
                        "noItemsText",
                        "showFilterBox",
                        "userFilteredItems",
                        "userFilteredItemsIndexMap",
                        "renderBeforeContent",
                        "showTree",
                        "portalProps",
                        "onFilterTextChanged"
                    ]
                },
                {
                    "name": "IDropdownExpandableProps<T>",
                    "properties": [
                        "ariaLabel",
                        "ariaLabelledBy",
                        "ariaDescribedBy",
                        "className",
                        "disabled",
                        "excludeTabStop",
                        "inputId",
                        "onCollapse",
                        "onExpand",
                        "placeholder",
                        "required"
                    ]
                },
                {
                    "name": "IDropdownExpandableTextFieldProps",
                    "properties": [
                        "autoSelect",
                        "showPrefix",
                        "disableAutocomplete"
                    ]
                }
            ]
        },
        {
            "description": "",
            "name": "IFilterResults<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The array of items matching the filter",
                    "name": "filteredItems",
                    "optional": false,
                    "type": "IListBoxItem<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An arrary mapping each filteredItem to its index in the original items array",
                    "name": "filteredIndexMap",
                    "optional": false,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An array of indices of matches within each given item (used to bold the matching text)",
                    "name": "filterMatches",
                    "optional": false,
                    "type": "number[][]"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Dropdown/DropdownCallout.Props.d.ts": [
        {
            "description": "",
            "name": "IDropdownCalloutProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Actions to render in the footer of the dropdown.",
                    "name": "actions",
                    "optional": true,
                    "type": "IReadonlyObservableArray<IButtonProps> | IButtonProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ClassName to pass to the callout content.  Use this to override the width.",
                    "name": "calloutContentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the dropdown to make relative to the expandable location.",
                    "name": "dropdownOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to exclude all listBox rows from the focusZone",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to remove the tabIndex from the callout content container.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The final filtered set of items from the dropdown.",
                    "name": "filteredItems",
                    "optional": true,
                    "type": "IObservableArray<IListBoxItem<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display when there are no filter results.  Will be formatted with the current filter string.",
                    "name": "filteredNoResultsText",
                    "optional": true,
                    "type": "string | IObservableValue<string>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display while filtered results are loading.",
                    "name": "filteredResultsLoadingText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show as a placeholder in the filter box.",
                    "name": "filterPlaceholderText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Pass to specify the text of the filter box.",
                    "name": "filterText",
                    "optional": false,
                    "type": "ObservableValue<string>"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to not set focus to the callout contents when they mount.",
                    "name": "focusOnMount",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A unique identifier for this dropdown callout.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to prevent default on mouseDown events inside the callout.\r\nThis keeps the dropdown from closing due to blurDismiss when a mousedown\r\nhappens inside of it.",
                    "name": "ignoreMouseDown",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ClassName to pass to the listbox.",
                    "name": "listBoxClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref to forward to the ListBox component.",
                    "name": "listBoxRef",
                    "optional": true,
                    "type": "React.RefObject<ListBox<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show when there are no items in the listbox.",
                    "name": "noItemsText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when a listbox row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event - This is the event that is causing the activation.\r\n@param tableRow - Details about the table row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional callback to notify when onKeyDown has been pressed within a filter textbox.",
                    "name": "onFilterKeyDown",
                    "optional": true,
                    "type": "(e: React.KeyboardEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to notify when the filter text has changed.  Do custom searching here and update the items.",
                    "name": "onFilterTextChanged",
                    "optional": true,
                    "type": "(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | null, newValue: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom content to render before the listbox in the dropdown.",
                    "name": "renderBeforeContent",
                    "optional": true,
                    "type": "() => JSX.Element | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to display a column with checks or checkboxes for selected items.",
                    "name": "showChecksColumn",
                    "optional": true,
                    "type": "boolean\r\n\r\n    /**\r\n     * Set to true to show a filter box above the listBox, or false to hide.  The filter box will show by default\r\n     * If there are 10 or more items in the dropdown.\r\n     */\r\n    showFilterBox?: boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies whether items should be sorted by startsWith matching when filtering.",
                    "name": "startsWithSort",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Title to show at the top of the dropdown.",
                    "name": "title",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to show a close button in the title area of the dropdown.",
                    "name": "showCloseButton",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The function that should be called to update the filtered items.",
                    "name": "updateFilteredItems",
                    "optional": true,
                    "type": "() => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide if you want to show a custom set of filtered items.  The items will still be filtered by text in the filterbox unless filterByText is false.",
                    "name": "userFilteredItems",
                    "optional": true,
                    "type": "IItemProvider<IListBoxItem<T>> | IListBoxItem<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provides the original item index for each item in userFilteredItems.\r\nOptional, if not provided then this will be computed by traversing items for match indices, which can be slow if there are a lot of items.",
                    "name": "userFilteredItemsIndexMap",
                    "optional": true,
                    "type": "IReadonlyObservableValue<number[]>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListBoxSharedProps<T>"
                },
                {
                    "name": "ICalloutProps",
                    "properties": [
                        "anchorElement",
                        "anchorOffset",
                        "anchorOrigin",
                        "anchorPoint",
                        "blurDismiss",
                        "contentLocation",
                        "lightDismiss",
                        "onDismiss",
                        "portalProps"
                    ]
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Dropdown/DropdownExpandable.Props.d.ts": [
        {
            "description": "",
            "name": "IDropdownExpandableProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-label to the Expandable element.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-labelled-by to the Expandable element.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-describedby to the Expandable element.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Supply autoSelect to select all the text in the input when the textfield gets\r\nfocus. This is useful if you want the user to copy the text, or replace the text\r\nupon typing instead of changing the current value.",
                    "name": "autoSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ClassName to pass to the Expandable.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref to pass to the expandable's container element.",
                    "name": "containerRef",
                    "optional": true,
                    "type": "React.RefObject<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to make the expandable disabled.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element should not be tabable but still should be able to receieve focus.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A ref to forward to the expandable.",
                    "name": "expandableRef",
                    "optional": false,
                    "type": "React.RefObject<ExpandableButton | ExpandableTextField>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id to be applied to the expandable's input  element.",
                    "name": "inputId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The set of items passed to the Dropdown.",
                    "name": "items",
                    "optional": false,
                    "type": "IListBoxItem<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is collapsed.",
                    "name": "onCollapse",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is expanded.",
                    "name": "onExpand",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show within the DropdownExpandable when there is no selected value.",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A function which renders the dropdown's callout.",
                    "name": "renderCallout",
                    "optional": false,
                    "type": "RenderCalloutFunction"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renderer for selected items.",
                    "name": "renderSelectedItems",
                    "optional": false,
                    "type": "(selection: IListSelection, items: IListBoxItem<T>[]) => JSX.Element | string"
                },
                {
                    "defaultValue": " false.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates whether dropdown is required or not.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selection object used by the Dropdown.",
                    "name": "selection",
                    "optional": false,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to show prefix icons. Not use unless expandable is expandabletextfield",
                    "name": "showPrefix",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true, the autocomplete attribute of the input element is set to \"off\".",
                    "name": "disableAutocomplete",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IDropdownExpandableButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "children",
                    "optional": true,
                    "type": "React.ReactNode"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownExpandableProps"
                },
                {
                    "name": "IExpandableButtonProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IDropdownExpandableTextFieldProps",
            "properties": [
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the list item has an icon show the icon as the prefix icon in the text field.",
                    "name": "showPrefix",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownExpandableProps"
                },
                {
                    "name": "IExpandableTextFieldProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Dropdown/DropdownFilterBarItem.Props.d.ts": [
        {
            "description": "",
            "name": "IDropdownFilterBarItemProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Don't show the Clear action.",
                    "name": "hideClearAction",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to include the placeholder as part of the selected label.",
                    "name": "showPlaceholderAsLabel",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Untoggle filter bar on clear filter",
                    "name": "toggleFilterBar",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFilterBarItemProps"
                },
                {
                    "name": "IDropdownProps<T>"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Dropdown/WithPivots.Props.d.ts": [
        {
            "description": "",
            "name": "IDropdownPivot<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique id for this pivot.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The items to show when this pivot is active.",
                    "name": "items",
                    "optional": false,
                    "type": "IItemProvider<IListBoxItem<T>> | IListBoxItem<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show for this pivot.  Defaults to id if not specified.",
                    "name": "name",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownProps<T>",
                    "properties": [
                        "actions",
                        "filterByText",
                        "filteredNoResultsText",
                        "filterPlaceholderText",
                        "items",
                        "noItemsText",
                        "showFilterBox",
                        "userFilteredItems"
                    ]
                }
            ]
        },
        {
            "description": "",
            "name": "IWithPivotsProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to forward to the DropdownCallout.",
                    "name": "calloutProps",
                    "optional": true,
                    "type": "IDropdownWithPivotsCalloutProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The children should be a function that takes IWithPivotsChildProps.",
                    "name": "children",
                    "optional": false,
                    "type": "(props: IWithPivotsChildProps) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to call when a pivot is clicked.",
                    "name": "onPivotClicked",
                    "optional": true,
                    "type": "(pivot: IDropdownPivot<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A list of pivots to show.",
                    "name": "pivots",
                    "optional": false,
                    "type": "IDropdownPivot<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id of the currently selected pivot.",
                    "name": "selectedPivot",
                    "optional": true,
                    "type": "string | ObservableValue<string>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IDropdownWithPivotsCalloutProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Pass to specify the text of the filter box.",
                    "name": "filterText",
                    "optional": true,
                    "type": "ObservableValue<string>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownCalloutProps<T>",
                    "properties": [
                        "anchorElement",
                        "anchorOffset",
                        "anchorOrigin",
                        "anchorPoint",
                        "dropdownOrigin",
                        "ignoreMouseDown",
                        "excludeFocusZone",
                        "excludeTabStop",
                        "focusOnMount",
                        "lightDismiss",
                        "listBoxClassName",
                        "listBoxRef",
                        "onActivate",
                        "onDismiss",
                        "onFilterTextChanged",
                        "title",
                        "showCloseButton"
                    ]
                }
            ]
        },
        {
            "description": "",
            "name": "IWithPivotsChildProps<T = {}>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IDropdownProps<T>",
                    "properties": [
                        "actions",
                        "filterByText",
                        "userFilteredItems",
                        "filteredNoResultsText",
                        "filterPlaceholderText",
                        "noItemsText",
                        "renderCallout",
                        "showFilterBox"
                    ]
                }
            ]
        }
    ],
    "azure-devops-ui/Components/EditableDropdown/EditableDropdown.Props.d.ts": [
        {
            "description": "",
            "name": "IEditableDropdownProps<T = {}>",
            "properties": [
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to disable the ability to fully clear the text box value",
                    "name": "allowClear",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to allow selecting values that aren't in the list of items.",
                    "name": "allowFreeform",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to allow users to highlight currently selected item (selected text will be passed as text box value instead of placeholder)",
                    "name": "allowTextSelection",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true (the default) any entered text (in freeform mode) is accepted\r\non blur or escape. If false, the user must explicitly press the enter key\r\nto accept a freeform value.",
                    "name": "autoAccept",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom function to filter items based on the given filter text\r\n\r\n@param filterText The text to filter the items by",
                    "name": "filterItems",
                    "optional": true,
                    "type": "(filterText: string, items: IListBoxItem<T>[]) => IFilterResults<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom function which determines if a given item should be focused after filtering",
                    "name": "filterMatchedItem",
                    "optional": true,
                    "type": "(item: IListBoxItem<T>) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Items should be supplied as an ObservableArray if they will be changing.",
                    "name": "items",
                    "optional": false,
                    "type": "IReadonlyObservableArray<IListBoxItem<T>> | IListBoxItem<T>[] | string[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the value of the input changes.",
                    "name": "onTextChange",
                    "optional": true,
                    "type": "(\r\n        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | React.SyntheticEvent<HTMLElement> | null,\r\n        value?: string\r\n    ) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when a new value is selected.  Selection happens on click, enter, or tab, or when the dropdown closes if allowFreeform is true.",
                    "name": "onValueChange",
                    "optional": true,
                    "type": "(value?: IListBoxItem<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selected text is shown in the input with a placeholder-like behavior.  It will default to the text of the selected item in items.",
                    "name": "selectedText",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The text value passed to the ExpandableTextField.",
                    "name": "text",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": " false.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates whether dropdown is required or not.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "className to pass to the listbox's container.",
                    "name": "containerClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownProps<T>",
                    "properties": [
                        "actions",
                        "ariaLabel",
                        "ariaLabelledBy",
                        "autoSelect",
                        "calloutContentClassName",
                        "className",
                        "columns",
                        "disableAutocomplete",
                        "disabled",
                        "filterByText",
                        "filterItem",
                        "filterThrottleWait",
                        "getUnselectableRanges",
                        "inputId",
                        "items",
                        "onCollapse",
                        "onExpand",
                        "onToggle",
                        "placeholder",
                        "noItemsText",
                        "renderCallout",
                        "renderExpandable",
                        "renderItem",
                        "selection",
                        "showTree",
                        "minCalloutWidth",
                        "required"
                    ]
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Expandable/Expandable.Props.d.ts": [
        {
            "description": "",
            "name": "IExpandableSharedProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the button cannot be interacted with.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " KeyCode.DownArrow\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The key used to expand the components callout.",
                    "name": "expandKey",
                    "optional": true,
                    "type": "KeyCode | KeyCode[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is collapsed.",
                    "name": "onCollapse",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is expanded.",
                    "name": "onExpand",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IExpandableProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderCallout is called when the component is expanded. This should return\r\nthe elements needed to render the appropriate callout.\r\nIf this prop is not passed, then the consumer is responsible for rendering the callout.\r\nThis is used in cases where the consumer wants to own the callout, so that the same\r\nelement can be used for mouseEnter/mouseLeave as for the expandable props, but have also\r\nhave the callout be a child of a MouseWithin.",
                    "name": "renderCallout",
                    "optional": true,
                    "type": "() => JSX.Element"
                }
            ],
            "externalTypes": [
                {
                    "name": "IExpandableSharedProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IExpandableContainerProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-label that can be added to the container",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class that is added to the div that is produced.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 250\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The collapseDelay is used in conjunction with the expandOnHover to determine\r\nhow long the mouse must be out of the expandable to collapse. This only applies\r\nif the expandable was expanded due to hover. The collapseDelay is defined in\r\nmilliseconds.",
                    "name": "collapseDelay",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the the focus of the div that is produced to be managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the div that is produced to be tabbable - a child will need to be tabbable.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id that is used in the aria-controls attribute. This should line up with\r\nthe id rendered into the expandable when a callout is rendered.",
                    "name": "expandableId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 250\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The expandDelay is used in conjunction with the expandOnHover to determine\r\nhow long the mouse must be over the expandable to expand. The expandDelay is\r\ndefined in milliseconds.",
                    "name": "expandDelay",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If expandOnHover controls whether or not the expandable element is shown\r\nwhen the mouse hovers over the element.",
                    "name": "expandOnHover",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "id that will be placed on the expandable id element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderCallout is called when the component is expanded. This should return\r\nthe elements needed to render the appropriate callout.",
                    "name": "renderCallout",
                    "optional": false,
                    "type": "(expandable: IExpandable, id: string, element: HTMLElement) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the tabindex on the callout element.",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " the value will be determined by the expanded state of the component.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-expanded value. Set to null to remove the attribute.",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean | null"
                },
                {
                    "defaultValue": " true.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-haspopup value. Set to null to remove the attribute.",
                    "name": "ariaHasPopup",
                    "optional": true,
                    "type": "boolean | null"
                },
                {
                    "defaultValue": " the attribute will only be present in expanded state, and the value will be set to the expandableId property.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-controls value. Set to empty string to remove the attribute.",
                    "name": "ariaControls",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IExpandableSharedProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IExpandable",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Collapsing the component will remove any callout's that are rendered when the\r\ncomponent is expanded.",
                    "name": "collapse",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Expanding the component will render any callout's assocaited with the expandable\r\ncomponent.",
                    "name": "expand",
                    "optional": false,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IExpandableChildProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "expanded",
                    "optional": false,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onClick",
                    "optional": false,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onKeyDown",
                    "optional": false,
                    "type": "(event: React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onMouseDown",
                    "optional": false,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ExpandableTextField/ExpandableTextField.Props.d.ts": [
        {
            "description": "",
            "name": "IExpandableTextFieldProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Element the dropdown should open relative to, if the dropdown shouldn't\r\nopen relative to the button itself.",
                    "name": "anchorElement",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Offset from the anchor element or point for the dropdown.",
                    "name": "anchorOffset",
                    "optional": true,
                    "type": "IOffset"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the anchor element the dropdown should be relative to.",
                    "name": "anchorOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "anchorPoint can be supplied if the dropdown should open at a fixed\r\npoint instead of relative to the button.",
                    "name": "anchorPoint",
                    "optional": true,
                    "type": "IPoint"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to dismiss the callout when focus leaves the TextField.",
                    "name": "blurDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref to pass to the container element.",
                    "name": "containerRef",
                    "optional": true,
                    "type": "React.RefObject<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional Id that should be used on the dropdown to uniquely identify\r\nthis element.",
                    "name": "dropdownId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the dropdown to make relative to the button location.",
                    "name": "dropdownOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not textField is editable and should be treated like a combobox.",
                    "name": "editable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If hideDropdownIcon is supplied the button acts as a dropdown button\r\nwithout showing the dropdown arrows.",
                    "name": "hideDropdownIcon",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method used to create the callout.",
                    "name": "renderCallout",
                    "optional": false,
                    "type": "RenderCalloutFunction"
                }
            ],
            "externalTypes": [
                {
                    "name": "IExpandableSharedProps"
                },
                {
                    "name": "ITextFieldProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Filter/Filter.Props.d.ts": [
        {
            "description": "",
            "name": "IFilterProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The currently selected filter.  If omitted, the Filter will keep track of this internally.",
                    "name": "activeFilter",
                    "optional": true,
                    "type": "ObservableValue<IFilterItem<T> | null>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specify an item to be highlighted as a best hit when the user performs a top level search in the filter box.",
                    "name": "bestHitItem",
                    "optional": true,
                    "type": "ObservableValue<IListBoxItem<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Classname to pass to the Filter's Expandable Button.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": ": true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to false to not do any text filtering when the user types in the filter box.  Do this if you want\r\nto control filtering through userFilteredItems.",
                    "name": "filterByText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The store object that holds the filter state.",
                    "name": "filterStore",
                    "optional": false,
                    "type": "IFilter"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Items that correspond to different keys within the filterStore.  Items will render as rows in the inital callout view of the Filter,\r\nand if selected will display their items or custom content to select the value for that filter key.",
                    "name": "filterItems",
                    "optional": false,
                    "type": "IFilterItem<T>[]"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to hide the back button when a filter is active.",
                    "name": "hideBackButton",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller may supply the set of items to be shown through the ItemProvider or array.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the underlying listbox a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.  Use an IItemProvider or something that implements it like ObservableArray\r\nIf the items will be changing.",
                    "name": "items",
                    "optional": false,
                    "type": "IItemProvider<IListBoxItem<T>> | IListBoxItem<T>[] | string[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to notify when the active filter has changed.",
                    "name": "onActiveFilterChanged",
                    "optional": true,
                    "type": "(activeFilter: IFilterItem | null) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to notify when the filter box text has changed.  Do custom searching here and update the filterItem's items.",
                    "name": "onFilterTextChanged",
                    "optional": true,
                    "type": "(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | null, newValue: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object used by the underlying Dropdown to maintain the selection state.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to show a reset button instead of a clear button in the active filter view.",
                    "name": "showActiveFilterResetButton",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the filter button text should change to \"Filter on\" when there is an active filter",
                    "name": "showFilterOnText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The title displayed at the top of the Filter's callout.",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide if you want to show a custom set of filtered items.",
                    "name": "userFilteredItems",
                    "optional": true,
                    "type": "IItemProvider<IListBoxItem<T>> | IListBoxItem<T>[]"
                },
                {
                    "defaultValue": " 320\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The width of the Filter's callout in px.",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFilterItem<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The key in the filterStore that selection within this item corresponds to.",
                    "name": "filterItemKey",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom renderer for content rendered before the Listbox in the Dropdown.\r\n@param onEditingComplete call this function when the user indicates they are done eidting and wish to return to the top level filter view.",
                    "name": "renderBeforeContent",
                    "optional": true,
                    "type": "(onEditingComplete: () => void) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom function for rendering the selected items within a filterItem.  This may be required if the ListBoxItems have a custom render function.\r\nThis should not return table markup, but rather the contents of the table cell each item would normally be rendered in.\r\n@param selectedItems A list of ListBoxItems that are selected within this filterItem's items",
                    "name": "renderSelectedItems",
                    "optional": true,
                    "type": "(selectedItems: IListBoxItem<T>[]) => JSX.Element | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom title to show in the Dropdown when this filterItem is active.",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IDropdownPivot<T>"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/FilterBar/FilterBar.Props.d.ts": [
        {
            "description": "",
            "name": "IFilterBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The filter store that this filter bar updates.  Apply mode handling within the filter bar is being deprecated.\nIf the filter uses apply mode, changes should be applied outside of the filter bar.",
                    "name": "filter",
                    "optional": true,
                    "type": "IFilter"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback that is called when the component is initially mounted. Passed an instance of the component,\nso that methods like focus() can be called.",
                    "name": "onMounted",
                    "optional": true,
                    "type": "(filterBar: IFilterBar) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS class name to add to the filter bar container",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback that is invoked after the filter bar has been rendered.",
                    "name": "onRenderComplete",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to access the IFilterBar interface. Use this instead of ref for accessing\nthe public methods and properties of the component.",
                    "name": "componentRef",
                    "optional": true,
                    "type": "(component: IFilterBar) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to handle clicking on the filter bar dismiss button.",
                    "name": "onDismissClicked",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": " Filter bar",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-label value.",
                    "name": "searchRoleAriaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to hide clear button.",
                    "name": "hideClearAction",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "React.HTMLAttributes<HTMLElement>"
                }
            ]
        },
        {
            "description": "",
            "name": "IFilterBar",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Focuses the first item in the filter bar",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Force the filter bar to re-render.",
                    "name": "forceUpdate",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/FilterBarItem/FilterBarItem.Props.d.ts": [
        {
            "description": "",
            "name": "IFilterBarItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "componentRef",
                    "optional": true,
                    "type": "(component: IFilterBarItem) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The filter store that this filter bar updates (optional, the parent FilterBar's filter is used by default)",
                    "name": "filter",
                    "optional": true,
                    "type": "IFilter"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The unique key for this filter item whose value is updated by changes to this filter item.",
                    "name": "filterItemKey",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show for the filter in the case that there is no current value",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Comparer of filter values to determine when the filter needs to be updated.",
                    "name": "filterValueComparer",
                    "optional": true,
                    "type": "(a: any, b: any) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Key for FilterBarItem. If this is changed, will always update state with new props.",
                    "name": "setKey",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isTextItem",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFilterBarItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Focuses the item",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Re-render the FilterBarItem",
                    "name": "forceUpdate",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/FocusGroup/FocusGroup.Props.d.ts": [
        {
            "description": "",
            "name": "IFocusGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id of the element to be treated as the\r\ndefault focusable element of the group.",
                    "name": "defaultElementId",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusGroupContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id of the element that has received focus.\r\nShould be used by the component that is consuming the context\r\nto determine whether tabIndex=1 or tabIndex=0 should be placed on\r\nthe element.",
                    "name": "focusedElementId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to be invoked when the element has received a DOM\r\nfocus event.",
                    "name": "onFocus",
                    "optional": false,
                    "type": "(elementId: string) => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusGroup",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set focus within the focus group. If no elementId is provided,\r\nfocus will be set to the last focused element of the group. If the group has\r\nnot yet received focus, focus will be set to the default element.",
                    "name": "focus",
                    "optional": false,
                    "type": "(elementId?: string): void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/FocusOrMouseWithin/FocusOrMouseWithin.Props.d.ts": [
        {
            "description": "",
            "name": "IFocusOrMouseWithinProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusOrMouseWithinStatus",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IFocusWithinStatus"
                },
                {
                    "name": "IMouseWithinStatus"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/FocusWithin/FocusWithin.Props.d.ts": [
        {
            "description": "",
            "name": "IFocusWithin",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "hasFocus",
                    "optional": false,
                    "type": "() => boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusWithinEvents",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusWithinProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If updateStateOnFocusChange is set to true, the FocusWithin component will update\r\nthe state of the component and cause a re-render of the sub-tree when focus enters\r\nof leaves the component.",
                    "name": "updateStateOnFocusChange",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFocusWithinEvents"
                }
            ]
        },
        {
            "description": "",
            "name": "IFocusWithinStatus",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "hasFocus",
                    "optional": false,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFocusWithinEvents"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/FocusZone/FocusZone.Props.d.ts": [
        {
            "description": "",
            "name": "FocusZoneDirection",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Horizontal",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "Vertical",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "FocusZoneKeyStroke",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "Dont alter the keystroke in any way.",
                    "name": "IgnoreNone",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "All parent focus zones should ignore the keystroke, but it should be\r\nprocessed normally by the current focuszone.",
                    "name": "IgnoreParents",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "All focuszones that receive the keystroke should ignore it.",
                    "name": "IgnoreAll",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IFocusZoneContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The focuszoneId of the current context should be added to elements through\r\nthe data-focuszone property for elements that are focusable and should\r\nparticpate in the focuszone handling.",
                    "name": "focuszoneId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The direction of the current context.",
                    "name": "direction",
                    "optional": true,
                    "type": "FocusZoneDirection"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFocusZoneProps",
            "properties": [
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Clicks on the currently focused element when Enter is pressed if true",
                    "name": "activateOnEnter",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set to true, focus will move out of inputs / text areas when at the\r\nstart or end of their content",
                    "name": "allowArrowOutOfInputs",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set to true, focus will be able to move from the last element to the\r\nfirst or vice versa.",
                    "name": "circularNavigation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selector for the element to receive focus when the FocusZone mounts.",
                    "name": "defaultActiveElement",
                    "optional": true,
                    "type": "string | (() => string)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The direction that focus moves within the FocusZone. This can be left\r\nunsupplied if the FocusZone is using the handleTabKey to navigate the\r\nFocusZone exclusively.",
                    "name": "direction",
                    "optional": true,
                    "type": "FocusZoneDirection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When set to true, the FocusZone will stop managing focus.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided, will wrap the FocusZone in a FocusGroup to handle\r\ntracking the focused items within the FocusZone.",
                    "name": "focusGroupProps",
                    "optional": true,
                    "type": "IFocusGroupProps & { ref?: React.Ref<FocusGroup> }"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether the FocusZone should focus a default element when it mounts or not.",
                    "name": "focusOnMount",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When handleTabKey is set to true, the tab and shift/tab keys will act as\r\nfocuszone navigation keys. NOTE: When the focus zone is set in circular\r\nnavigation mode, the user wont be able to get focus out of the zone without\r\nusing the mouse or some other method to move the focus.",
                    "name": "handleTabKey",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The focuszone can include all items that are tab stops by default within\r\nthe focus zone. This is not the default, and the focus zone will only\r\npick up components marked with the focuszone id. This is used to support\r\nembedded focus zones.",
                    "name": "includeDefaults",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This allows the consumer to intercept keystrokes after they are processed\r\nby the focus zone and may prevent this focus zone's parents from acting\r\non the keystroke.\r\n\r\nThis wont effect preventDefault.",
                    "name": "postprocessKeyStroke",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLElement>) => FocusZoneKeyStroke"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This allows the consumer to intercept keystrokes before they are processed\r\nby the focus zone and may prevent this focus zone or it parents from acting on\r\nthe keystroke.\r\n\r\nThis wont effect preventDefault.",
                    "name": "preprocessKeyStroke",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLElement>) => FocusZoneKeyStroke"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When set to true, prevents scroll after focus on specific element",
                    "name": "preventScrollOnFocus",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller knows that all elements of thie focus zone will be visible.\r\nThis means they will not have display: none or visibility: hidden css attributes\r\nthey we can skip this validation.\r\n\r\nThis should be used with care, it will ensure there is not style recalculations\r\ndone during focus evaluation, but this will break the focus zone if hidden\r\nelements exist in the zone.",
                    "name": "skipHiddenCheck",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true if keyboard controlled focus ends up on a focusable input element than input text is selected automatically\r\nso user could replace or delete it's content immediately.\r\n\r\nConsider making it a default behavior, since it's a default behavior for input elements.",
                    "name": "selectInputTextOnFocus",
                    "optional": true,
                    "type": "boolean\r\n}"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/FormItem/FormItem.Props.d.ts": [
        {
            "description": "",
            "name": "IFormItemContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id to use as the consuming component's ariaDescribedBy",
                    "name": "ariaDescribedById",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id to use as the consuming component's ariaLabelledBy",
                    "name": "ariaLabelledById",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the FormItem is in an error state. Consuming components\r\ncan alter their visualization based on this prop.",
                    "name": "error",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " Severity.Error\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Differentiates between error and warning states of FormItem. Consuming components\r\ncan alter their visualization based on this prop.",
                    "name": "severity",
                    "optional": true,
                    "type": "Severity"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFormItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria label that can be supplied if is should be something different than label.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to include on the element that wraps the item's",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the form item is currently in an error state.",
                    "name": "error",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Differentiates between error and warning states of FormItem.",
                    "name": "severity",
                    "optional": true,
                    "type": "IReadonlyObservableValue<Severity> | Severity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A label for the component. Will be wrapped in a <label /> element.",
                    "name": "label",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A helper message to include with the component. Will be wrapped in a <span /> element.",
                    "name": "message",
                    "optional": true,
                    "type": "IReadonlyObservableValue<React.ReactNode> | React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to mark the form item as required.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Emit generated label ID.\r\nThis can be used by consuming components to associate the label with the input,\r\nwhich is often needed due to accessibility reasons.\r\nFor example, we might want narrators to announce the input value together with the label so that users know what the value represents.\r\nThis event is needed because Label ID can't be determined in advance (it depends on number of available instances).",
                    "name": "emitGeneratedLabelId",
                    "optional": true,
                    "type": "(labelId: string) => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "Severity",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Error",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "Warning",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        }
    ],
    "azure-devops-ui/Components/Header/Header.Props.d.ts": [
        {
            "description": "",
            "name": "IHeader",
            "properties": [],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "TitleSize",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Medium",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Large",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Small",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IHeaderBreakpointCommandItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Icon of the Command Bar item to be displayed on the certain breakpoint.\r\nSpecify undefined to make icon hidden.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of the Command Bar item specified for the Header.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Importance of the Command Bar item to be displayed on the certain breakpoint.\r\nNot specifying important will let Header itself decide when to display items\r\nin the overflow area.\r\n\r\nIf full control is needed to display items in the overflow area, specify important\r\nfor each Command Bar item no matter they change between breakpoints or not.",
                    "name": "important",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text of the Command Bar item to be displayed on the certain breakpoint.\r\nSpecify undefined to make text hidden.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip props to display",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderBreakpoint",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The header is defined with series of breakpoints. Each of the breakpoints\r\nwill have a mappings for the specified Command Bar items.\r\n\r\nIf a Command Bar item is not changed for any of the breakpoints, then it is not\r\nnecessary to include it in the commandBarItems list. However, all the properties\r\n(id, text, iconProps, important) need to be specified for a Command Bar item, if\r\nit changes between breakpoints to have correct visibility for that item.",
                    "name": "breakpoint",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of Command Bar items, which will have a change for this particular breakpoint.\r\nId property needs to match the id from the commandBarItems of the Header in order to\r\nget a Command Bar item's visibility updated for a certain breakpoint.",
                    "name": "commandBarItems",
                    "optional": true,
                    "type": "IHeaderBreakpointCommandItem[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICustomHeaderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the root Header element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to show a separator after the Header",
                    "name": "separator",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderDescriptionProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the description element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional id used for the descriptions's text. Can be used in conjunction with aria-describedby.\r\ngetSafeId() will be called on this value.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderBackButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If these props are provided, the Header will draw a back button before the\r\nheader's title. By default this will use a subtle button with the \"Back\" icon,\r\nbut these props can override those choices.",
                    "name": "buttonProps",
                    "optional": false,
                    "type": "IButtonProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderIconProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the icon element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to render for the icon.",
                    "name": "iconProps",
                    "optional": false,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Applies appropriate font size and padding for the icon.",
                    "name": "titleSize",
                    "optional": true,
                    "type": "TitleSize"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderTitleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional aria level to pass to the title element",
                    "name": "ariaLevel",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the title element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional id used for the title's text. Can be used in conjunction with aria-labelledby.\r\ngetSafeId() will be called on this value.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Applies appropriate font size and padding for text.",
                    "name": "titleSize",
                    "optional": true,
                    "type": "TitleSize"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderTitleAreaProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the title area element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderTitleRowProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the title row element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If these props are provided, the Header will draw a back button before the\r\nheader's title. By default this will use a subtle button with the \"Back\" icon,\r\nbut these props can override those choices.",
                    "name": "backButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How many buttons to show in the HeaderCommandBar if there is room.  The rest will be sent to overflow if they are not marked as important.",
                    "name": "buttonCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to pass to the command bar rendered in the Header.",
                    "name": "commandBarClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to pass to the Header's content element.",
                    "name": "contentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Items to display in the far-right Command Bar\r\nShould influence page-wide state",
                    "name": "commandBarItems",
                    "optional": true,
                    "type": "IReadonlyObservableArray<IHeaderCommandBarItem> | IHeaderCommandBarItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id to assign to the more button within the HeaderCommandBar.",
                    "name": "commandBarMoreButtonId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Secondary text to display in the header, below the title",
                    "name": "description",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to pass to the description in the Header",
                    "name": "descriptionClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional id used for the descriptions's text. Can be used in conjunction with aria-describedby.\r\ngetSafeId() will be called on this value.",
                    "name": "descriptionId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A header can be defined with a set of breakpoints. These breakpoints will be used to control\r\nthe visibility of the Command Bar items as the space available to the header changes.",
                    "name": "headerBreakpoints",
                    "optional": true,
                    "type": "IHeaderBreakpoint[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Primary text to display in the header",
                    "name": "title",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria level to pass to the title in the Header",
                    "name": "titleAriaLevel",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to pass to the title in the Header",
                    "name": "titleClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to render the large Title Icon to the left of the Title and Description elements",
                    "name": "titleIconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional id used for the title's text. Can be used in conjunction with aria-labelledby.\r\ngetSafeId() will be called on this value after it is passed to the <HeaderTitle />",
                    "name": "titleId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Applies appropriate font size and padding for title text.",
                    "name": "titleSize",
                    "optional": true,
                    "type": "TitleSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to keep icons for header bar but expand to have text for overflow menu",
                    "name": "useAriaLabelForOverflow",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICustomHeaderProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/HeaderCommandBar/HeaderCommandBar.Props.d.ts": [
        {
            "description": "",
            "name": "IHeaderCommandBar",
            "properties": [],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderCommandBarItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-checked to the element.",
                    "name": "ariaChecked",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-controls to the element.\r\n\r\nNOTE: Give the base Id in this case, NOT the getSafeId.",
                    "name": "ariaControls",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-describedby to the element.\r\n\r\nNOTE: Give the base Id in this case, NOT the getSafeId.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-expanded to the element.",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-haspopup to the element.",
                    "name": "ariaHasPopup",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An aria label to add to the command bar item.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-posinset to the element.",
                    "name": "ariaPosInSet",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-roledescription to the element.",
                    "name": "ariaRoleDescription",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-pressed to the element.",
                    "name": "ariaPressed",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-selected to the element.",
                    "name": "ariaSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adds aria-setsize to the element.",
                    "name": "ariaSetSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates that the dropdown chevron should not be shown.\r\nOnly applies to items that have subMenuProps.",
                    "name": "hideDropdownIcon",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A value of true means the item will always be rendered as\r\na button directly in the header.\r\nA value of false means the item will always be rendered in\r\nan overflow button.\r\nUndefined means that the HeaderCommandBar will determine\r\nwhere the item is rendered.",
                    "name": "important",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Determines if we render as a primary button or not",
                    "name": "isPrimary",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The items will be sorted by rank if rank is present.",
                    "name": "rank",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom renderer for the command bar item when rendered in the header",
                    "name": "renderButton",
                    "optional": true,
                    "type": "(props: IButtonProps | IMenuButtonProps): JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Override the default \"menuItem\" role for the item",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Uses a subtle button when rendering this item - only applies\r\nwhen the item is not in overflow",
                    "name": "subtle",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip props to display",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMenuItem"
                }
            ]
        },
        {
            "description": "",
            "name": "IHeaderCommandBarProps",
            "properties": [
                {
                    "defaultValue": " 3\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How many buttons to show if there is room.  The rest will be sent to overflow if they are not marked as important.",
                    "name": "buttonCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Additional classes to be applied to component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Setting this property enables experimental layout computations meant to reduce flickering. This is a temporary property that will be removed in a future version and not supported long-term",
                    "name": "reduceFlickering",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Items to display in the far-right Command Bar\r\nShould influence page-wide state",
                    "name": "items",
                    "optional": false,
                    "type": "IHeaderCommandBarItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id to apply to the overflow more button.",
                    "name": "moreButtonId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the callout rendered by overflow menu button.",
                    "name": "overflowClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to keep icons for header bar but expand to have text for overflow menu",
                    "name": "useAriaLabelForOverflow",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the overflow menu",
                    "name": "moreButtonMenuClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ICustomHeaderCommandBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Additional classes to be applied to component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Focus group props to use in the focus zone that wraps the ButtonGroup",
                    "name": "focusGroupProps",
                    "optional": true,
                    "type": "IFocusGroupProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the last child is an icon button - will adjust right padding",
                    "name": "lastItemIsIconButton",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role to apply to the div containing the command bar, e.g. \"menubar\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IHeaderCommandBarWithFilterProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A filter object to listen to changes on. When there are changes, the filter icon\r\nwill be displayed as filled.",
                    "name": "filter",
                    "optional": false,
                    "type": "IFilter"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The current state of whether the filter is visible or hidden. The value is toggled\r\nby the onClick on the item.",
                    "name": "filterToggled",
                    "optional": false,
                    "type": "IObservableValue<boolean | undefined>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IHeaderCommandBarProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Icon/Icon.Props.d.ts": [
        {
            "description": "",
            "name": "IconSize",
            "properties": [
                {
                    "defaultValue": "\"\"",
                    "description": "Inherit has the icon take on the current text size.",
                    "name": "inherit",
                    "type": "string"
                },
                {
                    "defaultValue": "\"large\"",
                    "description": "1.5rem - 24px",
                    "name": "large",
                    "type": "string"
                },
                {
                    "defaultValue": "\"medium\"",
                    "description": "1rem - 16px",
                    "name": "medium",
                    "type": "string"
                },
                {
                    "defaultValue": "\"small\"",
                    "description": "0.75rem - 12px",
                    "name": "small",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IIconProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-describedBy",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-expanded attribute",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-hidden\r\nIf not set, it defaults to true. Valid values for extensions are true, false, and undefined.",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean | \"true\" | \"false\" | \"removed\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "label that can be added to the icon to help assistive technology understand\r\nthe meaning of the icon.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional classname to add to the Icon component. If the user wants to use\r\nan icon that is not coming from the fabric font the className should\r\ncontain the font-family and the character to display.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The iconName of the fabric icon to show. Only specify an iconName when the\r\nicon is coming from the fabric icon font.",
                    "name": "iconName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id for the root element",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A unique identifier for this component.",
                    "name": "key",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional click handler for the icon",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLSpanElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional mousedown handler for the icon.",
                    "name": "onMouseDown",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLSpanElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional keydown handler for the icon.",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLSpanElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Allows for arbitrary content to be rendered instead of using an icon from\r\nthe fabric icon font. A common scenario would be rendering something like a\r\nstatus icon in place of a font icon. We want to allow for scenarios that\r\nexpect iconProps to work, but still allow for custom components to be rendered.",
                    "name": "render",
                    "optional": true,
                    "type": "(className?: string) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Select from a standard size; for custom scenarios, you'll need to use custom CSS\r\nBy default, icons will inherit their font size from their parent element; if you're using an Icon inline with text, don't set this",
                    "name": "size",
                    "optional": true,
                    "type": "IconSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Extra styles that should be added to the element, this supports dynamic\r\nstyles that couldn't be defined statically in CSS.",
                    "name": "style",
                    "optional": true,
                    "type": "React.CSSProperties"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tabindex",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional title",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the icon is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class to apply to the wrapper element.  Wrapper elements are used when aria props are provided.",
                    "name": "wrapperClass",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/IdentityCard/ContactCard.Props.d.ts": [
        {
            "description": "",
            "name": "IContactCardContactLineProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content for line.",
                    "name": "content",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Label for line.",
                    "name": "label",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Link for line.",
                    "name": "link",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) to pad top.",
                    "name": "padTop",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IContactLineProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content for line.",
                    "name": "content",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Non-visible label for link (such as \"E-mail\" or \"Call\") to describe the link itself.",
                    "name": "hiddenLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Name for icon.",
                    "name": "iconName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Link for line.",
                    "name": "link",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IContactCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity object for persona and contact information.",
                    "name": "identity",
                    "optional": false,
                    "type": "IIdentity"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IOrganizationCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of direct reports.",
                    "name": "directReportList",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of managers.",
                    "name": "managerList",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to handle identity click.",
                    "name": "onClickEntity",
                    "optional": true,
                    "type": "(identifier: string | IIdentity) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IContactCardProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IGroupMembersCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of members.",
                    "name": "members",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of managers.",
                    "name": "managerList",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to handle identity click.",
                    "name": "onClickEntity",
                    "optional": true,
                    "type": "(identifier: string | IIdentity) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IContactCardProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IDefaultCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Previous header exists boolean.",
                    "name": "isPreviousHeader",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Direct manager identity object.",
                    "name": "manager",
                    "optional": true,
                    "type": "IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to handle identity click.",
                    "name": "onClickEntity",
                    "optional": true,
                    "type": "(identifier: string | IIdentity) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to show contact card.",
                    "name": "showContactCard",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to show organization card.",
                    "name": "showOrganizationCard",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IContactCardProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IGroupCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Previous header exists boolean.",
                    "name": "isPreviousHeader",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Direct manager identity object.",
                    "name": "members",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method to show organization card.",
                    "name": "showOrganizationCard",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IContactCardProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/IdentityCard/IdentityCard.Props.d.ts": [
        {
            "description": "",
            "name": "CardType",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Default",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Contact",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Organization",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IDataState",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cardType",
                    "optional": true,
                    "type": "CardType"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "directReportList",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "displayName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "email",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "header",
                    "optional": true,
                    "type": "IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "identity",
                    "optional": true,
                    "type": "IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "imageUrl",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isGroup",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "managerList",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "previousDataState",
                    "optional": true,
                    "type": "IDataState"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "source",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "successors",
                    "optional": true,
                    "type": "IIdentity[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IdentityCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Consumer id passed from the caller of the persona card and passed into the identity call.",
                    "name": "consumerId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Display name, if passed, in will be used to display when identity service fails to fetch the identity",
                    "name": "displayName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request Entity information about a given Entity.",
                    "name": "getEntityFromUniqueAttribute",
                    "optional": false,
                    "type": "(entityId: string) => IIdentity | PromiseLike<IIdentity>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Initial identity object, if available.",
                    "name": "identity",
                    "optional": true,
                    "type": "IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Image url, if passed, in will be used to display when identity service fails to fetch the identity",
                    "name": "imageUrl",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Initial header props to use if content is hosted inside an external component",
                    "name": "initialHeader",
                    "optional": true,
                    "type": "HeaderElementProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Callback when card is dismissed.",
                    "name": "onDismissCallback",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request connection information about a given Entity.",
                    "name": "onRequestConnectionInformation",
                    "optional": false,
                    "type": "(\r\n        entity: IIdentity | undefined,\r\n        getDirectReports?: boolean\r\n    ) => IIdentityConnections | PromiseLike<IIdentityConnections>"
                },
                {
                    "defaultValue": "",
                    "deprecated": true,
                    "deprecatedMessage": " use target instead\r",
                    "description": "(Optional) Reference HTML component.",
                    "name": "referenceHTMLComponent",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) The target that the PersonCard should try to position itself based on.\r\nCan be an HTMLElement or a point object with the X and Y coordinates set",
                    "name": "target",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Unique attribute (entityID or signInAddress or uniqueName) to get identity object (if no identity available).",
                    "name": "uniqueAttribute",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IdentityCardContentProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callout ref",
                    "name": "calloutRef",
                    "optional": false,
                    "type": "React.RefObject<Callout>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Data props from parent component to get the identity, cardtype etc information",
                    "name": "dataProps",
                    "optional": false,
                    "type": "IDataState"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Onclick of any persona entity",
                    "name": "onClickEntity",
                    "optional": true,
                    "type": "(identity: IIdentity) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Onclick of any persona header",
                    "name": "onHeaderClick",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Callback to open Contact Card",
                    "name": "onShowContactCard",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Callback to open Organization Card",
                    "name": "onShowOrganizationCard",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to force the unknown user message to show.",
                    "name": "showUnknownUser",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(Optional) Prevent requests if working",
                    "name": "working",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IdentityCardProps"
                }
            ]
        },
        {
            "description": "",
            "name": "HeaderElementProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Current data state (can be null).",
                    "name": "identity",
                    "optional": true,
                    "type": "IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function on click (show default card or pop breadcrumb).",
                    "name": "onClickFunction",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/IdentityPicker/IdentityPicker.Props.d.ts": [
        {
            "description": "",
            "name": "IIdentityPickerProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS class name to add to IdentityPicker",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom converter to go from identity to tag props",
                    "name": "convertItemToPill",
                    "optional": true,
                    "type": "(person: IIdentity, index: number) => ISelectedTagProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to display when there are no results found.",
                    "name": "noResultsFoundText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called on focus away\r\n@param text text value of the picker before focus away",
                    "name": "onBlur",
                    "optional": true,
                    "type": "(text?: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the user clicks or enters on a suggested person",
                    "name": "onIdentityAdded",
                    "optional": false,
                    "type": "(tag: IIdentity) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the user removes multiple identities by selecting them and hitting delete",
                    "name": "onIdentitiesRemoved",
                    "optional": false,
                    "type": "(identities: IIdentity[]) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the user removes a previously selected person",
                    "name": "onIdentityRemoved",
                    "optional": false,
                    "type": "(tag: IIdentity) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This prop specifies a callback where, if this is specified, unresolved emails are allowed to be chosen.\r\nThis allows unresolved emails to be passed into the onIdentityAdded callback and they have the following properties\r\n{ entityId: emailAddress, originDirectory: \"email\", entityType: IdentityType.Custom}",
                    "name": "onResolveEntity",
                    "optional": true,
                    "type": "(email: string, identity: IIdentity | null) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provider to handle how to filter the suggested people from a filter.",
                    "name": "pickerProvider",
                    "optional": false,
                    "type": "IPeoplePickerProvider"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to show when there is no input in the text field.",
                    "name": "placeholderText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Render a suggestion item for a custom identity.",
                    "name": "renderCustomIdentitySuggestion",
                    "optional": true,
                    "type": "(identity: IIdentity) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity values of the selected identities This prop is 100% controlled\r\nby the consumer. onIdentityAdded/onIdentityRemoved/onIdentitiesRemoved must also be implemented in order to\r\nwork properly. If this value is a array of IIDentities, the prop must be\r\nupdated to cause the PeoplePicker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the PeoplePicker\r\nto re-render.",
                    "name": "selectedIdentities",
                    "optional": false,
                    "type": "IReadonlyObservableArray<IIdentity> | IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label of the suggestions container",
                    "name": "suggestionsContainerAriaLabel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/IdentityPickerDropdown/CustomIdentityPickerDropdown.Props.d.ts": [
        {
            "description": "",
            "name": "ICustomIdentityPickerDropdownProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "boolean if the suggestions list is opened or not. This prop is 100% controlled\r\nby the consumer. onSuggestionsVisibleChanged must also be implemented in order to\r\nwork properly. If this value is a an boolean, the prop must be\r\nupdated to cause the IdentityPicker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the IdentityPicker\r\nto re-render.",
                    "name": "suggestionsVisible",
                    "optional": false,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the value of the input/textarea changes. This can happen when a user types or a new identity is selected.\r\nThe consumer is responsible to update the textValue property accordingly.",
                    "name": "onInputChange",
                    "optional": false,
                    "type": "(value: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the control is attempting to show or hide the suggestions list.\r\nThe consumer is responsible to update the suggestionsVisible",
                    "name": "onSuggestionsVisibleChanged",
                    "optional": false,
                    "type": "(shouldDisplay: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity value of the selected persona This prop is 100% controlled\r\nby the consumer. onChange must also be implemented in order to\r\nwork properly. If this value is a an identity, the prop must be\r\nupdated to cause the IdentityPicker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the IdentityPicker\r\nto re-render. The textValue may also need to be updated when you change\r\nthis to show the selected users display name",
                    "name": "textValue",
                    "optional": false,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Maximum number of suggestions to show in the full suggestion list.\r\nIf provided 0 or less, it will be set to no limit.\r\nIMPORTANT: This could create a performance issue if the number of suggestions is too high or not properly limited",
                    "name": "suggestionItemsMaximumCount",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISharedIdentityPickerProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/IdentityPickerDropdown/IdentityPickerDropdown.Props.d.ts": [
        {
            "description": "",
            "name": "IIdentityPickerDropdownProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the control is attempting to show or hide the suggestions list.",
                    "name": "onSuggestionsVisibleChanged",
                    "optional": true,
                    "type": "(suggestsionsVisible: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Maximum number of suggestions to show in the full suggestion list.\r\nIf provided 0 or less, it will be set to no limit.\r\nIMPORTANT: This could create a performance issue if the number of suggestions is too high or not properly limited",
                    "name": "suggestionItemsMaximumCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label of the suggestions container",
                    "name": "suggestionsContainerAriaLabel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISharedIdentityPickerProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/IdentityPickerDropdown/IdentityPickerDropdownFilterBarItem.Props.d.ts": [
        {
            "description": "",
            "name": "IIdentityPickerDropdownFilterBarItemState",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IFilterBarItemState<IIdentity[]>"
                }
            ]
        },
        {
            "description": "",
            "name": "IIdentityPickerDropdownFilterBarItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text value for initial identity for filter item",
                    "name": "initialTextValue",
                    "optional": true,
                    "type": "string | ObservableValue<string | undefined>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Initial identity for filter item",
                    "name": "initialValue",
                    "optional": true,
                    "type": "IIdentity | ObservableValue<IIdentity | undefined>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFilterBarItemProps"
                },
                {
                    "name": "IIdentityPickerProps",
                    "properties": [
                        "pickerProvider"
                    ]
                },
                {
                    "name": "ISharedIdentityPickerProps",
                    "properties": [
                        "className",
                        "editPlaceholder",
                        "resolveUnrecognizedIdentity"
                    ]
                }
            ]
        }
    ],
    "azure-devops-ui/Components/IdentityPickerDropdown/SharedIdentityPicker.Props.d.ts": [
        {
            "description": "",
            "name": "IPersonaConnections",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "directReports",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "successors",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "managers",
                    "optional": true,
                    "type": "IIdentity[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IdentityType",
            "properties": [
                {
                    "defaultValue": "\"user\"",
                    "description": "",
                    "name": "User",
                    "type": "string"
                },
                {
                    "defaultValue": "\"group\"",
                    "description": "",
                    "name": "Group",
                    "type": "string"
                },
                {
                    "defaultValue": "\"custom\"",
                    "description": "",
                    "name": "Custom",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IIdentity",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "active",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "department",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "description",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "displayName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "entityId",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "entityType",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "guest",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "image",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isHosted",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isMru",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "jobTitle",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "localDirectory",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "localId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "mail",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "mailNickname",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "manager",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "originDirectory",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "originId",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "physicalDeliveryOfficeName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "samAccountName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "scopeName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "signInAddress",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "subjectDescriptor",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "surname",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "telephoneNumber",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPeoplePickerProvider",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Add identities to the MRU\r\n@returns A promise that returns true if successful false otherwise",
                    "name": "addIdentitiesToMRU",
                    "optional": true,
                    "type": "(identities: IIdentity[]) => Promise<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Given a list of currently selected items and a filter string, return a list of suggestions to put in the suggestion list",
                    "name": "onFilterIdentities",
                    "optional": false,
                    "type": "(filter: string, selectedItems?: IIdentity[]) => IIdentity[] | PromiseLike<IIdentity[]> | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If no input is in the search box when clicked, provide a set of identities to show (used for MRU)",
                    "name": "onEmptyInputFocus",
                    "optional": true,
                    "type": "() => IIdentity[] | PromiseLike<IIdentity[]> | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request connection information about a given Entity.",
                    "name": "onRequestConnectionInformation",
                    "optional": false,
                    "type": "(entity: IIdentity, getDirectReports?: boolean) => IPersonaConnections | PromiseLike<IPersonaConnections>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request Entity information given an entityId",
                    "name": "getEntityFromUniqueAttribute",
                    "optional": false,
                    "type": "(entityId: string) => IIdentity | PromiseLike<IIdentity>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Add identities to the MRU\r\n@returns A promise that returns true if successful false otherwise",
                    "name": "removeIdentitiesFromMRU",
                    "optional": true,
                    "type": "(identities: IIdentity[]) => Promise<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Add non-identity entries",
                    "name": "setAdditionalEntries",
                    "optional": true,
                    "type": "(values: string[]) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Get non-identity entries",
                    "name": "getAdditionalEntries",
                    "optional": true,
                    "type": "() => string[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISharedIdentityPickerProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A boolean value indicating should component gets auto focussed on mount",
                    "name": "autoFocus",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " 300.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Width of callout",
                    "name": "calloutWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The CSS classname of the people picker control.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Disables the identity picker if true.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " \"Assign People\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder text for the input",
                    "name": "editPlaceholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional Id that will be given to the input element",
                    "name": "inputId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates if the text in resultsFooter or resultsFooterFull should be shown at the end of the suggestion list.",
                    "name": "isResultsFooterVisible",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to display when there are no results found.",
                    "name": "noResultsFoundText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback for when input gets blurred",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback for when a suggestion is clicked. If no valid suggestion has been selected, item is undefined.",
                    "name": "onChange",
                    "optional": false,
                    "type": "(item?: IIdentity) => boolean | void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback for when the search text is cleared.",
                    "name": "onClear",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback for when input gets focus",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(e: React.FocusEvent<HTMLInputElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provider to handle how to filter the suggested people from a filter.",
                    "name": "pickerProvider",
                    "optional": false,
                    "type": "IPeoplePickerProvider"
                },
                {
                    "defaultValue": " \"No one selected\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder text for the input",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Render a suggestion item for a custom identity.",
                    "name": "renderCustomIdentitySuggestion",
                    "optional": true,
                    "type": "(identity: IIdentity) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional delegate to resolve identity input which did not resolve to any suggested\r\nidentity in the picker.",
                    "name": "resolveUnrecognizedIdentity",
                    "optional": true,
                    "type": "(identityInput: string) => IIdentity | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Maximum number of suggestions to show in the full suggestion list.",
                    "name": "resultsMaximumNumber",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " false.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates whether textfield is required or not.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An ARIA label for the container that is the parent of the suggestions.",
                    "name": "suggestionsContainerAriaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "the classname of the suggestionitem.",
                    "name": "suggestionsItemClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity value of the selected persona This prop is 100% controlled\r\nby the consumer. onChange must also be implemented in order to\r\nwork properly. If this value is a an identity, the prop must be\r\nupdated to cause the IdentityPicker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the IdentityPicker\r\nto re-render. The textValue may also need to be updated when you change\r\nthis to show the selected users display name",
                    "name": "value",
                    "optional": false,
                    "type": "IReadonlyObservableValue<IIdentity | undefined> | IIdentity | undefined"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/IdentityPickerSuggestionsList/IdentityPickerSuggestionsList.Props.d.ts": [
        {
            "description": "",
            "name": "IdentityPickerSuggestionsListProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to render the callout which shows the suggestions list",
                    "name": "calloutProps",
                    "optional": false,
                    "type": "ICalloutProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to display when there are no suggestsions found for a given search.",
                    "name": "noResultsFoundText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the persona card is closed. This should set the openedIdentityCard value to undefined appropriately.",
                    "name": "onClosePersonaCard",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the persona card is opened. This should set the openedIdentityCard value appropriately.",
                    "name": "onOpenPersonaCard",
                    "optional": false,
                    "type": "(identity: IIdentity) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the callout is dismissed. This should set the suggestionsVisible appropriately.",
                    "name": "onDismiss",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": " undefined\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "IIdentity of the Persona Card if opened. The card is closed when set to undefined",
                    "name": "openedIdentityCard",
                    "optional": true,
                    "type": "IReadonlyObservableValue<IIdentity> | IIdentity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How the suggestion should look in the suggestion list.",
                    "name": "renderSuggestion",
                    "optional": true,
                    "type": "(suggestionItemProps: ISuggestionItemProps<IIdentity>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The target element that the callout should use to anchor to.",
                    "name": "suggestionTarget",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Boolean indicating if the suggestions list should be shown",
                    "name": "suggestionsVisible",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": " undefined\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The picker provider that will get details for the Identities when the persona card is opened.",
                    "name": "pickerProvider",
                    "optional": false,
                    "type": "IPeoplePickerProvider"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Maximum number of suggestions to show in the full suggestion list.\r\nIf provided 0 or less, it will be set to no limit.\r\nIMPORTANT: This could create a performance issue if the number of suggestions is too high or not properly limited",
                    "name": "resultsMaximumNumber",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISuggestionsListProps<IIdentity>"
                }
            ]
        },
        {
            "description": "",
            "name": "IIdentitySuggestionItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to be called when the contact card button is activated.",
                    "name": "onOpenPersonaCard",
                    "optional": true,
                    "type": "(identity: IIdentity) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISuggestionItemProps<IIdentity>"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Image/Image.Props.d.ts": [
        {
            "description": "",
            "name": "IImageProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional alt text for the image",
                    "name": "alt",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional classname to add to the Image component.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the image be scaled down to fit the container?\r\nIf true, we'll scale the image down / up to fit the container width, maintaining aspect ratio\r\nIf width and height are both supplied, this will be overridden to true",
                    "name": "containImage",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional height; we'll emit a wrapper around the img tag",
                    "name": "height",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A unique identifier for this component.",
                    "name": "key",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria role to be applied to the img element",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The url to use as the src of the <img> tag.",
                    "name": "src",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional width; we'll emit a wrapper around the img tag",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Intersection/Intersection.Props.d.ts": [
        {
            "description": "",
            "name": "IIntersectionProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller wants to observe a single static element within the intersection\r\nthat is available when the intersection mounts, it can supply an observationElement.",
                    "name": "observationElement",
                    "optional": true,
                    "type": "HTMLElement | string | (() => HTMLElement | null)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onIntersect is called in two cases and denotes a change in the rootElements\r\nvisible viewport.\r\n\r\n1) When the rootElement is scrolled onIntersect is called with a empty\r\narray of entries. No intersections are calculated.\r\n2) When the underlying IntersectionObserver fires the intersection events.\r\nThese event describe the changes in visibility of elements being observed\r\nthrough the IntersectionContext.",
                    "name": "onIntersect",
                    "optional": true,
                    "type": "(entries: IntersectionObserverEntry[]) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The parent element that contains the elements being observed and has its\r\nonScroll events forwarded.",
                    "name": "rootElement",
                    "optional": true,
                    "type": "HTMLElement | string | (() => HTMLElement | null)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An additional amount number of pixels that should be considered within the\r\nviewport of the rootElement. This is used to enlarge the visibility range\r\nmaking intersection occur when elements are still outside the visible view.",
                    "name": "rootMargin",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Threshold define the point at which the change is important. By default the\r\nthreshold are set to a 1% change in visibility. If the caller wants to know\r\nabout specific points only they can supply a custom set of thresholds.",
                    "name": "threshold",
                    "optional": true,
                    "type": "number[]"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Label/Label.Props.d.ts": [
        {
            "description": "",
            "name": "ILabelModel",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Background color of the label",
                    "name": "color",
                    "optional": true,
                    "type": "IColor"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text string for the label content",
                    "name": "content",
                    "optional": false,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ILabelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to enable or disable hover effects",
                    "name": "enableHover",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element has been exluded from a current focusZone by default.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element should not be tabable but still should be able to receieve focus.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id for the root element",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onBlur event handler for the Label",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onClick event handler for the Label",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus event handler for the Label",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onKeyDown when the Label is focused",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onMouseDown event handler for the Label",
                    "name": "onMouseDown",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Controls rendering of the control as \"selected\"",
                    "name": "selected",
                    "optional": true,
                    "type": "boolean | IReadonlyObservableValue<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Explicit tab index overrides any other focus-zone / focus-group controlled indexing",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": [
                {
                    "name": "ILabelModel"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/LabelGroup/LabelGroup.Props.d.ts": [
        {
            "description": "",
            "name": "WrappingBehavior",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "freeFlow",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "oneLine",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ILabelGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to emit on the root element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " label-0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The default child of the group",
                    "name": "defaultFocusElementId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional flag to disable mouse focus on labels, eg. clicking on them won't move focus to them\r\nKeyboard focus will still work\r\nDefaults to true for non-editable groups; false for editable groups",
                    "name": "disableMouseFocusOnLabels",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional flag to enable hover styles on labels in this group\r\nDefaults to false for non-editable groups; true for editable groups",
                    "name": "enableHoverStyles",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should we fade out the rightmost edge of the control for overflow purposes?\r\nWill render the fade-out if the control overflows or not\r\nNo effect on FreeFlow groups; OneLine only",
                    "name": "fadeOutOverflow",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id for the span that will contain the actual labels",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Labels to render within the group",
                    "name": "labelProps",
                    "optional": false,
                    "type": "ILabelModel[] | IReadonlyObservableArray<ILabelModel>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onClick for an arbitrary label, passes back the Key and the label's position in the group",
                    "name": "onLabelClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, labelModel: ILabelModel, index: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onKeyDown for an arbitrary label, passes back the Key and the label's position in the group",
                    "name": "onLabelKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLDivElement>, labelModel: ILabelModel, index: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onMouseDown for an arbitrary label",
                    "name": "onLabelMouseDown",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>, labelModel: ILabelModel, index: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional observable array that can be used to control what labels are Selected within the control",
                    "name": "selectedLabelContents",
                    "optional": true,
                    "type": "string[] | IReadonlyObservableArray<string>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional title to render",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " OneLine\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Describes how to wrap the content",
                    "name": "wrappingBehavior",
                    "optional": true,
                    "type": "WrappingBehavior"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IEditableLabelGroupProps",
            "properties": [
                {
                    "defaultValue": " \"Add label\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional button text",
                    "name": "addButtonText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional custom colors; default palatte will be used if none provided",
                    "name": "customColors",
                    "optional": true,
                    "type": "IColor[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional flag to disable color picker for new labels",
                    "name": "disableColorPicker",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional: Text to be shown when user attempts to add a duplicate label",
                    "name": "duplicateLabelText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Autocomplete and autosuggest retrieval function\r\nOptional; will only render color swatch picker\r\nif no suggestions are provided, none will be displayed",
                    "name": "getSuggestedLabels",
                    "optional": true,
                    "type": "(inputContent: string) => ILabelModel[] | PromiseLike<ILabelModel[]>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom handler for blur events",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Handler for when labels are to be removed from the group\r\nGroup will not update the observableArray itself; you may specify your own deletion lifecycle",
                    "name": "onLabelRemove",
                    "optional": true,
                    "type": "(labelModel: ILabelModel) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Handler for created labels\r\nGroup will not update the observableArray itself; you may specify your own creation lifecycle",
                    "name": "onLabelSubmit",
                    "optional": true,
                    "type": "(labelModel: ILabelModel) => void"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Overrides some internal padding that allows the control to reserve as much space as it needs\r\nSetting this will cause the control to change size as it enters / exits Edit mode",
                    "name": "shrinkToContents",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Override the default zero-data experience with a blank one",
                    "name": "useBlankZeroData",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " \"Type a label to add\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional placeholder text to be shown inside autocomplete control",
                    "name": "watermark",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ILabelGroupProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Link/Link.Props.d.ts": [
        {
            "description": "",
            "name": "IAnchorProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional href; if you don't provide one your link won't point anywhere",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a link opens in a new tab/window",
                    "name": "rel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional target, eg. _blank",
                    "name": "target",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ILink",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ILinkProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria described by for detailed information about the link",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional expanded flag for accessibility",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional hasPopup for accessibility",
                    "name": "ariaHasPopup",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria label",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-labelledby",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional selected for accessibility",
                    "name": "ariaSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to render",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional standin for data-is-focusable\r\n@@OFFICE_FABRIC remove when we are done.",
                    "name": "dataIsFocusable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional disabled boolean for the",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional point to a download location",
                    "name": "download",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the draggable attribute on the element.",
                    "name": "draggable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the link's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the link's to be tabbable.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional ID to emit",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onBlur handler",
                    "name": "onBlur",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onClick handler",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onFocus handler",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional hoverStart handler",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional hoverEnd handler",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional mouseOver handler",
                    "name": "onMouseOver",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onTouchEnd handler",
                    "name": "onTouchEnd",
                    "optional": true,
                    "type": "(event: React.TouchEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onTouchMove handler",
                    "name": "onTouchMove",
                    "optional": true,
                    "type": "(event: React.TouchEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional onTouchStart handler",
                    "name": "onTouchStart",
                    "optional": true,
                    "type": "(event: React.TouchEvent<HTMLAnchorElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to apply subtle styling to the link",
                    "name": "subtle",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tabIndex",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional link title",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the link is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": true,
                    "deprecatedMessage": " all links will be underlined by default unless given the removeUnderline prop.\r",
                    "description": "Set to true to underline the link text.",
                    "name": "underline",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to remove underline from link text.",
                    "name": "removeUnderline",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IAnchorProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/List/FixedHeightList.Props.d.ts": [
        {
            "description": "",
            "name": "IFixedHeightListCellDetails",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cellElement",
                    "optional": false,
                    "type": "HTMLElement | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cellIndex",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "rowElement",
                    "optional": false,
                    "type": "HTMLElement | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "rowIndex",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFixedHeightListRow<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Data that represents the instance of T for this row. In some cases the\r\nrow data may not be available.",
                    "name": "data",
                    "optional": false,
                    "type": "T"
                }
            ],
            "externalTypes": [
                {
                    "name": "IIndexed"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightListSelection",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not this selection will select items when they receive focus.",
                    "name": "selectOnFocus",
                    "optional": false,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelection"
                },
                {
                    "name": "IBehavior<{}"
                },
                {
                    "name": "ISelectableUI>"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightListSelectionOptions",
            "properties": [
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to select items when they receive focus.",
                    "name": "selectOnFocus",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelectOptions"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightListMaterializedStats",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "firstMaterialized",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "lastMaterialized",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IFixedHeightList<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "scrollIntoView works like the element method in the browser, but instead of being\r\nbased on the element scrollIntoView will scroll the row specified by the rowIndex\r\ninto view.\r\n\r\n@param rowIndex The 0 based rowIndex that should be scrolled into view.\r\n@param options These options are passed on to the underlying element.\r\n@param onScrollComplete This delegate is called when the scrolling is complete.\r\n This may not be immediate if the list has to materialize rows to scroll.\r\n NOTE: The rowIndex passed to the delegate will be the requested rowIndex or\r\n -1 if another scrollIntoView request is made before this scroll request completes.",
                    "name": "scrollIntoView",
                    "optional": false,
                    "type": "(rowIndex: number, options?: ScrollIntoViewOptions, onScrollComplete?: (rowIndex: number) => void) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Returns an object with the indexes of the first and last materialized and rendered rows.",
                    "name": "getStats",
                    "optional": false,
                    "type": "(): IFixedHeightListMaterializedStats"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An interface to group properties that get passed to the row renderer of each list row.",
                    "name": "export interface IFixedHeightListItemDetails<T> {\r\n    /**\r\n     * Sets aria-busy on the list item element.\r\n     */\r\n    ariaBusy",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-posinset on the div element.  Defaults to the item index.",
                    "name": "ariaPosInSet",
                    "optional": true,
                    "type": "number | null"
                },
                {
                    "defaultValue": " 1 The default value is 1 because the aria-rowindex is 1-based instead of 0-based\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Amount to offset the aria-rowindex attribute of a row. This should be added\r\nto the index to produce the aria-rowindex of the row. The common use case for this property\r\nis accounting for the header row of a Table. Per the ARIA spec, a header row should be included in\r\nthe aria-rowcount, and provided an aria-rowindex of 1, meaning the first actual row of the table\r\nneeds an aria-rowindex of 2.",
                    "name": "ariaRowOffset",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-setsize on the div element.  Defaults to the itemProvider length.",
                    "name": "ariaSetSize",
                    "optional": true,
                    "type": "number | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The data represents the object being rendered in this row. If the caller\r\nhas asynchronous loading of rows, the data MAY be undefined while we wait\r\nfor the data to be resolved.",
                    "name": "data",
                    "optional": true,
                    "type": "T"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An event dispatch the row MAY use to dispatch custom events to list behaviors.",
                    "name": "eventDispatch",
                    "optional": false,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Properties used to render the list as a whole.",
                    "name": "listProps",
                    "optional": false,
                    "type": "IFixedHeightListProps<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the table a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<T | IReadonlyObservableValue<T | undefined>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The row MUST call onFocusItem when a row or one of the child elements of the row receives focus.",
                    "name": "onFocusItem",
                    "optional": false,
                    "type": "(rowIndex: number, event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, will make cursor display as a pointer when hovering over the item otherwise default.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelectableUI{"
                },
                {
                    "name": "/**"
                },
                {
                    "name": "* scrollIntoView works like the element method in the browser"
                },
                {
                    "name": "but instead of being"
                },
                {
                    "name": "* based on the element scrollIntoView will scroll the row specified by the rowIndex"
                },
                {
                    "name": "* into view."
                },
                {
                    "name": "*"
                },
                {
                    "name": "* @param rowIndex The 0 based rowIndex that should be scrolled into view."
                },
                {
                    "name": "* @param options These options are passed on to the underlying element."
                },
                {
                    "name": "* @param onScrollComplete This delegate is called when the scrolling is complete."
                },
                {
                    "name": "*  This may not be immediate if the list has to materialize rows to scroll."
                },
                {
                    "name": "*  NOTE: The rowIndex passed to the delegate will be the requested rowIndex or"
                },
                {
                    "name": "*  -1 if another scrollIntoView request is made before this scroll request completes."
                },
                {
                    "name": "*/"
                },
                {
                    "name": "scrollIntoView: (rowIndex: number"
                },
                {
                    "name": "options?: ScrollIntoViewOptions"
                },
                {
                    "name": "onScrollComplete?: (rowIndex: number) => void) => void;"
                },
                {
                    "name": "/**"
                },
                {
                    "name": "* Returns an object with the indexes of the first and last materialized and rendered rows."
                },
                {
                    "name": "*"
                },
                {
                    "name": "*/"
                },
                {
                    "name": "getStats(): IFixedHeightListMaterializedStats;"
                },
                {
                    "name": "}"
                },
                {
                    "name": "/**"
                },
                {
                    "name": "* An interface to group properties that get passed to the row renderer of each list row."
                },
                {
                    "name": "*/"
                },
                {
                    "name": "export interface IFixedHeightListItemDetails<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightListProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the list a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.\r\n\r\nThere is simple ArrayItemProvider<T> for those that just have a set of items\r\nthey want to supply without writing a custom ItemProvider.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<T | IReadonlyObservableValue<T | undefined>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label property for the list.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the list root element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The index of the row that should be tabbable before the list has received focus.",
                    "name": "defaultTabbableRow",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller can supply an EventDispatch to the list if it wishes to\r\nparticipate it extending the behaviors. If one isn't supplied the list will\r\ncreate its own dispatcher when behaviors are supplied.",
                    "name": "eventDispatch",
                    "optional": true,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the list rows are focused.\r\nThe default focuszone if one isn't supplied is a Vertical non-cyclic focus zone.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this list.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 1000000\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum height of the table when virtualized. Browsers have issues\r\nrendering elements that are too large and when the FixedHeightList contains thousands\r\nof elements, the list renders very large spacer elements to correctly\r\nposition the scroll bar. The large spacer elements cause rendering issues\r\nacross browsers. To bypass this, we need to limit how large the list can\r\ngrow to. By default this size is 1,000,000px. However, if you have multiple\r\nitems within a scrollable region, this number might need to be reduced.\r\nFor instance, if you have 5 lists that can contain a lot of rows in the\r\nsame scrollable region, you would likely want to set the max height for\r\neach list to 200,000. Keep in mind that the smaller this number, the harder\r\nit will be for a user to scroll with precision.",
                    "name": "maxHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param listRow Details about the list row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus is called when a item in the list is focused. Preventing default\r\non the focus event will prevent row selection from occuring even if\r\nselectOnFocus is set to true.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param listRow Details about the list row being activated.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IFixedHeightListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param listRow - Details about the list row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IFixedHeightListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number of elements to materialize when an element is being scrolled to. This should be \r\nroughly 1/2 the elements you expect to show on screen",
                    "name": "pageSize",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a row's value is given as an ObservableValue with an undefined value,\r\nthe list will render a Loading row for the content. The default will be\r\na shimmer row that is semi random and matches the content.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param details Additional details about this row.",
                    "name": "renderLoadingRow",
                    "optional": true,
                    "type": "(rowIndex: number, details: IFixedHeightListItemDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "All callers must supply a function for rendering the list row.\r\n\r\nThis should render what is inside a row of the list. All focus, and positioning of the\r\nrows will be handled by the FixedHeightList itself.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param item This is the object that represents the current rows data.\r\n@param details Additional details to handle aria attributes and focus.",
                    "name": "renderRow",
                    "optional": false,
                    "type": "(rowIndex: number, item: T, details: IFixedHeightListItemDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role defines the aria role of the list and defaults to \"listbox\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Required height of each row. Every row in the tree must be this height and all overflow is hidden.\r\nThe FixedHeightList control uses this value to absolutely position elements within it.",
                    "name": "rowHeight",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the list selection. This\r\nis not required since the list offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IFixedHeightListSelection that supports multi\r\nselect.  Selection should be specified on mount if used and not updated to\r\na new object during the FixedHeightList's lifecycle.\r\n\r\nThere is a basic FixedHeightListSelection implementation available from the FixedHeightList\r\ncomponent.",
                    "name": "selection",
                    "optional": true,
                    "type": "IFixedHeightListSelection"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the list select a row when it is clicked?\r\nProvides a way to turn off row-click selection when necessary, for things like\r\nTable with singleClickActivation",
                    "name": "selectRowOnClick",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "width can be any supported css width value, either a %, px, and vw value.",
                    "name": "width",
                    "optional": false,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/List/List.Props.d.ts": [
        {
            "description": "",
            "name": "IListCellDetails",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cellElement",
                    "optional": false,
                    "type": "HTMLElement | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cellIndex",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "rowElement",
                    "optional": false,
                    "type": "HTMLElement | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "rowIndex",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IListRow<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Data that represents the instance of T for this row. In some cases the\r\nrow data may not be available.",
                    "name": "data",
                    "optional": false,
                    "type": "T"
                }
            ],
            "externalTypes": [
                {
                    "name": "IIndexed"
                }
            ]
        },
        {
            "description": "",
            "name": "IFilteredListSelection",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Let the filtered selection know that its parent selection has changed.\r\n@param value the selection ranges returned from the change on the parent selection.\r\n@param action the action that occured on the parent selection.",
                    "name": "selectionChanged",
                    "optional": false,
                    "type": "(value: ISelectionRange[], action: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using the parent selection and a map of filtered indices to parent selection indices,\r\nupdate the state of the filteredSelection.\r\n@param filteredIndexMap a mapping of filtered indices to parent selection indices",
                    "name": "updateFilteredSelection",
                    "optional": false,
                    "type": "(filteredIndexMap: number[]) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListSelection"
                }
            ]
        },
        {
            "description": "",
            "name": "IListSelection",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not this selection will select items when they receive focus.",
                    "name": "selectOnFocus",
                    "optional": false,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelection"
                },
                {
                    "name": "IBehavior<{}"
                },
                {
                    "name": "ISelectableUI>"
                }
            ]
        },
        {
            "description": "",
            "name": "IListSelectionOptions",
            "properties": [
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to select items when they receive focus.",
                    "name": "selectOnFocus",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelectOptions"
                }
            ]
        },
        {
            "description": "",
            "name": "IOverlayRenderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "rowElement",
                    "optional": false,
                    "type": "HTMLElement"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IRowOverlayableUI",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "addOverlay is used to create, or update an existing, overlay over an existing list row.\r\nThis allows the caller to apply effects to the row by having elements\r\nthat appear over top of the row.\r\n\r\n@param id This is a unique id for this overlay.\r\n@param rowIndex The index of the row the overlay should hover over.\r\n@param render A function which returns the React nodes that should be placed within the overlay.\r\n The parent element will be positioned, and have the same height and width\r\n as the underlying row element.\r\n@param zIndex If there are multiple overlays the caller can use the zIndex\r\n parameter to ensure they are layered correctly.\r\n@param columnIndex The index of the column the overlay should hover over (used for column header drag/drop)",
                    "name": "addOverlay",
                    "optional": false,
                    "type": "(id: string, rowIndex: number, render: (props: IOverlayRenderProps) => React.ReactNode, zIndex?: number, columnIndex?: number): void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "removeOverlay is used to remove an overlay that has already been registered.\r\nThe unique id is all that is needed.\r\n@param id This is a unique id for this overlay.",
                    "name": "removeOverlay",
                    "optional": false,
                    "type": "(id: string): void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IDragDroppableUI",
            "properties": [],
            "externalTypes": [
                {
                    "name": "ISelectableUI"
                },
                {
                    "name": "IRowOverlayableUI"
                }
            ]
        },
        {
            "description": "",
            "name": "BoltListDragEvent<T, D>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "BoltDragEvent<T"
                },
                {
                    "name": "D"
                },
                {
                    "name": "IListDragDropSecondaryData>"
                }
            ]
        },
        {
            "description": "",
            "name": "IListDragDropSecondaryData",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "readonly index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "readonly sourceId",
                    "optional": false,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IListMaterializedStats",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "firstMaterialized",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "firstRendered",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "lastMaterialized",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "lastRendered",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IList<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the focus to the given row after scrolling to it. If it's not focusable, it will use `direction` to find the closest one.\r\n@param rowIndex The index of the row to focus.\r\n@param direction Use 1 or -1 to try previous or next rows when given row is not focusable.",
                    "name": "focusRow",
                    "optional": false,
                    "type": "(rowIndex: number, direction?: number): Promise<void>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "scrollIntoView works like the element method in the browser, but instead of being\r\nbased on the element scrollIntoView will scroll the row specified by the rowIndex\r\ninto view.\r\n\r\n@param rowIndex The 0 based rowIndex that should be scrolled into view.\r\n@param options These options are passed on to the underlying element.\r\n@param onScrollComplete This delegate is called when the scrolling is complete.\r\n This may not be immediate if the list has to materialize rows to scroll.\r\n NOTE: The rowIndex passed to the delegate will be the requested rowIndex or\r\n -1 if another scrollIntoView request is made before this scroll request completes.",
                    "name": "scrollIntoView",
                    "optional": false,
                    "type": "(rowIndex: number, options?: ScrollIntoViewOptions, onScrollComplete?: (rowIndex: number) => void) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Returns an object with the indexes of the first and last materialized and rendered rows.",
                    "name": "getStats",
                    "optional": false,
                    "type": "(): IListMaterializedStats"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISelectableUI"
                },
                {
                    "name": "IRowOverlayableUI"
                }
            ]
        },
        {
            "description": "",
            "name": "IListItemDetails<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-busy on the list item element.",
                    "name": "ariaBusy",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-current value if the row matches the requirements of aria-current\r\nMore information: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current",
                    "name": "ariaCurrent",
                    "optional": true,
                    "type": "\"page\" | \"step\" | \"location\" | \"date\" | \"time\" | \"true\" | \"false\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-describedby on the list item element.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabelledBy property enables authors to reference other elements on the page to define an accessible name to assistive\r\ntechnology.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-posinset on the tr element.  Defaults to the item index.",
                    "name": "ariaPosInSet",
                    "optional": true,
                    "type": "number | null"
                },
                {
                    "defaultValue": " 1 The default value is 1 because the aria-rowindex is 1-based instead of 0-based\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Amount to offset the aria-rowindex attribute of a row. This should be added\r\nto the index to produce the aria-rowindex of the row. The common use case for this property\r\nis accounting for the header row of a Table. Per the ARIA spec, a header row should be included in\r\nthe aria-rowcount, and provided an aria-rowindex of 1, meaning the first actual row of the table\r\nneeds an aria-rowindex of 2.",
                    "name": "ariaRowOffset",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-setsize on the tr element.  Defaults to the itemProvider length.",
                    "name": "ariaSetSize",
                    "optional": true,
                    "type": "number | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The data represents the object being rendered in this row. If the caller\r\nhas asynchronous loading of rows, the data MAY be undefined while we wait\r\nfor the data to be resolved.",
                    "name": "data",
                    "optional": true,
                    "type": "T"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An event dispatch the row MAY use to dispatch custom events to list behaviors.",
                    "name": "eventDispatch",
                    "optional": false,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to exclude the list item from the focus zone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If false, the row will get tabIndex=0, otherwise tabIndex=-1.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Properties used to render the list as a whole.",
                    "name": "listProps",
                    "optional": false,
                    "type": "IListProps<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The row MUST call onFocusItem when a row or one of the child elements of the row receives focus.",
                    "name": "onFocusItem",
                    "optional": false,
                    "type": "(rowIndex: number, event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if text in the list row should be selectable.",
                    "name": "selectableText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, will make cursor display as a pointer when hovering over the item otherwise default.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IListProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the list a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.\r\n\r\nThere is simple ArrayItemProvider<T> for those that just have a set of items\r\nthey want to supply without writing a custom ItemProvider.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<T | IReadonlyObservableValue<T | undefined>>"
                },
                {
                    "defaultValue": " 0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Amount to offset the aria-rowcount attribute of a list. This should be added\r\nto the number of items in the list to produce the aria-rowcount. The common use case for this property\r\nis accounting for the header row of a Table. Per the ARIA spec, a header row should be included in\r\nthe aria-rowcount.",
                    "name": "ariaRowOffset",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The number of columns visible to the screen reader.\r\n\r\nBy default this is the value of columnCount",
                    "name": "ariaColumnCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label property for the list.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Behaviors can be added to the list and monitor events and interact with the\r\ncomponent through the IList methods.",
                    "name": "behaviors",
                    "optional": true,
                    "type": "IBehavior<Partial<IListProps<T>>, Partial<IList<T>>>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the list root element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number of columns the list is going to represent. This is important to get\r\ncorrect if the contents are going to show as multi-column since the\r\nvirtualization is emitting elements (non-visible) into the list for paging.\r\n\r\nBy default the list is a single column value.",
                    "name": "columnCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " 0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The index of the row that should be tabbable before the list has received focus.",
                    "name": "defaultTabbableRow",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller can supply an EventDispatch to the list if it wishes to\r\nparticipate it extending the behaviors. If one isn't supplied the list will\r\ncreate its own dispatcher when behaviors are supplied.",
                    "name": "eventDispatch",
                    "optional": true,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element should not be tabable but still should be able to receieve focus.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the list rows are focused.\r\nThe default focuszone if one isn't supplied is a Vertical non-cyclic focus zone.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this list.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "initialPageCount is used when the list is drawing pages and no pages are\r\nvisible. This primarily happens when the list is initially rendered.\r\n\r\nThe impact of setting this value effects performance of the initial render.\r\nSince the component performs 0 measurements it renders the initialPages and\r\nuses the IntersectionObserver to determine whether or not it has filled the\r\ncomponents viewport. This means that in the first pass it will render the\r\nrequested rows and then update the rows after the observer reports on the\r\nvisibility of the rendered pages. If 3 was not enough to fill the UI it will\r\nrender more, but this will happen async.\r\n\r\nThe default is 3 pages with a default of 10 rows per page - 30 rows..",
                    "name": "initialPageCount",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " 100000\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum height of the table when virtualized. Browsers have issues\r\nrendering elements that are too large and when the List contains thousands\r\nof elements, the list renders very large spacer elements to correctly\r\nposition the scroll bar. The large spacer elements cause rendering issues\r\nacross browsers. To bypass this, we need to limit how large the list can\r\ngrow to. By default this size is 100,000px. However, if you have multiple\r\nitems within a scrollable region, this number might need to be reduced.\r\nFor instance, if you have 5 lists that can contain a lot of rows in the\r\nsame scrollable region, you would likely want to set the max height for\r\neach list to 20,000. Keep in mind that the smaller this number, the harder\r\nit will be for a user to scroll with precision.",
                    "name": "maxHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "maxWidth is used to control the maximum width of the list.",
                    "name": "maxWidth",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "minWidth is used to control the minumum width of the list.",
                    "name": "minWidth",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param listRow Details about the list row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus is called when a item in the list is focused. Preventing default\r\non the focus event will prevent row selection from occuring even if\r\nselectOnFocus is set to true.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param listRow Details about the list row being activated.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param listRow - Details about the list row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "pageSize controls the granularity of row rendering. The list always renders\r\na full page worth of rows even when they are not needed to fill the viewport.\r\n\r\nSmaller values will help reduce the number of wasted rows that are rendered\r\noutside the viewport, but will force the list to re-render more often as\r\nscrolling occurs.",
                    "name": "pageSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a row's value is given as an ObservableValue with an undefined value,\r\nthe list will render a Loading row for the content. The default will be\r\na shimmer row that is semi random and matches the content.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param details Additional details about this row.",
                    "name": "renderLoadingRow",
                    "optional": true,
                    "type": "(rowIndex: number, details: IListItemDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "All callers must supply a function for rendering the list row.\r\n\r\nThe requirements of this function are quite complicated and before writing\r\na new row renderer you should ensure one doesnt already exist that solves\r\nyour needs.\r\n\r\nRequirements:\r\n\r\n1) The row function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The row function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.\r\n\r\n3) The row function MUST call onFocusItem when either the row element or\r\nany of the rows child elements receive the focus. This is needed to ensure\r\nnavigation within the list as well as in and out of the list function\r\ncorrectly.\r\n\r\nException: If your list doesn't support row level focus/selection.\r\n\r\n4) The row function MUST add data-row-index on the row element.  This is\r\nneeded to ensure mouse events can be translated to rows.\r\n\r\n5) The row function MAY dispatch events for behaviors but is not required.\r\nIf any events are dispatched they should be documented on the row renderer.\r\n\r\n6) The row function is responsible for all accessibility and focus\r\nmanagement within the row.\r\n\r\nException: If your list doesn't support row level focus/selection.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param item This is the object that represents the current rows data.\r\n@param details Additional details to handle aria attributes and focus.",
                    "name": "renderRow",
                    "optional": false,
                    "type": "(rowIndex: number, item: T, details: IListItemDetails<T>) => JSX.Element | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Lists MAY render a header above the list contents. This is done through the\r\nonRenderHeader. Like the renderRow method, there are set of restrictions the\r\nimplmentation MUST follow.\r\n\r\nRequirements:\r\n\r\n1) The header function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The header function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.",
                    "name": "renderHeader",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role defines the aria role of the list and defaults to \"listbox\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller has variable height rows they can specify the rowHeight they\r\nwant used to estimate the size of virtualized rows. This means that when rows\r\nare not rendered, the component will create virtual space for those rows to\r\nensure the scrolling behavior acts appropriately.\r\n\r\nIf the list has fixed size rows there is no need to specify a rowHeight. The\r\nlist will determine the height of the rows after the initial render when\r\nthe observer reports on page visibility.\r\n\r\nQuestion: How do I determine the rowHeight if their are variable height rows.\r\nThis one is a tough question, and the general answer is come up with a fair\r\naverage for the rows on a given page. If the select too large or too small\r\nscrolling behaviors can become a bit odd, generally select on the smaller\r\nside if you are unsure.",
                    "name": "rowHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An array of heights to be used when calculating the spacer heights.  If not supplied, the heights used\r\nwill be estimations.",
                    "name": "rowHeights",
                    "optional": true,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to allow text selection on all list rows.",
                    "name": "selectableText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the list selection. This\r\nis not required since the list offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IListSelection that supports multi\r\nselect.  Selection should be specified on mount if used and not updated to\r\na new object during the List's lifecycle.\r\n\r\nThere is a basic ListSelection implementation available from the List\r\ncomponent.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the list select a row when it is clicked?\r\nProvides a way to turn off row-click selection when necessary, for things like\r\nTable with singleClickActivation",
                    "name": "selectRowOnClick",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether we should allow scrolling on this list\r\nIf false, we will add scroll-hidden css class to the list",
                    "name": "showScroll",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If virtualize false is supplied the list will render all the items supplied\r\nto it. This shouldn't be used unless you know you have a limited number of\r\nrows. Virtualization is used to avoid performance problems.",
                    "name": "virtualize",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "width can be any supported css width value, either a %, px, and vw value.",
                    "name": "width",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This determines which element will be used for the overlay instead of the default element.\r\nThe format expected here is the CSS selector.",
                    "name": "overlay",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISimpleListCell",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "iconProps for the icon within the cell.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "text that should within the cell.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional node that will render instead of the text string.\r\nSeparate to preserve needed access to the text like with sorting.",
                    "name": "textNode",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optionally className that should be applied to the text.",
                    "name": "textClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A link that should be applied to the text of the cell.",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional.  Where to display the linked URL, as the name for a browsing context.  Used only if href is defined.\r\nSee https://developer.mozilla.org/docs/Web/HTML/Element/a for more information.",
                    "name": "hrefTarget",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional.  The relationship of the linked URL as space-separated link types.  Used only if href is defined.\r\nSee https://developer.mozilla.org/docs/Web/HTML/Element/a for more information.",
                    "name": "hrefRel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IScrollableListProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onScroll is called when the list is scrolled. This event is not throttled.\r\n\r\n@param event Scroll event details",
                    "name": "onScroll",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Scrollable List has an outer div. Use this to add classes to it. Use className to\r\nadd classes to the inner list element.",
                    "name": "outerClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListProps<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "ISimpleListProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "scrollable should be set to true if the list is not contained in a\r\nscrolling element. This will ensure the list scrolls vertically within\r\nthe list element itself.",
                    "name": "scrollable",
                    "optional": true,
                    "type": "true"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListProps<ISimpleListCell | string | number>",
                    "properties": []
                },
                {
                    "name": "\"renderRow\">>"
                }
            ]
        },
        {
            "description": "",
            "name": "IListItemProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class that will be added to the list item.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Details about the list item being rendered. This is given to the caller\r\nwhen a row needs to be rendered.",
                    "name": "details",
                    "optional": false,
                    "type": "IListItemDetails<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Index of the row that is being rendered.",
                    "name": "index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": true,
                    "deprecatedMessage": " Please add links within the cell. Rows rendered as links is an inaccessible pattern and support will be removed in future versions. ",
                    "description": "",
                    "name": "linkProps",
                    "optional": true,
                    "type": "ILinkProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of represented work item",
                    "name": "itemId",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Desired tab index",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/List/ListDragImage.Props.d.ts": [
        {
            "description": "",
            "name": "IListDragImageProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional icon props to show in the drag image",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to appear as part of the drag image",
                    "name": "text",
                    "optional": false,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/List/ListDropIndicator.Props.d.ts": [
        {
            "description": "",
            "name": "ListDropIndicatorPosition",
            "properties": [
                {
                    "defaultValue": "\"bottom\"",
                    "description": "",
                    "name": "bottom",
                    "type": "string"
                },
                {
                    "defaultValue": "\"top\"",
                    "description": "",
                    "name": "top",
                    "type": "string"
                },
                {
                    "defaultValue": "\"left\"",
                    "description": "",
                    "name": "left",
                    "type": "string"
                },
                {
                    "defaultValue": "\"right\"",
                    "description": "",
                    "name": "right",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IListDropIndicatorProps",
            "properties": [
                {
                    "defaultValue": " bottom\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether the indicator is appearing at the top, or the bottom, or sides of its containing element.",
                    "name": "position",
                    "optional": true,
                    "type": "ListDropIndicatorPosition"
                },
                {
                    "defaultValue": " 0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How much to offset where the circle is rendered on the horizontal axis",
                    "name": "xOffset",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " 0\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How much to offset the line horizontally when it is vertical",
                    "name": "lineOffset",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ListBox/ListBox.Props.d.ts": [
        {
            "description": "",
            "name": "IListBoxProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "className to pass to the listbox.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to be called after the listBox renders.",
                    "name": "didUpdate",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to exclude all listbox rows from focus zones.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to remove tab stops from the listbox rows.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the list box rows are focused.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event - This is the event that is causing the activation.\r\n@param tableRow - Details about the table row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to display a column with checks or checkboxes for selected items.\r\nFalse by default, unless `props.selection.multiSelect` which makes it default true.",
                    "name": "showChecksColumn",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListBoxSharedProps<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "IListBoxSharedProps<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tree columns if showTree is passed",
                    "name": "columns",
                    "optional": true,
                    "type": "ITreeColumn<IListBoxItem<T>>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "className to pass to the listbox's container.",
                    "name": "containerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is called when updates are made to the listBox items to update the unselectbale items in the selection.",
                    "name": "getUnselectableRanges",
                    "optional": true,
                    "type": "(items: IListBoxItem<T>[]) => ISelectionRange[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller may supply the set of items to be shown through the ItemProvider or array.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the listbox a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.  Use an IItemProvider or something that implements it like ObservableArray\r\nIf the items will be changing.",
                    "name": "items",
                    "optional": false,
                    "type": "IItemProvider<IListBoxItem<T>> | IListBoxItem<T>[] | string[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true or false to trigger screen reader loading announcements.  To show a loading indicator, pass an item of type ListBoxItemType.Loading in items.",
                    "name": "loading",
                    "optional": true,
                    "type": "boolean | Observable<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onToggle is called when an item is either expanded or collapsed. This will only do anything if the list box is being displayed as a tree.\r\n\r\n@param event - This is the event that is causing the toggle.\r\n@param treeItem - Details about the list item being toggled.",
                    "name": "onToggle",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param item - Details about the list row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided, this will be called on each item to determine how it's rendered.",
                    "name": "renderItem",
                    "optional": true,
                    "type": "(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IListBoxItem<T>>, tableItem: IListBoxItem<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to show a searching indicator in place of the list and make a screenreader announcement.  Set to null to cancel a search without making\r\nan announcement.",
                    "name": "searching",
                    "optional": true,
                    "type": "boolean | Observable<boolean | null>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to show when a search is in progress.",
                    "name": "searchResultsLoadingText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selection maintains the selected state and defines the selection behavior of the list box.  Defaults to a ListSelection\r\nwith selectOnFocus set to false if not provided.  Selection should be specified on mount and not updated to a new object\r\nduring the Listbox's lifecycle.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to show any current items while searching for more.",
                    "name": "showItemsWhileSearching",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not to display items as a tree rather than a list\r\nListBox will construct a tree using the parent field of ListBoxItems",
                    "name": "showTree",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " 100%\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The width of the listbox.",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IListBoxItem<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the element to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "className to pass to the item's cell.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional item data to be used in custom render function.",
                    "name": "data",
                    "optional": true,
                    "type": "T"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Disabled items will get a disabled style by default and be ignored by focus and selection.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Expand this item when ListBox builds the tree",
                    "name": "expanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide to indicate this item belongs to a group.  Use a GroupedItemProvider to arrange grouped items.\r\nThis id is passed to the header html element for the group so it should be a valid html id.",
                    "name": "groupId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide to render the item as a Link.",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props specifying the icon to render beside the item text.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique identifier of the item.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional parent of this item, used to build a tree in ListBox",
                    "name": "parent",
                    "optional": true,
                    "type": "IListBoxItem<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to render in the item's row.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip props to apply to the ListBox row for this item.  By default, an overflow tooltip is\r\nrendered with the item's text.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A function to render custom item content.",
                    "name": "render",
                    "optional": true,
                    "type": "(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IListBoxItem<T>>, tableItem: IListBoxItem<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The type of list item.  Headers and Separators ignore focus and selection.",
                    "name": "type",
                    "optional": true,
                    "type": "ListBoxItemType"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IListBoxGroup<T = {}>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique identifier for the group.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to indicate this group is loading.  The GroupedItemProvider will check this value and add a loading cell if true.",
                    "name": "loading",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provide a custom loading item to be added if loading is true.",
                    "name": "loadingItem",
                    "optional": true,
                    "type": "IListBoxItem<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Display name for the group.  Not needed if you are supplying your own header items.",
                    "name": "name",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ListBoxItemType",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Row",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "Header",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "",
                    "name": "Divider",
                    "type": "number"
                },
                {
                    "defaultValue": "4",
                    "description": "",
                    "name": "Loading",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ILoadingCellProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The index of the column this cell is being rendered in.",
                    "name": "columnIndex",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The column this cell is being rendered in.",
                    "name": "tableColumn",
                    "optional": false,
                    "type": "ITableColumn<IListBoxItem<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The listbox item associated with this cell.",
                    "name": "tableItem",
                    "optional": false,
                    "type": "IListBoxItem<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function to call after the row has finished rendering.  Use this to trigger data fetching.",
                    "name": "onMount",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/MasterPanel/MasterPanel.Props.d.ts": [
        {
            "description": "",
            "name": "IMasterPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to emit onto the root MasterPanel element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to always show the master panel on small screens.  By default the master panel will hide,\r\nand the details panel can be replaced with a fullscreen master panel by calling\r\nmasterPanelContext.setDetailsPanelVisibility(false)",
                    "name": "showOnSmallScreens",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMasterPanelInternalProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Current master details context layer.",
                    "name": "layer",
                    "optional": false,
                    "type": "IMasterDetailsContextLayer<any>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMasterPanelProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IMasterPanelHeaderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional subtitle text",
                    "name": "subTitle",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Title text to display",
                    "name": "title",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional number to specify the aria level.  Defaults to 1.",
                    "name": "titleAriaLevel",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Measure/Measure.Props.d.ts": [
        {
            "description": "",
            "name": "IMeasureProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Event hook for window resize or render completion to allow measuring of the rendered child",
                    "name": "onMeasure",
                    "optional": true,
                    "type": "(newWidth: number, newHeight: number) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Menu/Menu.Props.d.ts": [
        {
            "description": "",
            "name": "IMenuItemDetails",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "expandedIndex defines whether or not the menu item should render subMenu's",
                    "name": "expandedIndex",
                    "optional": false,
                    "type": "IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The instance of the menu is passed to through the menu details.",
                    "name": "menu",
                    "optional": false,
                    "type": "IMenu"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props used to render this menu.",
                    "name": "menuProps",
                    "optional": false,
                    "type": "IMenuProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method the menu item can use to notify the menu that the menu item was activated.",
                    "name": "onActivate",
                    "optional": false,
                    "type": "(menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu item can receive focus, it MUST call onFocusItem when it does.",
                    "name": "onFocusItem",
                    "optional": false,
                    "type": "(index: number, event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria position in the set.",
                    "name": "position",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria setsize for the menu items.",
                    "name": "setSize",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMenu",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "expandItem can be called to set the given menu item to an expanded state.\r\nThis is generally used when the menu item has a sub menu. Many menu items\r\nwill not do anything in the expanded state.",
                    "name": "expandItem",
                    "optional": false,
                    "type": "(menuItem: IMenuItem | null, expanded: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu is a subMenu, you can get the parent menu. If this is a root\r\nmenu undefined is returned.",
                    "name": "getParent",
                    "optional": false,
                    "type": "(): IMenu | undefined"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFocusable<{}>"
                }
            ]
        },
        {
            "description": "",
            "name": "MenuItemType",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "This uses the standard five column menu item.",
                    "name": "Normal",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "This will render a divider line between the previous and next item.\r\nA divider will only appear if the previous and next item are non-dividers.\r\nConsecutive dividers will be merged to a single divider.",
                    "name": "Divider",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "A special menu item that shows a header styled menu item in the PrimaryText column.",
                    "name": "Header",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "MenuCell",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "The state column is used to represent the state of the menu item. This is\r\nusually either a read-only or read-write checkbox.",
                    "name": "State",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "This is an Icon prefix used to represent the menu item.",
                    "name": "Icon",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "Primary text that describes the menu item. Often this will be the only\r\ncolumn that has a value.",
                    "name": "PrimaryText",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "Secondary text is a column that is generally used to represent things\r\nlike hot-keys/accelerators.",
                    "name": "SecondaryText",
                    "type": "number"
                },
                {
                    "defaultValue": "4",
                    "description": "Action column is used to give the user a way to represent a secondary\r\nway to interact with the menu. This may be things like the submenu icon\r\nor some other ui the user can independantly interact with.",
                    "name": "Action",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IMenuItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label for the menu item.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class added to the menu item row element in the default rendering.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "State of the menu item. This will render a checkbox if not readonly, and if\r\nthis is true and readonly it will render a Checkmark.",
                    "name": "checked",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional data attached to the menu item that can be used by the caller to\r\naccess during rendering or events.",
                    "name": "data",
                    "optional": true,
                    "type": "any"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "disabled menu items will render in a disabled style and they can't be activated.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu item is grouped with others they should all set the same groupKey.",
                    "name": "groupKey",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Hidden items will not be shown.",
                    "name": "hidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A menu item can act as an anchor tag by setting an href value.",
                    "name": "href",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "iconProps are used to render the Icon column.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Each menu item is required to define a unique id.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The built-in rendering type for the menu item. If a custom render method is\r\nsupplied the itemType is ignored.",
                    "name": "itemType",
                    "optional": true,
                    "type": "MenuItemType"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the user activates the menu item. This may be\r\nclicking on it, or using the keyboard to activate it.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => boolean | void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "rank is used to order the menu items within its group. If the menu item is not\r\ngrouped it will be ordered in the undefined group which occurs at the end of\r\nthe menu. If no menu items are grouped, this is used as the global ranking.",
                    "name": "rank",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "readonly is used to define whether the state of the menu item should be\r\nchangable from the menu item itself, or only an indicator.",
                    "name": "readonly",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "rel is used when the menu item is a link. It allows the caller to define how\r\nthe rel attribute is set. This applies when a target is specified as well.",
                    "name": "rel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller wants to custom render the cells for a given menu item they\r\ncan override this method. This means the override MUST take ownership of\r\nall relevant columns.\r\n\r\n@param menuCell is used to communicate which cell is being rendered.\r\n@param menuItem is the item that represents the current menu row.\r\n@param details is the details about this menu item.",
                    "name": "renderMenuCell",
                    "optional": true,
                    "type": "(menuCell: MenuCell, menuItem: IMenuItem, details: IMenuItemDetails) => JSX.Element | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller wants to custom render the entire row including the row\r\nelement this method can be used. The caller MUST handle all the requirements\r\nas follows:\r\n\r\n1) The row function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The row function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.\r\n\r\n3) The row function MUST call onFocusItem when a either the row element of\r\nany of the rows child elements receive focus. This is needed to ensure\r\nnavigation within the menu as well as in and out of the menu function\r\ncorrectly.\r\n\r\n4) The row function is responsible for all accessibility and focus\r\nmanagement within the row.\r\n\r\n@param index The menu item index being rendered.\r\n@param menuItem The menu item being rendered.\r\n@param details Details about the row and menu.",
                    "name": "renderMenuItem",
                    "optional": true,
                    "type": "(index: number, menuItem: IMenuItem, details: IMenuItemDetails) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The secondary text can be a string or other React components used to represent\r\nthis columns value.",
                    "name": "secondaryText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu item represents a sub menu it should have its sub menu props.",
                    "name": "subMenuProps",
                    "optional": true,
                    "type": "IMenuProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "target can be used to define how a menu item that is a link should be opened.",
                    "name": "target",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Primary text of the menu item. This can be a string, or other React components.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMenuProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label for the menu.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class added to the root element of the menu.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Predefined groups for the menu items. Groups do not have to be predefined,\r\nbut they must be in order to specify additional properties.",
                    "name": "groups",
                    "optional": true,
                    "type": "IMenuGroup[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "All menus MUST have a unique id.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set of menu items that should be rendered. This can either be an array or an\r\nobservable array of items. Use an observable when the set may be changed while\r\nthe menu is rendered.",
                    "name": "items",
                    "optional": false,
                    "type": "IMenuItem[] | IReadonlyObservableArray<IMenuItem>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the user activates a given menu item.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu is created a subMenu of an existing menu it will be given a parent\r\nmenu.",
                    "name": "parentMenu",
                    "optional": true,
                    "type": "IMenu"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IContextualMenuProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element the contextual menu is relative to. A common example is a\r\nMenuButton, where the menu appears below the button.\r\n(anchorOrigin should be supplied with anchorElement)",
                    "name": "anchorElement",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Offset from the anchor position (element or point) for the contextual menu.",
                    "name": "anchorOffset",
                    "optional": true,
                    "type": "IOffset"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Location on the anchor element the menu should align its menuOrigin.",
                    "name": "anchorOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An absolute point to open the menu. This may be used to open a contextual\r\nmenu when right click occurs, it would open at the mouse location.",
                    "name": "anchorPoint",
                    "optional": true,
                    "type": "IPoint"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the callout rendered by menu.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "fixedLayout can be used to avoid re-layout. This is not recommended. This\r\nwill prevent the callout from moving and it the callout is clipped it will\r\nremain clipped.",
                    "name": "fixedLayout",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Where on the menu to align with the anchor.",
                    "name": "menuOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Details about the menu being shown.",
                    "name": "menuProps",
                    "optional": false,
                    "type": "IMenuProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the user activates a given menu item.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onDismiss is called when the contextual menu should be dismissed. If dismisAll\r\nis supplied this should notify any parent menu that it should be dismissed as\r\nwell.",
                    "name": "onDismiss",
                    "optional": true,
                    "type": "(dismissAll: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the menu is created a subMenu of an existing menu it will be given a parent\r\nmenu.",
                    "name": "parentMenu",
                    "optional": true,
                    "type": "IMenu"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should this menu be treated as a sub menu of an existing menu. This\r\ngenerally shouldnt be supplied when opened a root menu.",
                    "name": "subMenu",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMenuGroup",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Key used to identify the group, maps to IMenuItem.groupKey.",
                    "name": "key",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the order groups should be displayed in (lowest first, undefined and 0 last)",
                    "name": "rank",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMenuItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The details about the given menu item.",
                    "name": "details",
                    "optional": false,
                    "type": "IMenuItemDetails"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "index of the menu item in the menu.",
                    "name": "index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The actual menu item object.",
                    "name": "menuItem",
                    "optional": false,
                    "type": "IMenuItem"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Menu/MenuButton.Props.d.ts": [
        {
            "description": "",
            "name": "IMenuButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Properties for the menu that appears when the dropdown is shown.",
                    "name": "contextualMenuProps",
                    "optional": false,
                    "type": "IContextualMenuProps | (() => IContextualMenuProps)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If hideDropdownIcon is supplied the button acts as a dropdown button\r\nwithout showing the dropdown arrows.",
                    "name": "hideDropdownIcon",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is collapsed.",
                    "name": "onCollapse",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to call when the dropdown is expanded.",
                    "name": "onExpand",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IButtonProps"
                },
                {
                    "name": "IExpandableButtonProps",
                    "properties": [
                        "buttonClassName"
                    ]
                }
            ]
        }
    ],
    "azure-devops-ui/Components/MessageBar/MessageBar.Props.d.ts": [
        {
            "description": "",
            "name": "MessageBarSeverity",
            "properties": [
                {
                    "defaultValue": "\"Info\"",
                    "description": "",
                    "name": "Info",
                    "type": "string"
                },
                {
                    "defaultValue": "\"Warning\"",
                    "description": "",
                    "name": "Warning",
                    "type": "string"
                },
                {
                    "defaultValue": "\"Error\"",
                    "description": "",
                    "name": "Error",
                    "type": "string"
                },
                {
                    "defaultValue": "\"Success\"",
                    "description": "",
                    "name": "Success",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IMessageBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional props for custom buttons",
                    "name": "buttonProps",
                    "optional": true,
                    "type": "IButtonProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional custom class name",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional override icon props\r\nDefault value depends on @see severity",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name for the message container",
                    "name": "messageClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional handler for any dismissal of the button",
                    "name": "onDismiss",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": " Info\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Severity for the MessageBar - regulates color and default icon",
                    "name": "severity",
                    "optional": true,
                    "type": "MessageBarSeverity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role prop\r\nIf not set, will default to alert for Error or Warning severity levels @see severity",
                    "name": "role",
                    "optional": true,
                    "type": "\"alert\" | \"banner\""
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/MessageCard/MessageCard.Props.d.ts": [
        {
            "description": "",
            "name": "MessageCardSeverity",
            "properties": [
                {
                    "defaultValue": "\"Info\"",
                    "description": "",
                    "name": "Info",
                    "type": "string"
                },
                {
                    "defaultValue": "\"Warning\"",
                    "description": "",
                    "name": "Warning",
                    "type": "string"
                },
                {
                    "defaultValue": "\"Error\"",
                    "description": "",
                    "name": "Error",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IMessageCardProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional props for custom buttons",
                    "name": "buttonProps",
                    "optional": true,
                    "type": "IButtonProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional custom class name",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional override icon props\r\nDefault value depends on @see severity",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to emit onto the internal message bar",
                    "name": "messageBarClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional handler for any dismissal of the button",
                    "name": "onDismiss",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": " Info\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Severity for the MessageBar - regulates color and default icon",
                    "name": "severity",
                    "optional": true,
                    "type": "MessageCardSeverity"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role prop\r\nIf not set, will default to alert for Error or Warning severity levels @see severity",
                    "name": "role",
                    "optional": true,
                    "type": "\"alert\" | \"banner\""
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/MouseWithin/MouseWithin.Props.d.ts": [
        {
            "description": "",
            "name": "IMouseWithin",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "hasMouse",
                    "optional": false,
                    "type": "() => boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMouseWithinEvents",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMouseWithinProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An enterDelay can be specified to control how long the mouse must be over\r\nthe component before the onMouseEnter delegate is called.",
                    "name": "enterDelay",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A leaveDelay can be specified to control how long the mouse must be out of\r\nthe component before the onMouseLeave delegate is called.",
                    "name": "leaveDelay",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If updateStateOnMouseChange is set to true, the MouseWithin component will update\r\nthe state of the component and cause a re-render of the sub-tree when the mouse enters\r\nof leaves the component.",
                    "name": "updateStateOnMouseChange",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMouseWithinEvents"
                }
            ]
        },
        {
            "description": "",
            "name": "IMouseWithinStatus",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "hasMouse",
                    "optional": false,
                    "type": "boolean"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMouseWithinEvents"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Observer/ItemsObserver.Props.d.ts": [
        {
            "description": "",
            "name": "IItemsObserverProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selection object to update when the items change.",
                    "name": "selection",
                    "optional": false,
                    "type": "ISelection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The items to observe.",
                    "name": "items",
                    "optional": false,
                    "type": "IItemProvider<T> | T[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The function that's used to get the unselectable ranges from the item set.",
                    "name": "getUnselectableRanges",
                    "optional": false,
                    "type": "(items: T[]) => ISelectionRange[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "children",
                    "optional": false,
                    "type": "React.ReactElement"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Observer/Observer.Props.d.ts": [
        {
            "description": "",
            "name": "IObservableExpression<T = any>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using an observableExpression you can sign up for an action instead of\r\nall actions which is the default.",
                    "name": "action",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "filter function that determines whether or not an action should affect\r\nthe state of the Observer.\r\n\r\n@param value The observable value that is being supplied for the action.\r\n@param action The action that has taken place.\r\n\r\n@returns true if the Observer should setState, false if the change should\r\nbe ignored.",
                    "name": "filter",
                    "optional": true,
                    "type": "(value: ObservedArgs<T>, action: string) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The observableValue is the value being observed. When actions are fired,\r\nthe filter is called and the results determine whether the component\r\nchanges state.",
                    "name": "observableValue",
                    "optional": false,
                    "type": "T | IObservableLikeValue<T> | IObservableLikeArray<ArrayMember<T>>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IUncheckedObserverProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called whenever componentDidUpdate is run by the Observer\r\n(after subscriptions have been updated).\r\nUseful in situations where you need to be notified when Observer updates\r\nhappen, but don't want to insert a new component just for the lifecycle methods.",
                    "name": "onUpdate",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "All props that should be passed down to the child element.\r\nThese properties are IObservableLikeValues, meaning that if they are observable,\r\nwe will attempt to subscribe to their changes.",
                    "name": "[propName",
                    "optional": false,
                    "type": "string]: IObservableLikeValue<any> | IObservableExpression"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Observer/ReadyableArrayObserver.Props.d.ts": [
        {
            "description": "",
            "name": "IReadyableArrayObserverProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The readyable array to observe. This component will use the ready value of this array to\r\nlisten for changes and call the appropriate render method.",
                    "name": "data",
                    "optional": false,
                    "type": "IReadyableReadonlyObservableArray<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This function will be called with the data once it is ready, as long as data exists.",
                    "name": "dataComponent",
                    "optional": false,
                    "type": "(data: T[]) => JSX.Element | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This function will be called if the data is not ready.",
                    "name": "loadingComponent",
                    "optional": true,
                    "type": "() => JSX.Element | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback that is called once the data is ready. This can be during componentDidMount if\r\nthe component has data at the first render pass. Or it will be called from an onUpdate call\r\nfrom the underlying Observer, once the data is ready.",
                    "name": "onReady",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This function will be called if the data is ready, but there is no data.",
                    "name": "zeroDataComponent",
                    "optional": true,
                    "type": "() => JSX.Element | null"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Observer/SelectionObserver.Props.d.ts": [
        {
            "description": "",
            "name": "ISelectionObserverProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selection object to observe.",
                    "name": "selection",
                    "optional": false,
                    "type": "ISelection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to make when the selection changes.  Return true to update the child component.",
                    "name": "onSelectionChanged",
                    "optional": true,
                    "type": "(newSelection: ISelectionRange[], action: string) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A callback to make when a a new item is selected.  Return true to update the child component.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(selectedIndices: ISelectionRange[]) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "children",
                    "optional": false,
                    "type": "React.ReactNode"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Page/Page.Props.d.ts": [
        {
            "description": "",
            "name": "Orientation",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Vertical",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Horizontal",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IPageProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional root classname for the page element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Describes if the page should render elements in a flex-row\r\nor flex-column",
                    "name": "orientation",
                    "optional": true,
                    "type": "Orientation"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional ref to the scrollable container for the page.",
                    "name": "scrollableContainerRef",
                    "optional": true,
                    "type": "React.RefObject<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tracks the selected tab id within the page.",
                    "name": "selectedTabId",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A list of providers contributing tab groups to the page.",
                    "name": "tabGroups",
                    "optional": true,
                    "type": "IReadonlyObservableArray<ITabGroup>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A list of providers contributing tabs to the page.",
                    "name": "tabProviders",
                    "optional": true,
                    "type": "IReadonlyObservableArray<IVssContributedTab>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback triggered when page's scroll event occurs.",
                    "name": "onScroll",
                    "optional": true,
                    "type": "React.UIEventHandler<HTMLDivElement>"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Panel/Panel.Props.d.ts": [
        {
            "description": "",
            "name": "IPanel",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "animateOut",
                    "optional": false,
                    "type": "(): Promise<void>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "PanelCloseButtonSize",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "small",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "large",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If these props are provided, the panel's header will draw a back button before the panel\r\nheader's title. By default this will use a subtle button with the \"Back\" icon,\r\nbut these props can override those choices.",
                    "name": "backButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, description of panel.",
                    "name": "description",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, display description item in lieu of panel description.",
                    "name": "descriptionItem",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional list of props to render as Buttons in the footer.",
                    "name": "footerButtonProps",
                    "optional": true,
                    "type": "IButtonProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content to render while the panel is in a loading / working state.\r\nShould typically be called with a <Spinner />:\r\noverlayContent={<Spinner label=\"Run starting...\" />}\r\n\r\nWhen this prop is defined, lightDismiss will be forced to false.",
                    "name": "overlayContent",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the panel should show a separator between the header and the content",
                    "name": "showSeparator",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The panel title you want to display.",
                    "name": "titleProps",
                    "optional": true,
                    "type": "IPanelTitleProps"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICustomPanelProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ICustomPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Label used to describe the contents of the panel for aria enabled devices.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of the element used to describe the contents of the panel for aria enabled devices.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This will dismiss the panel once it gets and then loses focus. Panels should\r\ndismiss when they lose focus unless they are intended to be modeless UI.",
                    "name": "blurDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css classname that shold be applied to the callout's root element.",
                    "name": "calloutClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the root Panel element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that should be applied to the callout's content element.",
                    "name": "contentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Element selector of the first focusable element. If no selector is supplied a hidden\r\nelement will be created and focus given to the CommandBarFlyout through this element.",
                    "name": "defaultActiveElement",
                    "optional": true,
                    "type": "string | (() => string)"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The panel will handle keyboard events and when the escape key is pressed the\r\npanel will close if the the event hasnt had the defaultPrevented.",
                    "name": "escDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "DOM element id.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The panel element will trap mouse events and dismiss the panel when a click\r\noccurs. This will prevent the events from being handled by the underlying\r\nelements outside the panel's contents.",
                    "name": "lightDismiss",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The panel element will be given a class that is a semi-transparency that helps\r\nthe user understand the user should focus on the panel and dismiss it before\r\ninteracting with the underlying document.",
                    "name": "modal",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The delegate to handle dismissing the panel. This will be called when the user clicks the close button on the panel.",
                    "name": "onDismiss",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The portalProps allow the caller to control how the Callout's portal are\r\nconfigured. The default will create the portal as a full screen element\r\nrooted in the body.",
                    "name": "portalProps",
                    "optional": true,
                    "type": "IPortalProps"
                },
                {
                    "defaultValue": " ContentSize.Medium\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Size of the panel.",
                    "name": "size",
                    "optional": true,
                    "type": "ContentSize"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelHeaderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If these props are provided, the panel's header will draw a back button before the panel\r\nheader's title. By default this will use a subtle button with the \"Back\" icon,\r\nbut these props can override those choices.",
                    "name": "backButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the Panel Header element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " PanelCloseButtonSize.large\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Size of the 'X' close button.",
                    "name": "closeButtonSize",
                    "optional": true,
                    "type": "PanelCloseButtonSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, description of panel.",
                    "name": "description",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The delegate to handle dismissing the panel. This will be called when the user clicks the close button on the panel.",
                    "name": "onDismiss",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": ": true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the header should show a close button.",
                    "name": "showCloseButton",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the panel should show a separator between the header and the content",
                    "name": "showSeparator",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The panel title you want to display.",
                    "name": "titleProps",
                    "optional": true,
                    "type": "IPanelTitleProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelOverlayProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content to render while the panel is in a loading / working state.\r\nShould typically be called with a <Spinner />:\r\noverlayContent={<Spinner label=\"Run starting...\" />}",
                    "name": "overlayContent",
                    "optional": true,
                    "type": "React.ReactNode"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelTitleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the title",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional icon props to pass to the title",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional id used for the title's text. Should only be used if there is a custom element\r\nto use as the label for the panel.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional size to render the panel's title",
                    "name": "size",
                    "optional": true,
                    "type": "TitleSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional title to display for the panel",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelCloseButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the Panel's close button element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The delegate to handle dismissing the panel. This will be called when the user clicks the close button on the panel.",
                    "name": "onDismiss",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": " PanelCloseButtonSize.large\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional size to render the panel close button.",
                    "name": "size",
                    "optional": true,
                    "type": "PanelCloseButtonSize"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelContentProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the Panel's content element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPanelFooterProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional className to pass to the Panel's footer element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the panel should show a separator between the content and the footer",
                    "name": "showSeparator",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional list of props to render as Buttons in the footer.",
                    "name": "buttonProps",
                    "optional": true,
                    "type": "IButtonProps[]"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Persona/Persona.Props.d.ts": [
        {
            "description": "",
            "name": "PersonaSize",
            "properties": [
                {
                    "defaultValue": "16",
                    "description": "",
                    "name": "size16",
                    "type": "number"
                },
                {
                    "defaultValue": "20",
                    "description": "",
                    "name": "size20",
                    "type": "number"
                },
                {
                    "defaultValue": "24",
                    "description": "",
                    "name": "size24",
                    "type": "number"
                },
                {
                    "defaultValue": "32",
                    "description": "",
                    "name": "size32",
                    "type": "number"
                },
                {
                    "defaultValue": "40",
                    "description": "",
                    "name": "size40",
                    "type": "number"
                },
                {
                    "defaultValue": "72",
                    "description": "",
                    "name": "size72",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IIdentityConnections",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "directReports",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "successors",
                    "optional": true,
                    "type": "IIdentity[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "managers",
                    "optional": true,
                    "type": "IIdentity[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IIdentity",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "active",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "department",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "description",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "displayName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "entityId",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "entityType",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "guest",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "image",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isHosted",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "isMru",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "jobTitle",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "localDirectory",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "localId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "mail",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "mailNickname",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "manager",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "originDirectory",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "originId",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "physicalDeliveryOfficeName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "samAccountName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "scopeName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "signInAddress",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "subjectDescriptor",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "surname",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "telephoneNumber",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IBasicIdentityRef",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Display name of the identity",
                    "name": "displayName",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique ID that the PersonaProvider can be used to look up complete information for the identity",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity image url",
                    "name": "imageUrl",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IIdentityDetailsProvider",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request connection information about a given Entity.",
                    "name": "onRequestConnectionInformation",
                    "optional": false,
                    "type": "(entity: IIdentity, getDirectReports?: boolean) => IIdentityConnections | PromiseLike<IIdentityConnections>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Request Entity information given an entityId",
                    "name": "getEntityFromUniqueAttribute",
                    "optional": false,
                    "type": "(entityId: string) => IIdentity | PromiseLike<IIdentity>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IPersonaProvider",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "renderIdentityCard",
                    "optional": true,
                    "type": "(\r\n        identity: IIdentity | IBasicIdentityRef,\r\n        personaDetailsProvider: IIdentityDetailsProvider,\r\n        onDismissCallback: () => void,\r\n        target: HTMLElement | undefined\r\n    ) => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IIdentityDetailsProvider"
                }
            ]
        },
        {
            "description": "",
            "name": "IPeoplePickerProvider",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Add identities to the MRU\r\n@returns A promise that returns true if successful false otherwise",
                    "name": "addIdentitiesToMRU",
                    "optional": true,
                    "type": "(identities: IIdentity[]) => Promise<boolean>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Given a list of currently selected items and a filter string, return a list of suggestions to put in the suggestion list",
                    "name": "onFilterIdentities",
                    "optional": false,
                    "type": "(filter: string, selectedItems?: IIdentity[]) => IIdentity[] | PromiseLike<IIdentity[]> | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If no input is in the search box when clicked, provide a set of identities to show (used for MRU)",
                    "name": "onEmptyInputFocus",
                    "optional": true,
                    "type": "() => IIdentity[] | PromiseLike<IIdentity[]> | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Add identities to the MRU\r\n@returns A promise that returns true if successful false otherwise",
                    "name": "removeIdentitiesFromMRU",
                    "optional": true,
                    "type": "(identities: IIdentity[]) => Promise<boolean>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IIdentityDetailsProvider"
                }
            ]
        },
        {
            "description": "",
            "name": "IPersonaProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the aria-label for the persona.\r\nDefaults to the identity's display name.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets aria-hidden for the persona",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ClassName of the persona",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Size of image to display. Use IdentitySize presets.",
                    "name": "size",
                    "optional": true,
                    "type": "PersonaSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identity to show the coin from.",
                    "name": "identity",
                    "optional": false,
                    "type": "IIdentity | IBasicIdentityRef"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provides information about an identity.",
                    "name": "personaProvider",
                    "optional": true,
                    "type": "IPersonaProvider"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ARIA role for the persona.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom tooltip props to be passed along to the Coin rendered by the Persona. Null indicates that no tooltip should be used.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps | null"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Pill/Pill.Props.d.ts": [
        {
            "description": "",
            "name": "PillSize",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "compact",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "regular",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "large",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "PillVariant",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "standard",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "outlined",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "colored",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "themedStandard",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IPillProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether the Pill should apply aria-hidden={true} to hide the element from screen readers.\r\nThis should only be done if some other element is responsible for reading the contents of the Pill.",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria label to pass to the pill.  Will default to the this.props.children if this.props.children is a string.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to emit on the root element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to emit on the content",
                    "name": "contentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Background color for the pill\r\nIgnored unless variant is set to Colored\r\nIf variant is set to Colored and this is not provided, we'll render as Standard and emit a warning to the console",
                    "name": "color",
                    "optional": true,
                    "type": "IColor"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to set if the pill is displaying a count of something",
                    "name": "containsCount",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element has been exluded from a current focusZone by default.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element should not be tabable but still should be able to receieve focus.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props used to render the pill icon\r\nIf a filled visual is provided as well, we only render the visual\r\nand will emit a warning to the console\r\nUsing with Size = PillSize.Compact will result in no icon being rendered and a warning being printed to the console",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id for the root element",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to handle blur events",
                    "name": "onBlur",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onClick handler for the pill itself",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event?: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus handler for the pill itself",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onMouseEnter for root element",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onMouseLeave for root element",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renders the remove button if provided\r\nHandler to remove the pill",
                    "name": "onRemoveClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom rendering function for left-aligned visuals\r\nUsing with size = PillSize.Compact will trigger a warning in the console\r\nand will not render anything",
                    "name": "onRenderFilledVisual",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": " Regular\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Use of iconProps, onRemoveClick, or onRenderFilledVisual in conjunction with Compact will result in those elements not being rendered\r\nand a warning being printed to the console",
                    "name": "size",
                    "optional": true,
                    "type": "PillSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Explicit tab index overrides any other focus-zone / focus-group controlled indexing",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Explicit tab index overrides any other focus-zone / focus-group controlled indexing for the remove button",
                    "name": "removeButtonTabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " Standard\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If this is set to Colored and color is not provided, we'll render as Standard and emit a warning to the console",
                    "name": "variant",
                    "optional": true,
                    "type": "PillVariant"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional role for the pill",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/PillGroup/PillGroup.Props.d.ts": [
        {
            "description": "",
            "name": "PillGroupOverflow",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "clip",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "wrap",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "fade",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IPillGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the pill group.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional mouse-enter handler",
                    "name": "onMouseEnter",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional mouse-leave handler",
                    "name": "onMouseLeave",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLDivElement>) => void"
                },
                {
                    "defaultValue": " PillGroupOverflow.clip\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set the overflow behavior.",
                    "name": "overflow",
                    "optional": true,
                    "type": "PillGroupOverflow"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Portal/Portal.Props.d.ts": [
        {
            "description": "",
            "name": "IPortalProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to add to the root of the portal.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to add to the portal host.",
                    "name": "parentClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional selector for the parentElement that will contain the portal tree.",
                    "name": "portalSelector",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional parentElement that will contain the portal tree.",
                    "name": "portalElement",
                    "optional": true,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "By default, the focus is returned to the previously active element when the portal is unmounted. Set this flag to true to bypass this action.",
                    "name": "bypassActiveElementFocusOnUnmount",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ProgressBar/ProgressBar.Props.d.ts": [
        {
            "description": "",
            "name": "IProgressBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the progress bar container div.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Current value of the progress bar. This should be a number between 0 and maxValue.",
                    "name": "currentValue",
                    "optional": false,
                    "type": "IReadonlyObservableValue<number> | number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Max value the progress bar can reach.",
                    "name": "maxValue",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the actual progress bar.",
                    "name": "progressBarClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 150\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Duration of the transition in milliseconds",
                    "name": "transitionDuration",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-label for the progress bar",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IIndeterminateProgressBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the progress bar container div.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Is the progress bar still loading.\r\nundefined: The gray bar will appear, but the progress bar will not start increasing.\r\ntrue: The grey bar will appear, a progress bar will slowly fill the width of the gray bar\r\nfalse: The progress bar will be rendered the full width of the bar, loadingAnimationComplete will be called\r\nwhen the animation is completed.",
                    "name": "loading",
                    "optional": true,
                    "type": "ObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the animation is complete. This is usually used to unmount the control.",
                    "name": "loadingAnimationComplete",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the actual progress bar.",
                    "name": "progressBarClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/RadioButton/RadioButton.Props.d.ts": [
        {
            "description": "",
            "name": "IRadioButtonGroup",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets focus to the RadioButtonGroup.",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "RadioButtonGroupDirection",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Horizontal",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "Vertical",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IRadioButtonGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the radio button group element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id of the button that should be focused by default.",
                    "name": "defaultButtonId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the radio button group's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the radio button group children container.",
                    "name": "groupClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id of the checkbox group element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback called when a new button is selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(buttonId: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The id of the currently selected radio button.",
                    "name": "selectedButtonId",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display above the radio group.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " RadioButtonGroupDirection.Vertical\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies the direction that the radio button children are layed out.",
                    "name": "direction",
                    "optional": true,
                    "type": "RadioButtonGroupDirection"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets \"aria-invalid\" attribute, if the error message is displayed, should be set to true.",
                    "name": "ariaInvalid",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets \"aria-errormessage\" attribute - the id of the element that provides error message.",
                    "name": "ariaErrorMessageId",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IRadioButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users. Only use if custom rendering the label\r\nwith children. Otherwise, this will automatically get set to the id of the text serving as the label.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which describes this one for screen reader users.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the radio button element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the button cannot be interacted with.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the radio button's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to omit setting the tab index.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "id of the radio button.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": " radio\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria role.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display next to the radio button.\r\nFor custom rendering the label of the radio button (to support two lines of text, etc.), pass\r\nchildren to the <RadioButton> and use the bolt-radio-button-label className. Make sure to set\r\nthe ariaLabelledBy prop to the id of the element containing your label. E.g.\r\n\r\n <RadioButton ariaLabelledBy={myId}>\r\n     <div className=\"bolt-radio-button-label\" id={getSafeId(myId)}>\r\n         {label-text}\r\n         <span className=\"sub-text-class\">{sub-text}</span>\r\n     </div>\r\n <RadioButton>",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the radio button is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ResizeGroup/ResizeGroup.Props.d.ts": [
        {
            "description": "",
            "name": "IResizeGroupContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "overflowItems",
                    "optional": true,
                    "type": "ObservableArray<IMenuItem>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IResizeGroupProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to forward to the responsive layout.",
                    "name": "responsiveLayoutProps",
                    "optional": false,
                    "type": "IResponsiveLayoutProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An array of menu items that correspond to responsiveChildren. Hidden responsive items\r\nwill have their corresponding menu items forwarded to ResizeGroupContext Consumers.",
                    "name": "overflowMenuItems",
                    "optional": false,
                    "type": "IMenuItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Extra items are always forwarded to ResizeGroupContext Consumers as overflowing items.\r\nThey do not correpsond with responsive children.",
                    "name": "extraItems",
                    "optional": true,
                    "type": "IMenuItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional boolean to keep icons for header bar but expand to have text for overflow menu",
                    "name": "useAriaLabelForOverflow",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ResponsiveLayout/ResponsiveLayout.Props.d.ts": [
        {
            "description": "",
            "name": "ResponsiveOrientation",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "Components are measured by width and adjusted based on the the width of the parent\r\nelement.",
                    "name": "Horizontal",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "Components are measure by height and adjusted based on the height of the parent\r\nelement.",
                    "name": "Vertical",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IResponsiveLayoutProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The set of components that are responsive in priority order. Not all child indexes\r\nneed to be listed, only the ones that should be responsive.",
                    "name": "responsiveChildren",
                    "optional": false,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Some components (like fillers) can be excluded from the layouts size calculations.\r\nThis is useful when a component has no effective impact on the size of the parent element.",
                    "name": "ignoredChildren",
                    "optional": true,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onLayoutChange is called when the responsive container is sized and one of the children\r\nis affected by the size change.\r\n\r\n@param hiddenCount - The number of currently hidden components in the layout.",
                    "name": "onLayoutChange",
                    "optional": true,
                    "type": "(hiddenCount: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Orientation of the responsiveness for the component. Defaults to Horizontal.",
                    "name": "orientation",
                    "optional": true,
                    "type": "ResponsiveOrientation"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ResponsiveViewport/ResponsiveViewport.Props.d.ts": [
        {
            "description": "",
            "name": "IBreakPoint",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set, the breakpoint is only active if the width of the element is greater than the given value",
                    "name": "minWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If set, the breakpoint is only active if the width of the element is less than or equal to the given value\r\n\r\nNote: this is different than standard CSS @media query behavior to deal with non-integer widths",
                    "name": "maxWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Name of class to apply if breakpoint is active",
                    "name": "className",
                    "optional": false,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IResponsiveViewportProps<T extends IBreakPoint = IBreakPoint>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Name of the tag used to create the wrapper element",
                    "name": "tag",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to apply to wrapper element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of breakpoints",
                    "name": "breakPoints",
                    "optional": false,
                    "type": "ReadonlyArray<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional initialWidth to compute initial breakpoints",
                    "name": "initialWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to get a reference to the viewport once mounted",
                    "name": "componentRef",
                    "optional": true,
                    "type": "(ref: IResponsiveViewport) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback to render the content, by default",
                    "name": "onRenderContent",
                    "optional": true,
                    "type": "(activeBreakPoints: T[]) => React.ReactNode"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IResponsiveViewport",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Measure current size and update breakpoints accordingly",
                    "name": "measure",
                    "optional": false,
                    "type": "(): void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/SingleLayerMasterPanel/SingleLayerMasterPanel.Props.d.ts": [
        {
            "description": "",
            "name": "ISingleLayerMasterPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref to the scrolling content div; avoid using if possible",
                    "name": "contentRef",
                    "optional": true,
                    "type": "React.Ref<HTMLDivElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renders the content area of the MasterPanel\r\nYour List/Tree goes here",
                    "name": "renderContent",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "For standard titles, mark the title element with \"bolt-master-panel-header-title\"\r\nFor standard subtitles, mark the subtitle element with \"bolt-master-panel-header-subtitle bolt-master-panel-header-secondary\"\r\n\r\nMark all secondary elements with the css class \"bolt-master-panel-header-secondary\" so they are hidden on scroll\r\n@see SimpleMasterDetailsHeader for a good basic implementation of title and subtitle",
                    "name": "renderHeader",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional renderer for any search functionality\r\nRenders into a styled area that scrolls with the content",
                    "name": "renderSearch",
                    "optional": true,
                    "type": "() => JSX.Element"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMasterPanelProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ISingleLayerMasterPanelHeaderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Handler for when back button is clicked",
                    "name": "onBackButtonClick",
                    "optional": true,
                    "type": "() => void"
                }
            ],
            "externalTypes": [
                {
                    "name": "IMasterPanelHeaderProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Sizer/Sizer.Props.d.ts": [
        {
            "description": "",
            "name": "Orientation",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Sizes on the X axis, left - right.",
                    "name": "row",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "Sizes on the Y axis top - bottom.",
                    "name": "column",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "Position",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "The Sized component appears before the Sizer.",
                    "name": "near",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "The Sized component appears after the Sizer.",
                    "name": "far",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ISizerProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-label for the divider",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that should be added to the Sizer component.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "divider can be used to control the visibility of a small divider line\r\ninside the sizer. If no divider is show then sizer will be transparent\r\nbut still work as expected. The caller can use a custom className to\r\ncustomize both the sizer and any dividers.",
                    "name": "divider",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for the Sizer component.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "keyboardStepMultiplier defines the number of pixels the sizer should move\r\nwhen a user uses the keyboard to manipulate the sizer.",
                    "name": "keyboardStepMultiplier",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " 10000 (px)\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "maxSize of the Sized component. The sizer will stop increasing the\r\nsize of the component at this point.",
                    "name": "maxSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " 100 (px)\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "minSize of the Sized component. The sizer will stop decreasing the\r\nsize of the component at this point.",
                    "name": "minSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSize is called with the Id and the updated size of the component\r\nwhile the sizing is ocurring. This can be used for live updates to\r\nthe UI.",
                    "name": "onSize",
                    "optional": false,
                    "type": "(event: MouseEvent | KeyboardEvent, updatedSize: number, id?: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSizeEnd is called with the Id and the updated size of the component\r\nwhen the sizing is complete. This can used to update any persistant\r\nvalues for the sizes if needed.",
                    "name": "onSizeEnd",
                    "optional": true,
                    "type": "(id?: string) => void"
                },
                {
                    "defaultValue": " Orientation.row\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "orientation defines whether or the sizer is sizing row based components\r\nor column based components. Row based sizer will size horizontally and\r\nColumn will size vertically.",
                    "name": "orientation",
                    "optional": false,
                    "type": "Orientation"
                },
                {
                    "defaultValue": " Position.near\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "position defines the relationship between the Sizer and the Sized\r\ncomponents. If the Sized component occurs before the Sizer it should\r\nbe defined as near, otherwise it should be defined as far.",
                    "name": "position",
                    "optional": true,
                    "type": "Position"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "size defines the current size of the Sized component. Using ObservableValues\r\ncan help reduce re-render by managing state internally instead of in a\r\nhigher level component.",
                    "name": "size",
                    "optional": false,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tabIndex can be used to allow for keyboard accessibility of the sizer.",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISizedProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that should be added to the Sizer component.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The height of the element generated by the component.",
                    "name": "height",
                    "optional": true,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The width of the element generated by the component.",
                    "name": "width",
                    "optional": true,
                    "type": "number | IReadonlyObservableValue<number>"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Spinner/Spinner.Props.d.ts": [
        {
            "description": "",
            "name": "SpinnerSize",
            "properties": [
                {
                    "defaultValue": "\"xsmall\"",
                    "description": "12px diameter",
                    "name": "xSmall",
                    "type": "string"
                },
                {
                    "defaultValue": "\"small\"",
                    "description": "16px diameter",
                    "name": "small",
                    "type": "string"
                },
                {
                    "defaultValue": "\"medium\"",
                    "description": "20px diameter",
                    "name": "medium",
                    "type": "string"
                },
                {
                    "defaultValue": "\"large\"",
                    "description": "28px diameter",
                    "name": "large",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "SpinnerOrientation",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "When a label is used render the label and animation in a row (label to the right).",
                    "name": "row",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "When a label is used render the label and animation in a column (label below).",
                    "name": "column",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ISpinnerProps",
            "properties": [
                {
                    "defaultValue": " polite\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-live value",
                    "name": "ariaLive",
                    "optional": true,
                    "type": "\"off\" | \"assertive\" | \"polite\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-label",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional custom classname",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id for the spinner",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional label text",
                    "name": "label",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " column\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional orientation when a label is used.",
                    "name": "orientation",
                    "optional": true,
                    "type": "SpinnerOrientation"
                },
                {
                    "defaultValue": " SpinnerSize.medium\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional spinner size",
                    "name": "size",
                    "optional": true,
                    "type": "SpinnerSize"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/SplitButton/SplitButton.Props.d.ts": [
        {
            "description": "",
            "name": "ISplitButtonProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to pass to the main button of the split button.\r\n\r\nPrimary, Disabled, and Subtle props are overriden by Split button props",
                    "name": "buttonProps",
                    "optional": false,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref of the main button",
                    "name": "buttonRef",
                    "optional": true,
                    "type": "string | ((instance: Button | null) => void) | React.RefObject<Button>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Css class(es) to be added to the split button",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if both buttons should be disabled.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ref of the expandable object",
                    "name": "expandableRef",
                    "optional": true,
                    "type": "React.RefObject<Expandable>\r\n\r\n    /**\r\n     * Props to pass to the dropdown button of the split button.\r\n     *\r\n     * Primary, Disabled, and Subtle props are overriden by Split button props\r\n     */\r\n    menuButtonProps: IMenuButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "renderCallout",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if both buttons should be styled with the primary style.",
                    "name": "primary",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if both buttons should be styled with the subtle style.",
                    "name": "subtle",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Splitter/Splitter.Props.d.ts": [
        {
            "description": "",
            "name": "SplitterDirection",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Children will be laid out left to right and divided vertically",
                    "name": "Vertical",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "Children will be laid out top to bottom and divided horizontally",
                    "name": "Horizontal",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "SplitterElementPosition",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Left/Top element",
                    "name": "Near",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "Right/Bottom element",
                    "name": "Far",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "FixedSizeLimitsFormat",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "minFixedSize and maxFixedSize are specified in pixels",
                    "name": "Pixels",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "minFixedSize and maxFixedSize are specified as a percentage of the total size (e.g. 0.6)",
                    "name": "Percentage",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ISplitterProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-label for the divider",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-labeledby for the divider",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to apply to the splitter\r\ncontainer div.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, show the fixed side of the splitter in a collapsed form.",
                    "name": "collapsed",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Is the splitter disabled",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " \"Show more information\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specific tooltip to use for the expand button that is shown in the collapsed state.",
                    "name": "expandTooltip",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional classname for the root Splitter far element.",
                    "name": "farElementClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " SplitterElementPosition.Far\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Which element is the fixed element.",
                    "name": "fixedElement",
                    "optional": true,
                    "type": "SplitterElementPosition"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The size of the fixed element",
                    "name": "fixedSize",
                    "optional": true,
                    "type": "IReadonlyObservableValue<number> | number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The initial fixed size, if this element does not have a controlled width. Defaults to 50%",
                    "name": "initialFixedSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The minimum size of the fixed element",
                    "name": "minFixedSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum size of the fixed element",
                    "name": "maxFixedSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional classname for the root Splitter near element.",
                    "name": "nearElementClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the collapsed mode changes. If supplied, the collapsed state will\r\nbe toggled",
                    "name": "onCollapsedChanged",
                    "optional": true,
                    "type": "(collapsed: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the fixed size changes",
                    "name": "onFixedSizeChanged",
                    "optional": true,
                    "type": "(newFixedSize: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Render the content of the far (last) element",
                    "name": "onRenderFarElement",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Render the content of the near (first) element",
                    "name": "onRenderNearElement",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": " SplitterDirection.Vertical\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The direction of the splitter.",
                    "name": "splitterDirection",
                    "optional": true,
                    "type": "SplitterDirection"
                },
                {
                    "defaultValue": " FixedSizeLimitsFormat.Pixels\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Format of fixed size limits.",
                    "name": "fixedSizeLimitsFormat",
                    "optional": true,
                    "type": "FixedSizeLimitsFormat\r\n}"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Status/Status.Props.d.ts": [
        {
            "description": "",
            "name": "IStatusProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Animate the icon (if supported). Defaults to true for Running.",
                    "name": "animated",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided, will set aria label of the Status component when\r\ntext is not specified.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional classname to add to the Status component.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to identify the fill color for the Status svg.",
                    "name": "color",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renders an icon of the provided size with the provided className,\r\nand an optional aria label.",
                    "name": "onRenderIcon",
                    "optional": false,
                    "type": "(className: string, size: StatusSize, animated?: boolean, ariaLabel?: string) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Size of the component.",
                    "name": "size",
                    "optional": true,
                    "type": "StatusSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided, will turn the component into an extended status pill\r\nwith this text.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided, will be displayed on pill hover.",
                    "name": "tooltipContent",
                    "optional": true,
                    "type": "(() => React.ReactNode) | undefined"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "StatusSize",
            "properties": [
                {
                    "defaultValue": "\"12\"",
                    "description": "",
                    "name": "s",
                    "type": "string"
                },
                {
                    "defaultValue": "\"16\"",
                    "description": "",
                    "name": "m",
                    "type": "string"
                },
                {
                    "defaultValue": "\"24\"",
                    "description": "",
                    "name": "l",
                    "type": "string"
                },
                {
                    "defaultValue": "\"32\"",
                    "description": "",
                    "name": "xl",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        }
    ],
    "azure-devops-ui/Components/SuggestionsList/SuggestionsList.Props.d.ts": [
        {
            "description": "",
            "name": "ISuggestionsListProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The CSS classname of the suggestions list.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How the \"no result found\" should look in the suggestion list.",
                    "name": "createDefaultItem",
                    "optional": true,
                    "type": "(currentSuggestions: T[]) => T"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to indicate whether or not the suggestions are loading.",
                    "name": "isLoading",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The text to display while the results are loading.",
                    "name": "loadingText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The text that should appear if no results are found when searching.",
                    "name": "noResultsFoundText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "What should occur the suggestion list loses focus.",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "What should occur the suggestion list gets focus.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "What should occur when a suggestion is clicked",
                    "name": "onSuggestionClicked",
                    "optional": false,
                    "type": "(suggestion: ISuggestionItemProps<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How the \"no result found\" should look in the suggestion list.",
                    "name": "renderNoResultFound",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How the suggestion should look in the suggestion list.",
                    "name": "renderSuggestion",
                    "optional": true,
                    "type": "(suggestionItemProps: ISuggestionItemProps<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Maximum number of suggestions to show in the full suggestion list.",
                    "name": "resultsMaximumNumber",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The list of Suggestions that will be displayed",
                    "name": "selectedIndex",
                    "optional": false,
                    "type": "IReadonlyObservableValue<number> | number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The list of Suggestions that will be displayed",
                    "name": "suggestions",
                    "optional": false,
                    "type": "ObservableArray<T> | T[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An ARIA label for the container that is the parent of the suggestions.",
                    "name": "suggestionsContainerAriaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "the classname of the suggestionitem.",
                    "name": "suggestionsItemClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Width of the suggestion callout..",
                    "name": "width",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISuggestionItemProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name to apply to the item.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The key for the item",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Index of the suggestion item.",
                    "name": "index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Is the item selected.",
                    "name": "isSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Item representing the suggestion.",
                    "name": "item",
                    "optional": false,
                    "type": "T"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "What should occur the suggestion item loses focus.",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "What should occur the suggestion item gets focus.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The callback when an item is clicked",
                    "name": "onClick",
                    "optional": false,
                    "type": "(suggestion: ISuggestionItemProps<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The callback used to render the suggestion item.",
                    "name": "renderSuggestion",
                    "optional": false,
                    "type": "(suggestionItemProps?: ISuggestionItemProps<T>) => JSX.Element"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Surface/Surface.Props.d.ts": [
        {
            "description": "",
            "name": "Spacing",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "condensed",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "default",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "relaxed",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "SurfaceBackground",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "normal",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "neutral",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "callout",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ISurfaceContext",
            "properties": [
                {
                    "defaultValue": " SurfaceBackground.normal\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies the background color of the surface onto which a component will be\r\nrendered. This allows components which consume the context to decide if anything\r\nabout their rendering needs to be changed.",
                    "name": "background",
                    "optional": false,
                    "type": "SurfaceBackground"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name that should be applied to achieve the horizontal spacing desired by the\r\nspacing prop for the context. This provides a standard mapping of spacing value =>\r\nclassName. If a component consuming the context wants different behavior based on\r\nthe spacing value, it can choose to not apply this className, and provide different style.",
                    "name": "horizontalClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " undefined - let the component decide how spacing should be applied.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies the spacing the container should use.\r\nThis allows components which consume the context to decide if anything\r\nabout their rendering needs to be changed.",
                    "name": "spacing",
                    "optional": true,
                    "type": "Spacing"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name that should be applied to achieve the vertical spacing desired by the\r\nspacing prop for the context. This provides a standard mapping of spacing value =>\r\nclassName. If a component consuming the context wants different behavior based on\r\nthe spacing value, it can choose to not apply this className, and provide different style.",
                    "name": "verticalClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISurfaceProps",
            "properties": [
                {
                    "defaultValue": " SurfaceBackground.normal\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies the semantic background color of the surface.",
                    "name": "background",
                    "optional": false,
                    "type": "SurfaceBackground"
                },
                {
                    "defaultValue": " undefined - let the component decide how spacing should be applied.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Specifies the spacing the container should use.\r\nThis allows components which consume the context to decide if anything\r\nabout their rendering needs to be changed.",
                    "name": "spacing",
                    "optional": true,
                    "type": "Spacing"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Table/Table.Props.d.ts": [
        {
            "description": "",
            "name": "ITable<T>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IList<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITableRow<T>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IListRow<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITableRowDetails<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class name to add to the rendered row element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "id to add to the rendered row element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the table a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<T | IReadonlyObservableValue<T | undefined>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderSpacer can be supplied to override the spacer columns before and\r\nafter the actual columns in the table. This is used to apply custom\r\nsemantics to these areas. The standard spacers should be used unless there\r\nis a specific need otherwise.",
                    "name": "renderSpacer",
                    "optional": true,
                    "type": "(rowIndex: number, left: boolean) => React.ReactNode | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the aria role on the tr element.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the table selection. This\r\nis not required since the table offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IListSelection that supports multi\r\nselect.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip props to pass to the table row.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": [
                {
                    "name": "IListItemDetails<T>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITableProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "columns is a required property of a table used to define the column layout\r\nfor the table.",
                    "name": "columns",
                    "optional": false,
                    "type": "Array<ITableColumn<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe IItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the table a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.\r\n\r\nThere is simple ArrayItemProvider<T> for those that just have a set of items\r\nthey want to supply without writing a custom ItemProvider.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<T | IReadonlyObservableValue<T | undefined>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Behaviors can be added to the table and monitor events and interact with the\r\ncomponent through the ITable methods.",
                    "name": "behaviors",
                    "optional": true,
                    "type": "Array<IBehavior<ITableProps<T>, ITable<T>>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the table root element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the container element.",
                    "name": "containerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom way to force single-select options in a multi-select selection.",
                    "name": "enforceSingleSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller can supply an EventDispatch to the table if it wishes to\r\nparticipate it extending the behaviors. If one isn't supplied the table will\r\ncreate its own dispatcher when behaviors are supplied.",
                    "name": "eventDispatch",
                    "optional": true,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to set the tabIndex of the first row to -1 instead of 0.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the table rows are focused.\r\nThe default focuszone if one isn't supplied is a Vertical non-cyclic focus zone.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": " 100000\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum height of the table when virtualized. Browsers have issues\r\nrendering elements that are too large and when the List contains thousands\r\nof elements, the list renders very large spacer elements to correctly\r\nposition the scroll bar. The large spacer elements cause rendering issues\r\nacross browsers. To bypass this, we need to limit how large the list can\r\ngrow to. By default this size is 100,000px. However, if you have multiple\r\nitems within a scrollable region, this number might need to be reduced.\r\nFor instance, if you have 5 lists that can contain a lot of rows in the\r\nsame scrollable region, you would likely want to set the max height for\r\neach list to 20,000. Keep in mind that the smaller this number, the harder\r\nit will be for a user to scroll with precision.",
                    "name": "maxHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showHeader determines whether or not the column headers are shown at the top\r\nof the table. If a function is passed, this function will be called whenever\r\nthe screen size changes.",
                    "name": "showHeader",
                    "optional": true,
                    "type": "boolean | ((screenSize: ScreenSize) => boolean)"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showLines determines whether or not lines displayed between rows.",
                    "name": "showLines",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showScroll determines whether we allow overflow on the table\r\nif it is false (as in default), we will add scroll-hidden css class to the table",
                    "name": "showScroll",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this table.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 10\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "pageSize controls the granularity of row rendering. The table always renders\r\na full page worth of rows even when they are not needed to fill the viewport.\r\n\r\nSmaller values will help reduce the number of wasted rows that are rendered\r\noutside the viewport, but will force the table to re-render more often as\r\nscrolling occurs.",
                    "name": "pageSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tables MAY render a header above the table contents. This is done through the\r\nonRenderHeader. Like the renderRow method, there are set of restrictions the\r\nimplmentation MUST follow.\r\n\r\nRequirements:\r\n\r\n1) The header function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The header function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.",
                    "name": "renderHeader",
                    "optional": true,
                    "type": "(columns: Array<ITableColumn<T>>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a row's value is given as an ObservableValue with an undefined value,\r\nthe list will render a Loading row for the content. The default will be\r\na shimmer row that is semi random and matches the content.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param details Additional details about this row.",
                    "name": "renderLoadingRow",
                    "optional": true,
                    "type": "(index: number, details: ITableRowDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The requirements of this function are quite complicated and before writing\r\na new row renderer you should ensure one doesnt already exist that solves\r\nyour needs.\r\n\r\nRequirements:\r\n\r\n1) The row function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The row function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.\r\n\r\n3) The row function MUST call onFocusItem when a either the row element of\r\nany of the rows child elements receive the focus. This is needed to ensure\r\nnavigation within the table as well as in and out of the table function\r\ncorrectly.\r\n\r\n4) The row function MUST ensure the className for each of the columns is\r\nadded the cell for the given colmn.\r\n\r\n5) The row function MAY dispatch events for behaviors but is not required.\r\nIf any events are dispatched they should be documented on the row renderer.\r\n\r\n6) The row function is responsible for all accessibility and focus\r\nmanagement within the row.",
                    "name": "renderRow",
                    "optional": true,
                    "type": "TableRowRenderer<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderSpacer can be supplied to override the spacer columns before and\r\nafter the actual columns in the table. This is used to apply custom\r\nsemantics to these areas. The standard spacers should be used unless there\r\nis a specific need otherwise.\r\n\r\n@param rowIndex - The index of the row to render for.\r\n@param left - True if this is the left spacer, false if it is the right spacer",
                    "name": "renderSpacer",
                    "optional": true,
                    "type": "(rowIndex: number, left: boolean) => React.ReactNode | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to allow text selection for table rows.",
                    "name": "selectableText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event - This is the event that is causing the activation.\r\n@param tableRow - Details about the table row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus is called when a item in the list is focused. Preventing default\r\non the focus event will prevent row selection from occuring even if\r\nselectOnFocus is set to true.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param tableRow Details about the list row being activated.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: ITableRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param tableRow - Details about the table row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<T>) => void"
                },
                {
                    "defaultValue": " \"grid\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role defines the aria role of the table and defaults to \"grid\"\r\nIf the table does not have any focusable elements within the rows, set the role as \"table\" instead of \"grid\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller has variable height rows they can specify the rowHeight they\r\nwant used to estimate the size of virtualized rows. This means that when rows\r\nare not rendered, the component will create virtual space for those rows to\r\nensure the scrolling behavior acts appropriately.\r\n\r\nIf the table has fixed size rows there is no need to specify a rowHeight. The\r\ntable will determine the height of the rows after the initial render when\r\nthe observer reports on page visibility.\r\n\r\nQuestion: How do I determine the rowHeight if their are variable height rows.\r\nThis one is a tough question, and the general answer is come up with a fair\r\naverage for the rows on a given page. If the select too large or too small\r\nscrolling behaviors can become a bit odd, generally select on the smaller\r\nside if you are unsure.",
                    "name": "rowHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An array of heights to be used when calculating the spacer heights.  If not supplied, the heights used\r\nwill be estimations.",
                    "name": "rowHeights",
                    "optional": true,
                    "type": "number[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "scrollable should be set to true if the table is not contained in a\r\nscrolling element. This will ensure the table scrolls vertically within\r\nthe table element itself.",
                    "name": "scrollable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the table selection. This\r\nis not required since the table offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IListSelection that supports multi\r\nselect.\r\n\r\nThere is a basic ListSelection implementation available from the List\r\ncomponent.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the table select a row when it is clicked?",
                    "name": "selectRowOnClick",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Determines the width of the spacer cells on either side of each row.",
                    "name": "spacerWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A table can be defined with a set of breakpoints. These breakpoints will be\r\nused to control the column layout as the space available to the table changes.",
                    "name": "tableBreakpoints",
                    "optional": true,
                    "type": "ITableBreakpoint[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If virtualize false is supplied the list will render all the items supplied\r\nto it. This shouldn't be used unless you know you have a limited number of\r\nrows. Virtualization is used to avoid performance problems.",
                    "name": "virtualize",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "TableColumnLayout",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "If a column is noted as none, when an asynchronous row is loaded no\r\nanimation will be added to this column.",
                    "name": "none",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "The row uses a single line of text. This is the default for a column that\r\ndoesnt explicitly define a column layout",
                    "name": "singleLine",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "The row uses a single line of text with a small prefix.",
                    "name": "singleLinePrefix",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "The row uses two lines of text.",
                    "name": "twoLine",
                    "type": "number"
                },
                {
                    "defaultValue": "4",
                    "description": "The row uses two lines of text with a large prefex.",
                    "name": "twoLinePrefix",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "TableColumnStyle",
            "properties": [
                {
                    "defaultValue": "1",
                    "description": "Secondary colums should be rendered normally.",
                    "name": "Secondary",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "Primary columns should be rendered with emphasis.",
                    "name": "Primary",
                    "type": "number"
                },
                {
                    "defaultValue": "3",
                    "description": "Tertiary columns should be rendered de-emphasized.",
                    "name": "Tertiary",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ITableColumnBehaviorProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "tableProps",
                    "optional": false,
                    "type": "Partial<ITableProps<T>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "columnIndex",
                    "optional": false,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "SortOrder",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "ascending",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "descending",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ColumnJustification",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "Left",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "",
                    "name": "Right",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IColumnSortProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is deprecated, aria-sort is used instead.",
                    "name": "ariaLabelAscending",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is deprecated, aria-sort is used instead.",
                    "name": "ariaLabelDescending",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If a column is tagged as sorted, the header will indicate the sort order with\r\na visual icon in the if the header uses the standard renderer. If a custom\r\nrenderer is used, it should handle the sortOrder.",
                    "name": "sortOrder",
                    "optional": true,
                    "type": "SortOrder"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITableBreakpoint",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The table is defined with series of breakpoints. Each of the breakpoints\r\nwill have a mapping for the column widths. Columns widths should be\r\ndefined the same here as within an ITableColumn, except 0 should be used\r\nfor columns that are hidden at this breakpoint.",
                    "name": "breakpoint",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The width of each column in the table when this breakpoint is active.\r\nThe width can be a positive number for a fixed width, a negative number\r\nfor a proportional width, or 0 for a hidden column.",
                    "name": "columnWidths",
                    "optional": false,
                    "type": "number[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IMeasurementStyle",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Pixels represented by the 'px' css measurement.",
                    "name": "Pixel",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "RootEMs represented by the 'rem' css measurement.",
                    "name": "REM",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ITableColumn<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.  Used when no column name or icon is provided.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Behaviors can be added a column to monitor events and interact with the column.",
                    "name": "behaviors",
                    "optional": true,
                    "type": "Array<IBehavior<ITableColumnBehaviorProps<T>, {}>>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to that should be added to the table cell for each of the\r\nvalues in this column.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is used to help the table understand the general layout of the data.\r\nOne of the general purposes of this value is used when data is loaded\r\nasynchronously the table will render a loading animation by default and\r\nthe layout is used to help define the visuals for the animation.\r\n\r\nA column with no columnLayout defined will use the TableColumnLayout.singleLine\r\nstyle.",
                    "name": "columnLayout",
                    "optional": true,
                    "type": "TableColumnLayout"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "cell renders MAY use the column style to apply css or other behaviors to\r\nthis column.",
                    "name": "columnStyle",
                    "optional": true,
                    "type": "TableColumnStyle"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that will be added to the cell for each header element.",
                    "name": "headerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className that will be added to the header title.",
                    "name": "headerTitleClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tabindex of the table header. Defaults to 0 if not set",
                    "name": "headerTabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If iconProps are supplied the Icon will be drawn to the left of the\r\ncolumn name in the header cell.",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this table. NOTE: If this column uses the renderSimpleCell function\r\nthe id is used as the property name of the row object to render.",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How to justify the content within cells. Will also effect the position of the sorting\r\narrow",
                    "name": "justification",
                    "optional": true,
                    "type": "ColumnJustification"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Mark as readonly if there are no interactive elements in the column",
                    "name": "readonly",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to mark the column field as required, primarily for editable grids. This will display an asterisk next to the column name.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "maxWidth defines how large the column MAY grow if the column is resizble.\r\nThis must be an absolute number, it can't be supplied as a percentage.",
                    "name": "maxWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "minWidth defines how small the column MAY shrink if the column is resizble.\r\nThis must be an absolute number, it can't be supplied as a percentage.",
                    "name": "minWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The name of the column is used to render the column header string. If the\r\ncolumn has no header shown or only an icon the name can be omitted.",
                    "name": "name",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderCell MUST be supplied for a column. This defines how the column values\r\nwill be rendered in the table. Row rendering functions should use this\r\nfunction unless the row rendering function has a custom presentation for\r\nthe row/column.\r\n\r\n@param rowIndex - This is the 0 based row index.\r\n@param columnIndex - This is the 0 based column index.\r\n@param tableColumn - This is the column definition for this cell.\r\n@param tableItem - This is the object being rendered in this row.\r\n@param ariaRowIndex - This is the index of the row that aria will read.\r\n@param role - This is the role of child \"tr\" element.",
                    "name": "renderCell",
                    "optional": false,
                    "type": "(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<T>, tableItem: T, ariaRowIndex?: number, role?: string) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderHeaderCell can be supplied to render a custom header. It will be\r\nthe responsibility of the custom render function to manage all status\r\nof the header. This includes all accessibitlity and focus management.\r\n\r\n@param index - This is the 0 based column index.\r\n@param tableColumn - This is the column definition for the header being rendered.\r\n@param focuszoneId - Focuszone id that needs to be included if the header is focusable.\r\n@param isFirstActionableHeader - True for the first column header that gets focused on keyboard accessibility.",
                    "name": "renderHeaderCell",
                    "optional": true,
                    "type": "(columnIndex: number, tableColumn: ITableColumn<T>, focuszoneId?: string, isFirstActionableHeader?: boolean) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSize is triggered when the column header is sized by the user. This is\r\na required property to enable the column to be resized.\r\n\r\n@param event - This is the mouse or keyboard event that has caused the resize to occur.\r\n@param index - This is the 0 based column index being resized.\r\n@param width - This is the updated width of the column. Note: this is called\r\n with values that conform to the defined min/max values.\r\n@param column - This is the column definition for the column being resized.",
                    "name": "onSize",
                    "optional": true,
                    "type": "(event: MouseEvent | KeyboardEvent, columnIndex: number, width: number, column: ITableColumn<T>) => void"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Show the column divider for resizable columns",
                    "name": "showSizerDivider",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSizeEnd is called when the currently active sizing operation has completed.\r\nThis means the user has stopped sizing the column. Any actions the consumer\r\nwants to take when sizing ends, they should implement here.",
                    "name": "onSizeEnd",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Within a table columns may optionally be sorted. The table will render an indicator\r\nin the header by default for the current sort order. SortProps should be supplied\r\nfor each column that MAY be sorted even if it isn't currently sorted. This allows\r\nthe table to know which columns are and which are not sortable.",
                    "name": "sortProps",
                    "optional": true,
                    "type": "IColumnSortProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The width of a column can one of two values:\r\n\r\nPositive value - This is the exact width of the column in pixels. This\r\nwould be something like 250 to have a 250px column.\r\n\r\nNegative value - This is the percentage of the remaining space in the\r\ncontaining element this column should consume. This would be something\r\nlike -100 for 100% of the remaining space.\r\n\r\nNOTE: This is different than css since we dont want to do unneeded\r\nstring processing, CSS would have you use a string like 250px or 100%.",
                    "name": "width",
                    "optional": false,
                    "type": "IReadonlyObservableValue<number> | number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The widthStyle can be set when the width is a positive number. By default\r\nthe width is interpreted as a fixed pixel value. If the column is going to have\r\na small UI representation such as a Coin, User Image, and a button these will\r\nscale with font size and should be represented with root EM values. This\r\ncorresponds to the css rem measurement.",
                    "name": "widthStyle",
                    "optional": true,
                    "type": "IMeasurementStyle"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITableHeaderCellProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel to pass to the header cell.  By default, the cell is labelled by its content element.\r\nIf specified, aria-hidden will be set to true on the content element to prevent dupplicate announcements.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "column is the core information used to describe a table column.",
                    "name": "column",
                    "optional": false,
                    "type": "ITableColumn<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "columnIndex is used to define the index of this column.",
                    "name": "columnIndex",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional focuszoneId that should be added to the component when supplied.\r\nThis allows the table to provider keyboard accessibility to the header\r\nthrough a focuszone.",
                    "name": "focuszoneId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Identifies the first column header that will get the focus via keyboard accessibility.",
                    "name": "isFirstActionableHeader",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITableRowProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class names that should be added to the row element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Index of the row that should be rendered.",
                    "name": "index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Details about how the table is rendering rows.",
                    "name": "details",
                    "optional": false,
                    "type": "ITableRowDetails<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": true,
                    "deprecatedMessage": " Please include links inside the table cell render methods. Table row links are inaccessible and support for them will be removed in future versions. ",
                    "description": "",
                    "name": "linkProps",
                    "optional": true,
                    "type": "ILinkProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ISimpleTableCell",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "[prop",
                    "optional": false,
                    "type": "string]: ISimpleListCell | string | number"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Table/TableBreakpoint.Props.d.ts": [
        {
            "description": "",
            "name": "ITableBreakpointProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set of columns that being displayed in the table. These are used to compute the\r\nbreakpoints and when the breakpoints are reached the column widths are updated.\r\nThe column width must be an ObservableValue for the update to be applied.",
                    "name": "breakpoints",
                    "optional": false,
                    "type": "ITableBreakpoint[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The set of widths that will be managed by the table breakpoint as the available\r\nspace changes.",
                    "name": "columnWidths",
                    "optional": false,
                    "type": "(number | IObservableValue<number>)[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Delegate that is called when the breakpoint changes.",
                    "name": "onBreakpoint",
                    "optional": false,
                    "type": "(breakpointIndex: number, breakpoint: number) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Tabs/Tabs.Props.d.ts": [
        {
            "description": "",
            "name": "TabSize",
            "properties": [
                {
                    "defaultValue": "\"compact\"",
                    "description": "32px tall with 14px text",
                    "name": "Compact",
                    "type": "string"
                },
                {
                    "defaultValue": "\"tall\"",
                    "description": "48px tall with 14px text",
                    "name": "Tall",
                    "type": "string"
                },
                {
                    "defaultValue": "\"large-link\"",
                    "description": "40px tall with 17px text",
                    "name": "LargeLink",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "Orientation",
            "properties": [
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Horizontal",
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "description": "",
                    "name": "Vertical",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ITabBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, do not apply position: sticky to the tab bar.",
                    "name": "disableSticky",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Non-tabs content to render in the tab bar, such as filterbar, view actions, etc.",
                    "name": "renderAdditionalContent",
                    "optional": true,
                    "type": "() => JSX.Element | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional root classname for the tabs element.",
                    "name": "tabsClassName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITabsProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ITabListProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Header string to render",
                    "name": "listTitle",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Subtitle string to render",
                    "name": "listSubTitle",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Defines the tab groups that tabs can be placed into",
                    "name": "tabGroups",
                    "optional": true,
                    "type": "ITabGroup[]"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITabsProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ITabsProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria-label for the tab group",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional root classname for the tabs element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the selected tab has changed (through click or keyboard)",
                    "name": "onSelectedTabChanged",
                    "optional": false,
                    "type": "(newTabId: string) => void"
                },
                {
                    "defaultValue": " flex-column\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Determines if we'll render as Flex-Row or Flex-Column",
                    "name": "orientation",
                    "optional": true,
                    "type": "Orientation"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The selected tab's id either as a string or a readonly observable value",
                    "name": "selectedTabId",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tab display size",
                    "name": "tabSize",
                    "optional": true,
                    "type": "TabSize"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number to display next to the name of the tab in a badge. If a non-numeric value is desired\r\nin the badge, use the renderBadge prop and pass a <TabBadge /> instead.",
                    "name": "badgeCount",
                    "optional": true,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Matches this Tab to a Group",
                    "name": "groupId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used for aria attributes on tab.\r\nDoes not need to be provided when used in the context of a TabBar or Tabs component",
                    "name": "index",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the tab is appearing as selected.\r\nDoes not need to be provided when used in the context of a TabBar or Tabs component",
                    "name": "isSelected",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the user requests to change to this pivot. If this method return false, the change will be blocked.",
                    "name": "onBeforeTabChange",
                    "optional": true,
                    "type": "(ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | null, tabId: string, url?: string) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Handles click/keydown events on the tab.\r\nDoes not need to be provided when used in the context of a TabBar or Tabs component",
                    "name": "onClick",
                    "optional": true,
                    "type": "(selectedTabId: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to provide custom content in the badge area of a Tab. If the content is simply a number, use badgeCount instead.\r\nIn cases where the Badge should be a standard Pill, but just with text instead of a number, use a TabBadge, like the following:\r\n\r\nrenderBadge={() => <TabBadge>50+</TabBadge>}",
                    "name": "renderBadge",
                    "optional": true,
                    "type": "() => React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used for aria attributes on tab.\r\nDoes not need to be provided when used in the context of a TabBar or Tabs component",
                    "name": "setSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided will use an <a> for the tab as well as allow it to be CTRL-clicked to open in\r\na new browser tab",
                    "name": "url",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISharedTabProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ITabBadgeProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A custom className to add to the underlying <Pill />.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the <Pill /> contains a number.",
                    "name": "containsCount",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If defined, wrap the <Pill /> in a <Tooltip /> with this props.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabGroup",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique identifier for a TabGroup",
                    "name": "id",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Display name",
                    "name": "name",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Ordering: Lower = renders first",
                    "name": "order",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabProviderContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A list of commands that should be rendered in the header.",
                    "name": "commandBarItems",
                    "optional": true,
                    "type": "IHeaderCommandBarItem[] | IReadonlyObservableArray<IHeaderCommandBarItem>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called to render content for the tab",
                    "name": "renderContent",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called to render content for the filter bar",
                    "name": "renderFilterBar",
                    "optional": true,
                    "type": "(inTabBar: boolean) => JSX.Element | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tracks the selected tab id.",
                    "name": "selectedId",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The current list of all provided tabs (not defined directly as children to the Tabs component)",
                    "name": "tabs",
                    "optional": false,
                    "type": "IVssContributedTab[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabGroupProviderContext",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "groups",
                    "optional": false,
                    "type": "ITabGroup[]"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabProviderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "providers",
                    "optional": false,
                    "type": "IReadonlyObservableArray<IVssContributedTab>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tracks the selected tab id.",
                    "name": "selectedTabId",
                    "optional": false,
                    "type": "IReadonlyObservableValue<string> | string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITabGroupProviderProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "providers",
                    "optional": false,
                    "type": "IReadonlyObservableArray<ITabGroup>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IVssContributedTab",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number to display next to the name of the tab in a badge. If a non-numeric value is desired\r\nin the badge, use the renderBadge prop and pass a <TabBadge /> instead.",
                    "name": "badgeCount",
                    "optional": true,
                    "type": "number | IReadonlyObservableValue<number>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A list of commands that should be rendered in the header.",
                    "name": "commandBarItems",
                    "optional": true,
                    "type": "IHeaderCommandBarItem[] | IReadonlyObservableArray<IHeaderCommandBarItem>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, use a fast page switch when switching to this pivot (a url must be supplied by the pivot).",
                    "name": "fpsRequired",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Matches this Tab to a Group",
                    "name": "groupId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the user requests to change to this pivot. If this method return false, the change will be blocked.",
                    "name": "onBeforeTabChange",
                    "optional": true,
                    "type": "(ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | null, tabId: string, url?: string) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to sort tabs. Lower order means the tab will be rendered first. If not provided, defaults to 100",
                    "name": "order",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renders content for the tab",
                    "name": "render",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Used to provide custom content in the badge area of a Tab. If the content is simply a number, use badgeCount instead.\r\nIn cases where the Badge should be a standard Pill, but just with text instead of a number, use a TabBadge, like the following:\r\n\r\nrenderBadge={() => <TabBadge>50+</TabBadge>}",
                    "name": "renderBadge",
                    "optional": true,
                    "type": "() => React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Renders a filter bar - provides a parameter to determine whether or not this render\r\nis taking place in the tab bar or in the content",
                    "name": "renderFilterBar",
                    "optional": true,
                    "type": "(inTabBar: boolean) => JSX.Element | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of the route to use to compute the url for this pivot",
                    "name": "routeId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional route values to use along with the supplied route id when computing this pivot's url",
                    "name": "routeValues",
                    "optional": true,
                    "type": "{ [key: string]: string }"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If provided will use an <a> for the tab as well as allow it to be CTRL-clicked to open in\r\na new browser tab",
                    "name": "url",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ISharedTabProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/TagPicker/TagPicker.Props.d.ts": [
        {
            "description": "",
            "name": "ISelectedTagProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content to show in the pill when selected.",
                    "name": "content",
                    "optional": false,
                    "type": "string | JSX.Element"
                }
            ],
            "externalTypes": [
                {
                    "name": "IPillProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ITagPickerProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to determine if two tags are identical.",
                    "name": "areTagsEqual",
                    "optional": false,
                    "type": "(first: T, second: T) => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id of another element which labels this one for screen reader users.\r\nDefaults to FormItem's label if this TagPicker is used within.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class added to the tag picker.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback which converts one of the tag items to a pill.",
                    "name": "convertItemToPill",
                    "optional": false,
                    "type": "(item: T, index: number) => ISelectedTagProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to create a default item from a search string.",
                    "name": "createDefaultItem",
                    "optional": true,
                    "type": "(searchString: string) => T | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String used to break apart a search string. If this is set, you should also define onDelimitedSearch\r\nto handle input where the user has pasted in several items delimited",
                    "name": "deliminator",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show when the search does not show any suggestions",
                    "name": "noResultsFoundText",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when focus has entered the TagPicker input field.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when focus has left the TagPicker.\r\n@param text text value of the tag pick before focusing away",
                    "name": "onBlur",
                    "optional": true,
                    "type": "(text?: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the user has typed or pasted a string with the deliminator. The callback returns the equivalent of searchString.split(this.props.deliminator)",
                    "name": "onDelimitedSearch",
                    "optional": true,
                    "type": "(strings: string[]) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the user clicks or focuses on an empty text field. This can be used to show an MRU list",
                    "name": "onEmptyInputFocus",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the right arrow key is pressed inside the tag picker.",
                    "name": "onSuggestionExpanded",
                    "optional": true,
                    "type": "(tag: T) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the text value of the input tag has changed. This callback should change the suggestions and suggestionsLoading values appropriately.",
                    "name": "onSearchChanged",
                    "optional": false,
                    "type": "(searchValue: string) => void"
                },
                {
                    "defaultValue": " 250\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number in milliseconds that determines how long to debounce the supplied onSearchChanged or onDelimitedSearch function for.",
                    "name": "onSearchChangedDebounceWait",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when a tag is chosen. Unless the tag is not valid, the consumer should update the suggestions list.",
                    "name": "onTagAdded",
                    "optional": false,
                    "type": "(tag: T) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when a tag is removed. Unless the tag is not valid, the consumer should update the suggestions list.",
                    "name": "onTagRemoved",
                    "optional": false,
                    "type": "(tag: T) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when a group of tags is removed. Unless the tag is not valid, the consumer should update the suggestions list. If this is not\r\nspecified, then the user cannot select multiple tags for deletion.",
                    "name": "onTagsRemoved",
                    "optional": true,
                    "type": "(tags: T[]) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder text to show when the input has no text and there are no selected tags",
                    "name": "placeholderText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Icon props to show at the beginning of the picker control when there is nothing selected",
                    "name": "prefixIconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback to render the suggestion row for a given suggestion.",
                    "name": "renderSuggestionItem",
                    "optional": false,
                    "type": "(itemProps: ISuggestionItemProps<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of tags currently selected by the user. This prop is 100% controlled\r\nby the consumer. onTagAdded/onTagRemoved/onTagsRemoved must also be implemented in order to\r\nwork properly. If this value is a an item, the prop must be\r\nupdated to cause the Tag Picker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the Tag Picker\r\nto re-render.",
                    "name": "selectedTags",
                    "optional": false,
                    "type": "IReadonlyObservableArray<T> | T[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Function to determine if blur should clear the textfield and close the suggestions list",
                    "name": "shouldBlurClear",
                    "optional": true,
                    "type": "() => boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of suggestions for the given search value. This prop is 100% controlled\r\nby the consumer. onSearchChanged must also be implemented in order to\r\nwork properly. If this value is a an item, the prop must be\r\nupdated to cause the Tag Picker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the Tag Picker\r\nto re-render.",
                    "name": "suggestions",
                    "optional": false,
                    "type": "IReadonlyObservableArray<T> | T[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "boolean indicating if the control is waiting to generate its suggestions list. This prop is 100% controlled\r\nby the consumer. onSearchChanged must also be implemented in order to\r\nwork properly. If this value is a an T, the prop must be\r\nupdated to cause the Tag Picker to re-render. If this value is an\r\nObservableValue, then changing its value will cause the Tag Picker",
                    "name": "suggestionsLoading",
                    "optional": false,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "String to show when results are loading",
                    "name": "suggestionsLoadingText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label of the suggestions container",
                    "name": "suggestionsContainerAriaLabel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TeachingBubble/TeachingBubble.Props.d.ts": [
        {
            "description": "",
            "name": "ITeachingBubble",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "dismiss",
                    "optional": false,
                    "type": "() => void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITeachingBubbleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional image to render in the teaching bubble",
                    "name": "imageProps",
                    "optional": true,
                    "type": "IImageProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional button to render in the teaching bubble",
                    "name": "primaryButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Second optional button to render in the teaching bubble.",
                    "name": "secondaryButtonProps",
                    "optional": true,
                    "type": "IButtonProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Body to be rendered in the bubble",
                    "name": "text",
                    "optional": false,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A title to be rendered for the bubble",
                    "name": "title",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ICustomTeachingBubbleProps"
                }
            ]
        },
        {
            "description": "",
            "name": "ICustomTeachingBubbleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The element the teaching bubble is positioned relative to.",
                    "name": "anchorElement",
                    "optional": false,
                    "type": "HTMLElement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When an anchorElement is supplied the anchorOrigin is used to describe the\r\nrelative location of the callout with respect to the anchorElement.",
                    "name": "anchorOrigin",
                    "optional": false,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-describedby for the teaching bubble",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-label for the teaching bubble",
                    "name": "ariaLabeledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " vertical\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "How the bubble should be aligned if the anchor origin is a corner",
                    "name": "cornerPlacement",
                    "optional": true,
                    "type": "TeachingBubbleCornerPlacement"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When the teaching bubble is mounted, what will be the element inside that gets focus.",
                    "name": "defaultActiveElement",
                    "optional": true,
                    "type": "string | (() => string)"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback for when the teaching bubble is dismissed. The owner should be responsible for hiding the teaching bubble.",
                    "name": "onDismiss",
                    "optional": false,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when a teaching bubble changes postion upon changing the anchor element or anchor origin.",
                    "name": "onLocationChange",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Is the teachign bubble only text? This will cause the callout to have light dismiss behavior.",
                    "name": "textOnly",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "TeachingBubbleCornerPlacement",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "If the anchor origin is a corner, the bubble will be positioned to the right/left of the element",
                    "name": "horizontal",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "If the anchor origin is a corner, the bubble will be positioned above/below the element",
                    "name": "vertical",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        }
    ],
    "azure-devops-ui/Components/TeachingPanel/TeachingPanel.Props.d.ts": [
        {
            "description": "",
            "name": "ITeachingSlideProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Title of the slide",
                    "name": "title",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Description of the slide.",
                    "name": "description",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Url path for the image to show.",
                    "name": "slideImage",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Alt text to describe the slide image.",
                    "name": "imageAltText",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITeachingPanelProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "List of slides to show.",
                    "name": "slides",
                    "optional": false,
                    "type": "ITeachingSlideProps[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback when the panel is dismissed with the index of the slide that was shown when the panel was dismissed.",
                    "name": "onDismiss",
                    "optional": true,
                    "type": "(slideIndex: number) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Content class name for teaching panel",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TextField/TextField.Props.d.ts": [
        {
            "description": "",
            "name": "TextFieldStyle",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Rendered closer to a typical <input />",
                    "name": "normal",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "Rendered with no border and a non-white background",
                    "name": "inline",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "TextFieldFocusTreatmentBehavior",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "Focus treatment will appear when the TextField has focus via mouse or keyboard",
                    "name": "all",
                    "type": "number"
                },
                {
                    "defaultValue": "1",
                    "description": "Focus treatment will only appear when the TextField has focus via keyboard",
                    "name": "keyboardOnly",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "Focus treatment will never appear (used within FilterBar)",
                    "name": "none",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "TextFieldWidth",
            "properties": [
                {
                    "defaultValue": "\"auto\"",
                    "description": "No width property is added to the TextField, it will grow to fill its container.",
                    "name": "auto",
                    "type": "string"
                },
                {
                    "defaultValue": "\"bolt-textfield-default-width\"",
                    "description": "A standard width of 296px is set for the TextField",
                    "name": "standard",
                    "type": "string"
                },
                {
                    "defaultValue": "\"bolt-textfield-inline-tabbar-width\"",
                    "description": "Width for the TextField when it is used inline within a TabBar",
                    "name": "tabBar",
                    "type": "string"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "ITextField",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Gets the end position or offset of a text selection.",
                    "name": "readonly selectionEnd",
                    "optional": false,
                    "type": "number | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Gets the starting position or offset of a text selection.",
                    "name": "readonly selectionStart",
                    "optional": false,
                    "type": "number | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets focus on the TextField if it's currently mounted",
                    "name": "focus",
                    "optional": false,
                    "type": "(): void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Selects content in the text field.",
                    "name": "select",
                    "optional": false,
                    "type": "(): void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the currently selected values in the TextField if it's currently mounted",
                    "name": "setSelectionRange",
                    "optional": false,
                    "type": "(start: number, end: number, direction?: \"forward\" | \"backward\" | \"none\" | undefined): void"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITextFieldProps",
            "properties": [
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the input can be activated. Text will not be selectable and a cursor: pointer\r\nwill be used.",
                    "name": "activatable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-activedescendant on the input/textfield.",
                    "name": "ariaActiveDescendant",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-autocomplete on the input/textfield.",
                    "name": "ariaAutoComplete",
                    "optional": true,
                    "type": "\"none\" | \"list\" | \"inline\" | \"both\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-controls on the input/textfield.",
                    "name": "ariaControls",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-describedby on the input/textfield.",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-expanded on the input/textfield.",
                    "name": "ariaExpanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-hasPopup on the input/textfield.",
                    "name": "ariaHasPopup",
                    "optional": true,
                    "type": "boolean | \"menu\" | \"listbox\" | \"tree\" | \"grid\" | \"dialog\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-invalid on the input/textfield.",
                    "name": "ariaInvalid",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-label on the input/textfield.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-labelledby on the input/textfield.",
                    "name": "ariaLabelledBy",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-roledescription on the input/textfield.",
                    "name": "ariaRoleDescription",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Adjust the textfield height as the contents change.",
                    "name": "autoAdjustHeight",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Should the input tag have autocomplete enabled. Ignored if multiline is set to true.",
                    "name": "autoComplete",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "autoFocus on the input/textfield.",
                    "name": "autoFocus",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Supply autoSelect to select all the text in the input when the textfield gets\r\nfocus. This is useful if you want the user to copy the text, or replace the text\r\nupon typing instead of changing the current value.",
                    "name": "autoSelect",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Classname passed to the TextField.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ClassName to pass to the element containing the TextField and description.",
                    "name": "containerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates that the element is disabled - influences styling,\r\naria-disabled, and disabled on the input/textarea.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the textfield to be tabbable.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " TextFieldFocusTreatmentBehavior.all\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Indicates how we should apply the focus treatment to the\r\nTextField. Default is to show the focus treatment when focused via keyboard or mouse.\r\nTextFields that do not wish to have focus treatment (e.g. in the filter bar) should use \"none\"",
                    "name": "focusTreatment",
                    "optional": true,
                    "type": "TextFieldFocusTreatmentBehavior"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Classname passed to the input/textarea element.",
                    "name": "inputClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ref to get passed to the input element.",
                    "name": "inputElement",
                    "optional": true,
                    "type": "React.RefObject<HTMLTextAreaElement & HTMLInputElement>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Id to pass to the input element.",
                    "name": "inputId",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " text\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Type that is passed to the <input> element, e.g. password, number, etc.\r\nSee https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types for a full list",
                    "name": "inputType",
                    "optional": true,
                    "type": "\"password\" | \"text\" | \"button\" | \"number\""
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Label to be rendered before the TextField. Will be wrapped in a\r\n<label> element and wired up with the appropriate aria attributes.",
                    "name": "label",
                    "optional": true,
                    "type": "React.ReactNode"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "MaxLength on the input/textarea.",
                    "name": "maxLength",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum width in px that the textfield will grow to.",
                    "name": "maxWidth",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, uses a textarea instead of an input element.",
                    "name": "multiline",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder on the input/textarea.",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props for the icon to be rendered before the input/textarea.",
                    "name": "prefixIconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the TextField should be read-only.",
                    "name": "readOnly",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true, the input element will be marked as required and an asterisk will be appended to the label.",
                    "name": "required",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true if the TextField is multiline.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the text area should be resizable. Only used if multiline is true.",
                    "name": "resizable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role to use in the TextField.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number of rows the text area should have. Only used if multiline is set to true.",
                    "name": "rows",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the character counter against the limit in the lower right corner should be displayed.\r\nOnly used if maxLength is provided.",
                    "name": "showCharacterCounter",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " undefined which will default to the browser's default for the input and textarea tags.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true or false, overrides the default spellCheck behavior of the browser.",
                    "name": "spellCheck",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " TextFieldStyle.normal\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Changes visual appearance of TextField. Use TextFieldStyle.inline to style as an inline text field.",
                    "name": "style",
                    "optional": true,
                    "type": "TextFieldStyle"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props for the icon to be rendered after the input/textarea.",
                    "name": "suffixIconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the tabindex on the input/textarea element.",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text value of the input/textarea. This prop is 100% controlled\r\nby the consumer. onChange must also be implemented in order to\r\nwork properly. If this value is a raw string, the prop must be\r\nupdated to cause the TextField to re-render. If this value is an\r\nObservableValue, then changing its value will cause the TextField\r\nto re-render.",
                    "name": "value",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string | undefined> | string"
                },
                {
                    "defaultValue": " auto\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Sets the width of the TextField.",
                    "name": "width",
                    "optional": true,
                    "type": "TextFieldWidth"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when blur event is fired by the input/textarea.",
                    "name": "onBlur",
                    "optional": true,
                    "type": "() => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the value of the input/textarea changes.",
                    "name": "onChange",
                    "optional": true,
                    "type": "(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the element is clicked.",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the focus event is fired by the input/textarea.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the key down event is fired by the input/textarea.",
                    "name": "onKeyDown",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the key press event is fired by the input/textarea.",
                    "name": "onKeyPress",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the key press event is fired by the input/textarea.",
                    "name": "onKeyUp",
                    "optional": true,
                    "type": "(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Called when the paste event is fired by the input/textarea.",
                    "name": "onPaste",
                    "optional": true,
                    "type": "(event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tooltip to show when the button is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITextFieldWithMessageProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Classname passed to the root element of the component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional message to display with the textfield",
                    "name": "message",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Classname passed to the element containing the message",
                    "name": "messageClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props provided to the TextField rendered by this component",
                    "name": "textFieldProps",
                    "optional": false,
                    "type": "ITextFieldProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Whether or not the message is considered an error message - will add\r\nappropriate classNames to TextField, message, as well as aria properties.",
                    "name": "error",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TextFilterBarItem/TextFilterBarItem.Props.d.ts": [
        {
            "description": "",
            "name": "ITextFilterBarProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to use for the FilterBarItem",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Show a clear button when the TextField has a value that resets the value to empty.",
                    "name": "clearable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional className to use for the TextFilterBarItem's input element",
                    "name": "inputClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder text for the TextField",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maxLength property to be passed to the input in the TextField.\r\nDefault value is 200 characters.",
                    "name": "maxTextLength",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Only fire onChange when the Enter key is pressed instead of defaulting to throttle timing.",
                    "name": "onlyChangeOnEnter",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " TextFieldStyle.normal\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Changes visual appearance of TextField. Use TextFieldStyle.inline to style as an inline text field.",
                    "name": "style",
                    "optional": true,
                    "type": "TextFieldStyle"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The throttle wait time to use when updating the filter. The text field\r\nwill still update on every keystroke, but the updating the filter\r\nitself will be throttled by this amount. The default value is 200 ms.\r\nPassing a value of 0 here will cause this text field not to be throttled.",
                    "name": "throttleWait",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " TextFieldWidth.auto\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Changes visual appearance of TextField. Use TextFieldWidth.standard to get the standard text field width.",
                    "name": "width",
                    "optional": true,
                    "type": "TextFieldWidth"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-label for the input box. If not set, it defaults to the placeholder",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFilterBarItemProps"
                }
            ]
        },
        {
            "description": "",
            "name": "IInlineKeywordFilterBarItemProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The filter store that this filter bar updates (optional, the parent FilterBar's filter is used by default)",
                    "name": "filter",
                    "optional": true,
                    "type": "IFilter"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The unique key for this filter item whose value is updated by changes to this filter item.",
                    "name": "filterItemKey",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maxLength property to be passed to the input in the TextField.\r\nDefault value is 200 characters.",
                    "name": "maxTextLength",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Placeholder text for the TextField",
                    "name": "placeholder",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITextFilterBarProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/Time/Ago/Ago.Props.d.ts": [
        {
            "description": "",
            "name": "IAgoProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Assitional label for ago. First part of the label is the ago value itself.\r\nDefaults to the content of the base tooltip.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom className applied to pass to the <Time> component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The date object for which Duration string is required.",
                    "name": "date",
                    "optional": false,
                    "type": "Date"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The format in which Duration string is required (default compact).",
                    "name": "format",
                    "optional": true,
                    "type": "AgoFormat"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tabIndex for Ago",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tooltip props that, if provided, will override the standard tooltip built\r\nby the component based on the start time.\r\nIf no tooltip is desired, pass null.\r\nIf the standard tooltip is desired, don't use this prop or pass undefined.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Locale for Ago",
                    "name": "locale",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Current date to compare date with",
                    "name": "currentDate",
                    "optional": true,
                    "type": "Date"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Time format for tooltip to override default date format",
                    "name": "tooltipTimeFormat",
                    "optional": true,
                    "type": "Intl.DateTimeFormatOptions"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Time/Duration/Duration.Props.d.ts": [
        {
            "description": "",
            "name": "IDurationProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-hidden",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Addtional label for the duration. First part of the label is duration itself.\r\nDefaults to the content of the base tooltip.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom className applied to pass to the <Time> component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The end date object for which Duration string is required.",
                    "name": "endDate",
                    "optional": true,
                    "type": "Date"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The start date object for which Duration string is required.",
                    "name": "startDate",
                    "optional": false,
                    "type": "Date"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tabIndex for ago",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Tooltip props that, if provided, will override the standard tooltip built\r\nby the component based on the start time.\r\nIf no tooltip is desired, pass null.\r\nIf the standard tooltip is desired, don't use this prop or pass undefined.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps | null"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Time/Time/Time.Props.d.ts": [
        {
            "description": "",
            "name": "ITimeProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional aria-hidden",
                    "name": "ariaHidden",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Addtional label for the time. First part of the label is the datetime.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Custom className applied to the <time> or <span> element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The date time that will be machine readable.",
                    "name": "dateTime",
                    "optional": true,
                    "type": "Date"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Reference to the function which returns time interval before next refresh.",
                    "name": "getNextInterval",
                    "optional": false,
                    "type": "() => number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The reference to function which returns a string to display.",
                    "name": "getTimeString",
                    "optional": false,
                    "type": "() => string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tabIndex for time",
                    "name": "tabIndex",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The tool tip to be displayed.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps | null"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Toast/Toast.Props.d.ts": [
        {
            "description": "",
            "name": "IToast",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "fadeOut",
                    "optional": false,
                    "type": "(): ICancelablePromise<void>"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IToastProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional text for the Call to Action",
                    "name": "callToAction",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name for the root toast element",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Message to display on the Toast",
                    "name": "message",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional handler for when the Call to Action is clicked",
                    "name": "onCallToActionClick",
                    "optional": true,
                    "type": "(event?: React.MouseEvent<HTMLButtonElement>) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/Toggle/Toggle.Props.d.ts": [
        {
            "description": "",
            "name": "IToggleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria Label for the Toggle for screen reader users.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label when checked is true.",
                    "name": "onAriaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria label when checked is false.",
                    "name": "offAriaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The checked state of the toggle.",
                    "name": "checked",
                    "optional": true,
                    "type": "IReadonlyObservableValue<boolean> | boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional class name to add to the toggle element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, the toggle cannot be interacted with.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true if you don't want the toggle's focus managed by a FocusZone.",
                    "name": "excludeFocusZone",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to omit setting the tab index to 0.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id to add to the toggle element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display when the toggle is unchecked.",
                    "name": "offText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display when toggle is checked.",
                    "name": "onText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " switch\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Aria role of the toggle element.",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to display next to the toggle regardless of checked state.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional tooltip to show when the radio button is hovered.",
                    "name": "tooltipProps",
                    "optional": true,
                    "type": "ITooltipProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "An optional callback to handle click and keyboard events.",
                    "name": "onChange",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, checked: boolean) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-describedby id to use for the component",
                    "name": "ariaDescribedBy",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TooltipEx/Tooltip.Props.d.ts": [
        {
            "description": "",
            "name": "ITooltipProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When true, will add the aria-describedby attribute to the child using the\r\ngetSafeId value of the tooltip id.",
                    "name": "addAriaDescribedBy",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "anchorOffset is used to shift the location of the callout from the defined\r\nlocation by a fixed amount. An example might be the tooltip callout defaults\r\nto an anchorOffset of { x: 8 y: 8 } from the mouse position.",
                    "name": "anchorOffset",
                    "optional": true,
                    "type": "IOffset"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When an anchorElement is supplied the anchorOrigin is used to describe the\r\nrelative location of the callout with respect to the anchorElement.",
                    "name": "anchorOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the tooltip.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": " 250\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When the tooltip shows up it is delayed by delayMs. This prevents the tooltip\r\nfrom blinking when the mouse goes over an element but doesnt hover for long\r\nenough. The default is 250ms.",
                    "name": "delayMs",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the tooltip is marked disabled it wont be shown on its normal show condition\r\nlike hover or focus.",
                    "name": "disabled",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "fixedLayout is used to determine whether or not the callout should be moved\r\nbased on visibility. if fixedLayout is set to true the callout wont be moved.",
                    "name": "fixedLayout",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional id for the tooltip container element.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Pass to use a custom function to check for overflow.  By default, the anchorElement's\r\nscroll width is compared to the its offset width.",
                    "name": "overflowDetected",
                    "optional": true,
                    "type": "(anchorElement: HTMLElement) => boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Only show the tooltip if the contained element is larger than the element it\r\nis housed in. This is designed to help with showing the full text when an\r\nellipsis it used to clip the text.",
                    "name": "overflowOnly",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Show the tooltip when the tooltip's children get focus. The component MUST be\r\ngiven content to show and not use the innerText that comes from overflowOnly.",
                    "name": "showOnFocus",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to show when the tooltip is shown.",
                    "name": "text",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "tooltipOrigin works in conjunction with the other position styles;\r\nanchorElement, anchorOffset, anchorOrigin. After determining the location\r\nbased on the anchor properties the position of the tooltip is applied.",
                    "name": "tooltipOrigin",
                    "optional": true,
                    "type": "IOrigin"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderContent can be used to render custom HTML inside the tooltip.\r\n\r\nNOTE: This shouldn't be used to create a custom Callout, use the Callout\r\ncomponent, this should be used for helping users understand the details\r\nabout a component on the page.",
                    "name": "renderContent",
                    "optional": true,
                    "type": "() => React.ReactNode"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TreeEx/FixedHeightTree.Props.d.ts": [
        {
            "description": "",
            "name": "IFixedHeightTree<T>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "IFixedHeightList<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightTreeRowDetails<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The data represents the object being rendered in this row. If the caller\r\nhas asynchronous loading of rows, the data MAY be undefined while we wait\r\nfor the data to be resolved.",
                    "name": "data",
                    "optional": false,
                    "type": "ITreeItemEx<T>"
                }
            ],
            "externalTypes": [
                {
                    "name": "IFixedHeightListItemDetails<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "IFixedHeightTreeProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the tree root element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller can supply an EventDispatch to the tree if it wishes to\r\nparticipate it extending the behaviors. If one isn't supplied the tree will\r\ncreate its own dispatcher when behaviors are supplied.",
                    "name": "eventDispatch",
                    "optional": true,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the tree rows are focused.\r\nThe default focuszone if one isn't supplied is a Vertical non-cyclic focus zone.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this tree.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe ITreeItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the tree a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.\r\n\r\nThere is simple TreeItemProvider<T> for those that just have a set of items\r\nthey want to supply without writing a custom ItemProvider.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<ITreeItemEx<T> | IReadonlyObservableValue<ITreeItemEx<T>>>"
                },
                {
                    "defaultValue": " 1000000\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum height of the table when virtualized. Browsers have issues\r\nrendering elements that are too large and when the List contains thousands\r\nof elements, the list renders very large spacer elements to correctly\r\nposition the scroll bar. The large spacer elements cause rendering issues\r\nacross browsers. To bypass this, we need to limit how large the list can\r\ngrow to. By default this size is 1,000,000px. However, if you have multiple\r\nitems within a scrollable region, this number might need to be reduced.\r\nFor instance, if you have 5 lists that can contain a lot of rows in the\r\nsame scrollable region, you would likely want to set the max height for\r\neach list to 200,000. Keep in mind that the smaller this number, the harder\r\nit will be for a user to scroll with precision.",
                    "name": "maxHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event - This is the event that is causing the activation.\r\n@param treeRow - Details about the tree row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus is called when a item in the list is focused. Preventing default\r\non the focus event will prevent row selection from occuring even if\r\nselectOnFocus is set to true.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param tableRow Details about the list row being activated.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param treeRow - Details about the tree row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onToggle is called when an item is either expanded or collapsed.\r\n\r\n@param event - This is the event that is causing the toggle.\r\n@param treeItem - Details about the tree item being toggled.",
                    "name": "onToggle",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeItem: ITreeItemEx<T>) => void"
                },
                {
                    "defaultValue": " 10\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "pageSize controls the granularity of row rendering. The tree always renders\r\na full page worth of rows even when they are not needed to fill the viewport.\r\n\r\nSmaller values will help reduce the number of wasted rows that are rendered\r\noutside the viewport, but will force the tree to re-render more often as\r\nscrolling occurs.",
                    "name": "pageSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a row's value is given as an ObservableValue with an undefined value,\r\nthe list will render a Loading row for the content. The default will be\r\na shimmer row that is semi random and matches the content.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param details Additional details about this row.",
                    "name": "renderLoadingRow",
                    "optional": true,
                    "type": "(rowIndex: number, details: IFixedHeightTreeRowDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The row that should be rendered in the tree. The resulting div will be placed inside the\r\nFixedHeightList control. Keep in mind any overflow content will be cut off, so consider\r\nthe width and rowHeight values passed in.",
                    "name": "renderRow",
                    "optional": false,
                    "type": "FixedHeightTreeRowRenderer<T>"
                },
                {
                    "defaultValue": " \"tree\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role defines the aria role of the tree and defaults to \"tree\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Required height of each row. Every row in the tree must be this height and all overflow is hidden.\r\nThe FixedHeightList control uses this value to absolutely position elements within it.",
                    "name": "rowHeight",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the tree selection. This\r\nis not required since the tree offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IListSelection that supports multi\r\nselect.\r\n\r\nThere is a basic ListSelection implementation available from the List\r\ncomponent.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " 100%\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Width can be any supported css width value, either a %, px, and vw value.",
                    "name": "width",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TreeEx/Tree.Props.d.ts": [
        {
            "description": "",
            "name": "ITree<T>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "ITable<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITreeColumn<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "hierarchical should be specified for any column that will show the\r\nindentation of the tree expansion.",
                    "name": "hierarchical",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " 16\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number of pixels the indentation will apply for each depth.",
                    "name": "indentationSize",
                    "optional": true,
                    "type": "number"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITableColumn<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITreeRow<T>",
            "properties": [],
            "externalTypes": [
                {
                    "name": "ITableRow<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITreeRowDetails<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The data represents the object being rendered in this row. If the caller\r\nhas asynchronous loading of rows, the data MAY be undefined while we wait\r\nfor the data to be resolved.",
                    "name": "data",
                    "optional": false,
                    "type": "ITreeItemEx<T>"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITableRowDetails<ITreeItemEx<T>>"
                }
            ]
        },
        {
            "description": "",
            "name": "ITreeProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ariaLabel allows the caller to describe the elements contents to assistive\r\ntechnology.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Behaviors can be added to the tree and monitor events and interact with the\r\ncomponent through the ITree methods.",
                    "name": "behaviors",
                    "optional": true,
                    "type": "IBehavior<Partial<ITreeProps<ITreeItemEx<T>>>, Partial<ITree<T>>>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "columns is a required property of a tree used to define the column layout\r\nfor the tree.",
                    "name": "columns",
                    "optional": false,
                    "type": "ITreeColumn<T>[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the tree root element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "CSS className to add to the container element.",
                    "name": "containerClassName",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller can supply an EventDispatch to the tree if it wishes to\r\nparticipate it extending the behaviors. If one isn't supplied the tree will\r\ncreate its own dispatcher when behaviors are supplied.",
                    "name": "eventDispatch",
                    "optional": true,
                    "type": "IEventDispatch"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "focuszoneProps allows the caller to manage the how the tree rows are focused.\r\nThe default focuszone if one isn't supplied is a Vertical non-cyclic focus zone.",
                    "name": "focuszoneProps",
                    "optional": true,
                    "type": "IFocusZoneProps | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Unique Id for this tree.",
                    "name": "id",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The caller MUST supply the set of items to be shown through the ItemProvider.\r\nThe ITreeItemProvider allows the caller to store their items in the form that\r\nbests suits their needs but gives the tree a well defined interface for\r\nrequesting the items. This can include async fetching of items through\r\nobservables.\r\n\r\nThere is simple TreeItemProvider<T> for those that just have a set of items\r\nthey want to supply without writing a custom ItemProvider.",
                    "name": "itemProvider",
                    "optional": false,
                    "type": "IItemProvider<ITreeItemEx<T> | IReadonlyObservableValue<ITreeItemEx<T>>>"
                },
                {
                    "defaultValue": " 100000\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The maximum height of the table when virtualized. Browsers have issues\r\nrendering elements that are too large and when the List contains thousands\r\nof elements, the list renders very large spacer elements to correctly\r\nposition the scroll bar. The large spacer elements cause rendering issues\r\nacross browsers. To bypass this, we need to limit how large the list can\r\ngrow to. By default this size is 100,000px. However, if you have multiple\r\nitems within a scrollable region, this number might need to be reduced.\r\nFor instance, if you have 5 lists that can contain a lot of rows in the\r\nsame scrollable region, you would likely want to set the max height for\r\neach list to 20,000. Keep in mind that the smaller this number, the harder\r\nit will be for a user to scroll with precision.",
                    "name": "maxHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onActivate is called when the row is activated. Activation occurs on\r\nthe Enter keystroke or double click.\r\n\r\n@param event - This is the event that is causing the activation.\r\n@param treeRow - Details about the tree row being activated.",
                    "name": "onActivate",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onFocus is called when a item in the list is focused. Preventing default\r\non the focus event will prevent row selection from occuring even if\r\nselectOnFocus is set to true.\r\n\r\n@param event This is the event that is causing the activation.\r\n@param tableRow Details about the list row being activated.",
                    "name": "onFocus",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, listRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onSelect is called when the row is selected. Selection occurs on the\r\nSpace keystroke or click.\r\n\r\n@param event - This is the event that is causing the selection.\r\n@param treeRow - Details about the tree row being selected.",
                    "name": "onSelect",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeRow: ITreeRow<T>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "onToggle is called when an item is either expanded or collapsed.\r\n\r\n@param event - This is the event that is causing the toggle.\r\n@param treeItem - Details about the tree item being toggled.",
                    "name": "onToggle",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLElement>, treeItem: ITreeItemEx<T>) => void"
                },
                {
                    "defaultValue": " 10\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "pageSize controls the granularity of row rendering. The tree always renders\r\na full page worth of rows even when they are not needed to fill the viewport.\r\n\r\nSmaller values will help reduce the number of wasted rows that are rendered\r\noutside the viewport, but will force the tree to re-render more often as\r\nscrolling occurs.",
                    "name": "pageSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Trees MAY render a header above the tree contents. This is done through the\r\nonRenderHeader. Like the renderRow method, there are set of restrictions the\r\nimplmentation MUST follow.\r\n\r\nRequirements:\r\n\r\n1) The header function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The header function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.",
                    "name": "renderHeader",
                    "optional": true,
                    "type": "(columns: ITreeColumn<T>[]) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When a row's value is given as an ObservableValue with an undefined value,\r\nthe list will render a Loading row for the content. The default will be\r\na shimmer row that is semi random and matches the content.\r\n\r\n@param index This is the 0 based row index that should be rendered.\r\n@param details Additional details about this row.",
                    "name": "renderLoadingRow",
                    "optional": true,
                    "type": "(rowIndex: number, details: ITreeRowDetails<T>) => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The requirements of this function are quite complicated and before writing\r\na new row renderer you should ensure one doesnt already exist that solves\r\nyour needs.\r\n\r\nRequirements:\r\n\r\n1) The row function MUST return a singlely rooted component that resolves\r\nto single rooted element, or return a single element that is either a <tr>\r\nor another acceptable tag that is marked as a display: table-row.\r\n\r\n2) The row function MUST only include direct child elements that are either\r\n<td>'s or acceptable elements that are maked as display: table-cell. The\r\nrenderer MUST return one element for each defined column even if there is\r\nno data to be rendered in the column.\r\n\r\n3) The row function MUST call onFocusItem when a either the row element of\r\nany of the rows child elements receive the focus. This is needed to ensure\r\nnavigation within the tree as well as in and out of the tree function\r\ncorrectly.\r\n\r\n4) The row function MUST ensure the className for each of the columns is\r\nadded the cell for the given colmn.\r\n\r\n5) The row function MAY dispatch events for behaviors but is not required.\r\nIf any events are dispatched they should be documented on the row renderer.\r\n\r\n6) The row function is responsible for all accessibility and focus\r\nmanagement within the row.",
                    "name": "renderRow",
                    "optional": true,
                    "type": "TreeRowRenderer<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "renderSpacer can be supplied to override the spacer columns before and\r\nafter the actual columns in the table. This is used to apply custom\r\nsemantics to these areas. The standard spacers should be used unless there\r\nis a specific need otherwise.",
                    "name": "renderSpacer",
                    "optional": true,
                    "type": "(rowIndex: number, left: boolean) => React.ReactNode | null"
                },
                {
                    "defaultValue": " \"tree\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "role defines the aria role of the tree and defaults to \"tree\"",
                    "name": "role",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If the caller has variable height rows they can specify the rowHeight they\r\nwant used to estimate the size of virtualized rows. This means that when rows\r\nare not rendered, the component will create virtual space for those rows to\r\nensure the scrolling behavior acts appropriately.\r\n\r\nIf the tree has fixed size rows there is no need to specify a rowHeight. The\r\ntree will determine the height of the rows after the initial render when\r\nthe observer reports on page visibility.\r\n\r\nQuestion: How do I determine the rowHeight if their are variable height rows.\r\nThis one is a tough question, and the general answer is come up with a fair\r\naverage for the rows on a given page. If the select too large or too small\r\nscrolling behaviors can become a bit odd, generally select on the smaller\r\nside if you are unsure.",
                    "name": "rowHeight",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set to true to make the text in the tree rows selectable.",
                    "name": "selectableText",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "scrollable should be set to true if the tree is not contained in a\r\nscrolling element. This will ensure the tree scrolls vertically within\r\nthe tree element itself.",
                    "name": "scrollable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A selection object can be supplied for managing the tree selection. This\r\nis not required since the tree offers onSelect as a delegate. If the caller\r\nwants multi-selction they must use an IListSelection that supports multi\r\nselect.\r\n\r\nThere is a basic ListSelection implementation available from the List\r\ncomponent.",
                    "name": "selection",
                    "optional": true,
                    "type": "IListSelection"
                },
                {
                    "defaultValue": " true if columns are supplied.\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showHeader determines whether or not the column headers are shown at the top\r\nof the tree.",
                    "name": "showHeader",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showLines determines whether or not lines displayed between rows.",
                    "name": "showLines",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " false\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "showScroll determines whether we allow overflow on the table\r\nif it is false (as in default), we will add scroll-hidden css class to the table",
                    "name": "showScroll",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " true\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Using singleClickActivation will activate the item when the row is clicked.\r\nWhere setting singleClickActivation to false will require a doubleclick to\r\nactivate a given row.",
                    "name": "singleClickActivation",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A tree can be defined with a set of breakpoints. These breakpoints will be\r\nused to control the column layout as the space available to the tree changes.",
                    "name": "tableBreakpoints",
                    "optional": true,
                    "type": "ITableBreakpoint[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If virtualize false is supplied the list will render all the items supplied\r\nto it. This shouldn't be used unless you know you have a limited number of\r\nrows. Virtualization is used to avoid performance problems.",
                    "name": "virtualize",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set true to set the tabIndex of the underlying table to -1 instead of 0.",
                    "name": "excludeTabStop",
                    "optional": true,
                    "type": "boolean"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "ITreeRowProps<T>",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "css class names to add to the row element.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Details about the row being rendered.",
                    "name": "details",
                    "optional": false,
                    "type": "ITreeRowDetails<T>"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "This is the 0 based row index.",
                    "name": "index",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": true,
                    "deprecatedMessage": " Please include links within the content itself. Rows rendered as links are inaccessible and support for them will be removed in future versions. ",
                    "description": "",
                    "name": "linkProps",
                    "optional": true,
                    "type": "IAnchorProps"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TreeEx/TreeExpand.Props.d.ts": [
        {
            "description": "",
            "name": "ITreeExpandProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional CSS className to apply to the item.",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The depth determines how much space appears to the left of the expander.\r\nThe space is defined as depth * indentationSize.",
                    "name": "depth",
                    "optional": false,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Defines whether or not the item is currently expanded or not.",
                    "name": "expanded",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": " \"ChevronRight\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The iconName for the collapsed state.",
                    "name": "iconCollapsedProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": " \"ChevronDown\"\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The iconName for the expanded state.",
                    "name": "iconExpandedProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": " 16\r",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Number of pixels the indentation will apply for each depth.",
                    "name": "indentationSize",
                    "optional": true,
                    "type": "number"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "When the user clicks on the tree expand. This allows the override the\r\nclick behavior without requiring another element.",
                    "name": "onClick",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Method that will be called when the expander is toggled. If no toggle\r\nmehod is supplied the expander will be drawn but will be invisible.",
                    "name": "onToggle",
                    "optional": true,
                    "type": "(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/TypeAhead/TypeAhead.Props.d.ts": [
        {
            "description": "",
            "name": "ITypeAheadProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Handles AutoComplete input (tab)",
                    "name": "onAutoComplete",
                    "optional": true,
                    "type": "(suggestedValue: string) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Suggested value to display and tab-complete",
                    "name": "suggestedValue",
                    "optional": true,
                    "type": "IReadonlyObservableValue<string> | string"
                }
            ],
            "externalTypes": [
                {
                    "name": "ITextFieldProps"
                }
            ]
        }
    ],
    "azure-devops-ui/Components/VssPersona/VssPersona.Props.d.ts": [
        {
            "description": "",
            "name": "IIdentityDetailsProvider",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Return a URL to a profile image suitable for display at size pixels.",
                    "name": "getIdentityImageUrl",
                    "optional": false,
                    "type": "(size: number): string | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Gets the user's displayname.",
                    "name": "getDisplayName",
                    "optional": false,
                    "type": "(): string | undefined"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "(optional) Render an element to display on delayed hover of the VssPersona\r\ne.g. a profile card or tooltip containing the full display name",
                    "name": "onRenderPersonaCard",
                    "optional": true,
                    "type": "(image: HTMLElement, onDismiss: () => void): JSX.Element"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IVssPersonaProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "aria-label to be used for the VssPersona. If this prop is undefined, the component will automatically include an aria-label\r\nbased on the display name. A value of null indicates that no ariaLabel should be added. The use case for this is a situation\r\nwhere the display name is also in the DOM - which could cause screen readers to read the name multiple times.",
                    "name": "ariaLabel",
                    "optional": true,
                    "type": "string | null"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "",
                    "name": "cssClass",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Size of image to display. Use VssPersonaSize presets.",
                    "name": "size",
                    "optional": true,
                    "type": "VssPersonaSize"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Provides information about an identity.",
                    "name": "identityDetailsProvider",
                    "optional": true,
                    "type": "IIdentityDetailsProvider"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "If true, do not show persona card on hover",
                    "name": "suppressPersonaCard",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set when VssPersona is within a focus zone",
                    "name": "dataIsFocusable",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Set when VssPersona is a tab stop but not in focus zone",
                    "name": "isTabStop",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Alternate text for VSSPersona image to display when image load does not succeed",
                    "name": "imgAltText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback on image load error",
                    "name": "onImageError",
                    "optional": true,
                    "type": "(event: React.SyntheticEvent<HTMLImageElement>) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional callback on image load error",
                    "name": "showInitialsOnImageError",
                    "optional": true,
                    "type": "boolean"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, if provided the image url for the Icon. Used if identityDetailsProvider is not set",
                    "name": "imageUrl",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Optional, if provided the name to generate the tooltip and initials to use for the persona coin. Used if identityDetailsProvider is not set",
                    "name": "displayName",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ],
    "azure-devops-ui/Components/ZeroData/ZeroData.Props.d.ts": [
        {
            "description": "",
            "name": "ZeroDataActionType",
            "properties": [
                {
                    "defaultValue": "0",
                    "description": "",
                    "name": "ctaButton",
                    "type": "number"
                },
                {
                    "defaultValue": "2",
                    "description": "",
                    "name": "link",
                    "type": "number"
                }
            ],
            "externalTypes": [],
            "enum": true
        },
        {
            "description": "",
            "name": "IZeroDataItem",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Path to the image to display.",
                    "name": "imagePath",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Props to pass to the icon to render in place of an image",
                    "name": "iconProps",
                    "optional": true,
                    "type": "IIconProps"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Alt text to set for the image",
                    "name": "imageAltText",
                    "optional": false,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Primary text to display",
                    "name": "primaryText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Secondary text to display",
                    "name": "secondaryText",
                    "optional": true,
                    "type": "string | JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "A function to render an action other than the standard button or link.\r\nIf specified, actionText, actionType, onActionClick, and actionHref will be ignored.",
                    "name": "renderAction",
                    "optional": true,
                    "type": "() => JSX.Element"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Text to put on the button. If not set, no button will be rendered.",
                    "name": "actionText",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "The type of button to render. Default is link.",
                    "name": "actionType",
                    "optional": true,
                    "type": "ZeroDataActionType"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Callback called when the user clicks on the button",
                    "name": "onActionClick",
                    "optional": true,
                    "type": "(ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IZeroDataItem) => void"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "href used for link when actionType is link",
                    "name": "actionHref",
                    "optional": true,
                    "type": "string"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Additional props to pass to the button",
                    "name": "actionButtonProps",
                    "optional": true,
                    "type": "any"
                }
            ],
            "externalTypes": []
        },
        {
            "description": "",
            "name": "IZeroDataProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name for the root component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": [
                {
                    "name": "IZeroDataItem"
                }
            ]
        },
        {
            "description": "",
            "name": "IZeroDataMultipleProps",
            "properties": [
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "ZeroData items to display",
                    "name": "items",
                    "optional": false,
                    "type": "IZeroDataItem[]"
                },
                {
                    "defaultValue": "",
                    "deprecated": false,
                    "deprecatedMessage": "",
                    "description": "Class name for the root component",
                    "name": "className",
                    "optional": true,
                    "type": "string"
                }
            ],
            "externalTypes": []
        }
    ]
};